const data = [
  {
    id: 28211,
    slug: "wise-words",
    title: "Wise words...",
    url: "https://www.betheshyft.com/community/thread/MjgyMTE/wise-words/",
  },
  {
    id: 28065,
    slug: "mind",
    title: "Mind...",
    url: "https://www.betheshyft.com/community/thread/MjgwNjU/mind/",
  },
  {
    id: 27774,
    slug: "simple-meditative-postures-part-3",
    title: "Simple meditative postures part 3",
    url: "https://www.betheshyft.com/community/thread/Mjc3NzQ/simple-meditative-postures-part-3/",
  },
  {
    id: 27751,
    slug: "simple-meditative-postures-part-2",
    title: "Simple meditative postures part 2",
    url: "https://www.betheshyft.com/community/thread/Mjc3NTE/simple-meditative-postures-part-2/",
  },
  {
    id: 27712,
    slug: "does-diet-help-with-erectile-dysfunction-ed",
    title: "Does diet help with Erectile Dysfunction(ED)?! 🤔🧐",
    url: "https://www.betheshyft.com/community/thread/Mjc3MTI/does-diet-help-with-erectile-dysfunction-ed/",
  },
  {
    id: 27698,
    slug: "simple-meditative-postures-series-1",
    title: "Simple meditative postures series 1",
    url: "https://www.betheshyft.com/community/thread/Mjc2OTg/simple-meditative-postures-series-1/",
  },
  {
    id: 27696,
    slug: "how-to-reduce-bloating",
    title: "How to reduce bloating",
    url: "https://www.betheshyft.com/community/thread/Mjc2OTY/how-to-reduce-bloating/",
  },
  {
    id: 27694,
    slug: "how-stress-looks-like",
    title: "How stress looks like",
    url: "https://www.betheshyft.com/community/thread/Mjc2OTQ/how-stress-looks-like/",
  },
  {
    id: 27614,
    slug: "happiness-is",
    title: "Happiness is...",
    url: "https://www.betheshyft.com/community/thread/Mjc2MTQ/happiness-is/",
  },
  {
    id: 27586,
    slug: "4-effective-ways-to-take-care-of-your",
    title:
      "4 effective ways to take care of your health during this festive season 😍❤️",
    url: "https://www.betheshyft.com/community/thread/Mjc1ODY/4-effective-ways-to-take-care-of-your/",
  },
  {
    id: 27516,
    slug: "alignment-for-half-moon-pose",
    title: "Alignment for half moon pose.",
    url: "https://www.betheshyft.com/community/thread/Mjc1MTY/alignment-for-half-moon-pose/",
  },
  {
    id: 27261,
    slug: "self-care-is-productive",
    title: "Self care is Productive!",
    url: "https://www.betheshyft.com/community/thread/MjcyNjE/self-care-is-productive/",
  },
  {
    id: 27258,
    slug: "getting-back-to-form",
    title: "Getting back to form",
    url: "https://www.betheshyft.com/community/thread/MjcyNTg/getting-back-to-form/",
  },
  {
    id: 27257,
    slug: "let-s-keep-on-working-to-improve-our",
    title: "Let's keep on working to improve our health!",
    url: "https://www.betheshyft.com/community/thread/MjcyNTc/let-s-keep-on-working-to-improve-our/",
  },
  {
    id: 27224,
    slug: "difference-between-probiotic-and-prebiotic",
    title: "Difference between probiotic and prebiotic",
    url: "https://www.betheshyft.com/community/thread/MjcyMjQ/difference-between-probiotic-and-prebiotic/",
  },
  {
    id: 27223,
    slug: "for-healthy-gut",
    title: "For healthy gut",
    url: "https://www.betheshyft.com/community/thread/MjcyMjM/for-healthy-gut/",
  },
  {
    id: 27190,
    slug: "building-strength",
    title: "Building strength",
    url: "https://www.betheshyft.com/community/thread/MjcxOTA/building-strength/",
  },
  {
    id: 27128,
    slug: "spinal-mobility",
    title: "Spinal Mobility",
    url: "https://www.betheshyft.com/community/thread/MjcxMjg/spinal-mobility/",
  },
  {
    id: 27035,
    slug: "experiencing-some-of-the-symptoms-in-the-chart",
    title: "Experiencing some of the symptoms in the chart?",
    url: "https://www.betheshyft.com/community/thread/MjcwMzU/experiencing-some-of-the-symptoms-in-the-chart/",
  },
  {
    id: 26963,
    slug: "diet-impacts-skin-we-know-what-exactly-boosts",
    title: "Diet impacts skin. We know. What exactly boosts collagen?",
    url: "https://www.betheshyft.com/community/thread/MjY5NjM/diet-impacts-skin-we-know-what-exactly-boosts/",
  },
  {
    id: 26922,
    slug: "humanity-is-greater-than-status",
    title: "Humanity is greater than status!",
    url: "https://www.betheshyft.com/community/thread/MjY5MjI/humanity-is-greater-than-status/",
  },
  {
    id: 26856,
    slug: "building-up-strength-flexibility-in-a-balanced-way",
    title: "Building up strength  & flexibility in a balanced way..",
    url: "https://www.betheshyft.com/community/thread/MjY4NTY/building-up-strength-flexibility-in-a-balanced-way/",
  },
  {
    id: 26855,
    slug: "picture-that-will-make-you-smile",
    title: "Picture that will make you smile 😊",
    url: "https://www.betheshyft.com/community/thread/MjY4NTU/picture-that-will-make-you-smile/",
  },
  {
    id: 26724,
    slug: "change-your-habits-and-the-results-would-change",
    title: "Change your habits and the results would change...",
    url: "https://www.betheshyft.com/community/thread/MjY3MjQ/change-your-habits-and-the-results-would-change/",
  },
  {
    id: 26691,
    slug: "happy-monday",
    title: "Happy Monday!",
    url: "https://www.betheshyft.com/community/thread/MjY2OTE/happy-monday/",
  },
  {
    id: 26673,
    slug: "mental-health-check-in",
    title: "Mental health check in",
    url: "https://www.betheshyft.com/community/thread/MjY2NzM/mental-health-check-in/",
  },
  {
    id: 26630,
    slug: "poses-for-thyroid",
    title: "Poses for thyroid",
    url: "https://www.betheshyft.com/community/thread/MjY2MzA/poses-for-thyroid/",
  },
  {
    id: 26624,
    slug: "combat-insulin-resistance",
    title: "Combat insulin resistance",
    url: "https://www.betheshyft.com/community/thread/MjY2MjQ/combat-insulin-resistance/",
  },
  {
    id: 26623,
    slug: "insulin-resistance",
    title: "Insulin resistance",
    url: "https://www.betheshyft.com/community/thread/MjY2MjM/insulin-resistance/",
  },
  {
    id: 26622,
    slug: "sleep",
    title: "Sleep",
    url: "https://www.betheshyft.com/community/thread/MjY2MjI/sleep/",
  },
  {
    id: 26587,
    slug: "nutrition-for-a-healthy-sperm",
    title: "Nutrition for a healthy sperm💪",
    url: "https://www.betheshyft.com/community/thread/MjY1ODc/nutrition-for-a-healthy-sperm/",
  },
  {
    id: 26558,
    slug: "fruit-guide",
    title: "FRUIT GUIDE",
    url: "https://www.betheshyft.com/community/thread/MjY1NTg/fruit-guide/",
  },
  {
    id: 26471,
    slug: "yoga-for-better-sleep",
    title: "Yoga for better Sleep",
    url: "https://www.betheshyft.com/community/thread/MjY0NzE/yoga-for-better-sleep/",
  },
  {
    id: 26453,
    slug: "you-deserve",
    title: "You deserve...",
    url: "https://www.betheshyft.com/community/thread/MjY0NTM/you-deserve/",
  },
  {
    id: 26417,
    slug: "6-reasons-for-low-immunity",
    title: "6 Reasons for Low Immunity",
    url: "https://www.betheshyft.com/community/thread/MjY0MTc/6-reasons-for-low-immunity/",
  },
  {
    id: 26400,
    slug: "lets-reflect-for-a-while",
    title: "Let’s reflect for a while !!💫",
    url: "https://www.betheshyft.com/community/thread/MjY0MDA/lets-reflect-for-a-while/",
  },
  {
    id: 26386,
    slug: "how-to-regulate-your-emotions",
    title: "How to Regulate your Emotions",
    url: "https://www.betheshyft.com/community/thread/MjYzODY/how-to-regulate-your-emotions/",
  },
  {
    id: 26380,
    slug: "don-t-feel-guilty-for-the-self",
    title: "Don't feel guilty for the Self!",
    url: "https://www.betheshyft.com/community/thread/MjYzODA/don-t-feel-guilty-for-the-self/",
  },
  {
    id: 26343,
    slug: "finding-balance-in-life",
    title: "Finding Balance in Life...",
    url: "https://www.betheshyft.com/community/thread/MjYzNDM/finding-balance-in-life/",
  },
  {
    id: 26329,
    slug: "what-happens-in-our-brain-when-we-exercise",
    title: "What happens in our brain when we exercise?",
    url: "https://www.betheshyft.com/community/thread/MjYzMjk/what-happens-in-our-brain-when-we-exercise/",
  },
  {
    id: 26318,
    slug: "share-these-with-your-parents-grandparents",
    title: "Share these with your Parents / Grandparents!",
    url: "https://www.betheshyft.com/community/thread/MjYzMTg/share-these-with-your-parents-grandparents/",
  },
  {
    id: 26302,
    slug: "evening-hunger-pangs-driving-you-nuts-not-sure",
    title:
      "Evening hunger pangs driving you nuts??! 🤯 Not sure what to eat ?!🥲 Here are my top 5 picks !",
    url: "https://www.betheshyft.com/community/thread/MjYzMDI/evening-hunger-pangs-driving-you-nuts-not-sure/",
  },
  {
    id: 26283,
    slug: "two-quick-tips-to-benefit-fully-completely-with",
    title:
      "Two quick tips to benefit fully & completely with your Online classes !",
    url: "https://www.betheshyft.com/community/thread/MjYyODM/two-quick-tips-to-benefit-fully-completely-with/",
  },
  {
    id: 26270,
    slug: "why-it-s-hard-to-talk-about-mental",
    title: "Why it's hard to talk about mental health",
    url: "https://www.betheshyft.com/community/thread/MjYyNzA/why-it-s-hard-to-talk-about-mental/",
  },
  {
    id: 26241,
    slug: "posture-for-back-pain-4",
    title: "Posture for back pain 4",
    url: "https://www.betheshyft.com/community/thread/MjYyNDE/posture-for-back-pain-4/",
  },
  {
    id: 26145,
    slug: "yoga-for-the-immune-system",
    title: "Yoga for the immune system 💥",
    url: "https://www.betheshyft.com/community/thread/MjYxNDU/yoga-for-the-immune-system/",
  },
  {
    id: 26076,
    slug: "postures-to-relieve-constipation",
    title: "Postures to relieve constipation",
    url: "https://www.betheshyft.com/community/thread/MjYwNzY/postures-to-relieve-constipation/",
  },
  {
    id: 26075,
    slug: "body-check-up-karwaya-kya",
    title: "Body Check up karwaya kya ??! 🧐",
    url: "https://www.betheshyft.com/community/thread/MjYwNzU/body-check-up-karwaya-kya/",
  },
  {
    id: 26070,
    slug: "eat-mindful",
    title: "🍥Eat mindful🍥",
    url: "https://www.betheshyft.com/community/thread/MjYwNzA/eat-mindful/",
  },
  {
    id: 26041,
    slug: "did-you-know-the-benefits-of-soaked-almonds",
    title:
      "Did you know the benefits of SOAKED Almonds over just plain almonds ???",
    url: "https://www.betheshyft.com/community/thread/MjYwNDE/did-you-know-the-benefits-of-soaked-almonds/",
  },
  {
    id: 26024,
    slug: "postures-for-back-pain-3",
    title: "Postures for back pain 3",
    url: "https://www.betheshyft.com/community/thread/MjYwMjQ/postures-for-back-pain-3/",
  },
  {
    id: 25944,
    slug: "some-basic-yoga-poses",
    title: "Some basic yoga poses",
    url: "https://www.betheshyft.com/community/thread/MjU5NDQ/some-basic-yoga-poses/",
  },
  {
    id: 25914,
    slug: "postures-for-back-pain-2",
    title: "Postures for back pain 2",
    url: "https://www.betheshyft.com/community/thread/MjU5MTQ/postures-for-back-pain-2/",
  },
  {
    id: 25892,
    slug: "stop-feeling-guilty-for",
    title: "Stop feeling guilty for...",
    url: "https://www.betheshyft.com/community/thread/MjU4OTI/stop-feeling-guilty-for/",
  },
  {
    id: 25872,
    slug: "how-to-make-sure-that-your-children-indulge",
    title: "How to make sure that your children indulge in healthy eating ??!",
    url: "https://www.betheshyft.com/community/thread/MjU4NzI/how-to-make-sure-that-your-children-indulge/",
  },
  {
    id: 25871,
    slug: "yoga-poses-for-better-sleep",
    title: "Yoga poses for better sleep 🌙",
    url: "https://www.betheshyft.com/community/thread/MjU4NzE/yoga-poses-for-better-sleep/",
  },
  {
    id: 25860,
    slug: "postures-to-relieve-back-pain-1",
    title: "Postures to relieve back pain 1",
    url: "https://www.betheshyft.com/community/thread/MjU4NjA/postures-to-relieve-back-pain-1/",
  },
  {
    id: 25822,
    slug: "foods-to-keep-in-mind-when-dealing-with",
    title: "Foods to keep in mind when dealing with skin acne ! 🖤💜",
    url: "https://www.betheshyft.com/community/thread/MjU4MjI/foods-to-keep-in-mind-when-dealing-with/",
  },
  {
    id: 25810,
    slug: "daily-yoga-poses",
    title: "Daily yoga poses",
    url: "https://www.betheshyft.com/community/thread/MjU4MTA/daily-yoga-poses/",
  },
  {
    id: 25792,
    slug: "let-s-celebrate-self-acceptance-and-growth",
    title: "Let's celebrate self acceptance and growth👍",
    url: "https://www.betheshyft.com/community/thread/MjU3OTI/let-s-celebrate-self-acceptance-and-growth/",
  },
  {
    id: 25768,
    slug: "safest-plank",
    title: "Safest plank",
    url: "https://www.betheshyft.com/community/thread/MjU3Njg/safest-plank/",
  },
  {
    id: 25706,
    slug: "risky-wrist",
    title: "🤛Risky Wrist🤜",
    url: "https://www.betheshyft.com/community/thread/MjU3MDY/risky-wrist/",
  },
  {
    id: 25685,
    slug: "benefit-of-sleeping-early",
    title: "Benefit of sleeping early",
    url: "https://www.betheshyft.com/community/thread/MjU2ODU/benefit-of-sleeping-early/",
  },
  {
    id: 25602,
    slug: "don-t-be-afraid-to-start-over",
    title: "Don't be afraid to start over...",
    url: "https://www.betheshyft.com/community/thread/MjU2MDI/don-t-be-afraid-to-start-over/",
  },
  {
    id: 25587,
    slug: "common-mistakes-in-plank-pt-3",
    title: "Common mistakes in plank pt. 3",
    url: "https://www.betheshyft.com/community/thread/MjU1ODc/common-mistakes-in-plank-pt-3/",
  },
  {
    id: 25584,
    slug: "iron-rich-foods-for-a-healthy-growth-and",
    title: "Iron rich foods for a healthy growth and development",
    url: "https://www.betheshyft.com/community/thread/MjU1ODQ/iron-rich-foods-for-a-healthy-growth-and/",
  },
  {
    id: 25574,
    slug: "common-mistakes-in-plank-pt-2",
    title: "Common mistakes in plank pt.2",
    url: "https://www.betheshyft.com/community/thread/MjU1NzQ/common-mistakes-in-plank-pt-2/",
  },
  {
    id: 25573,
    slug: "sleep-well",
    title: "Sleep well",
    url: "https://www.betheshyft.com/community/thread/MjU1NzM/sleep-well/",
  },
  {
    id: 25551,
    slug: "excess-gas",
    title: "💨😮‍💨Excess gas 😮‍💨💨",
    url: "https://www.betheshyft.com/community/thread/MjU1NTE/excess-gas/",
  },
  {
    id: 25528,
    slug: "common-mistakes-in-plank-pt-1",
    title: "Common mistakes in plank pt. 1",
    url: "https://www.betheshyft.com/community/thread/MjU1Mjg/common-mistakes-in-plank-pt-1/",
  },
  {
    id: 25510,
    slug: "food-for-soul",
    title: "Food for Soul ❤️🥳",
    url: "https://www.betheshyft.com/community/thread/MjU1MTA/food-for-soul/",
  },
  {
    id: 25475,
    slug: "simple",
    title: "Simple",
    url: "https://www.betheshyft.com/community/thread/MjU0NzU/simple/",
  },
  {
    id: 25433,
    slug: "are-u-drinking-2-liters-of-water-daily",
    title: "Are u drinking  2 liters of water daily ? 💦💧",
    url: "https://www.betheshyft.com/community/thread/MjU0MzM/are-u-drinking-2-liters-of-water-daily/",
  },
  {
    id: 25403,
    slug: "always-remember",
    title: "Always Remember:)",
    url: "https://www.betheshyft.com/community/thread/MjU0MDM/always-remember/",
  },
  {
    id: 25361,
    slug: "have-a-healthy-day-ahead",
    title: "Have a healthy day ahead!",
    url: "https://www.betheshyft.com/community/thread/MjUzNjE/have-a-healthy-day-ahead/",
  },
  {
    id: 25321,
    slug: "snack-attack",
    title: "SNACK ATTACK!!! 🤩🥳",
    url: "https://www.betheshyft.com/community/thread/MjUzMjE/snack-attack/",
  },
  {
    id: 25273,
    slug: "kick-start-your-day-with-a-dash-of",
    title: "Kick start your day with a dash of Cinnamon 💫",
    url: "https://www.betheshyft.com/community/thread/MjUyNzM/kick-start-your-day-with-a-dash-of/",
  },
  {
    id: 25265,
    slug: "correct-posture-for-lying-down-pt2",
    title: "Correct posture for lying down pt2",
    url: "https://www.betheshyft.com/community/thread/MjUyNjU/correct-posture-for-lying-down-pt2/",
  },
  {
    id: 25218,
    slug: "happy-and-healthy-week-ahead",
    title: "Happy and Healthy Week ahead",
    url: "https://www.betheshyft.com/community/thread/MjUyMTg/happy-and-healthy-week-ahead/",
  },
  {
    id: 25182,
    slug: "5-weekend-must-have-habits",
    title: "5 weekend must have habits",
    url: "https://www.betheshyft.com/community/thread/MjUxODI/5-weekend-must-have-habits/",
  },
  {
    id: 25168,
    slug: "lying-down",
    title: "Lying down",
    url: "https://www.betheshyft.com/community/thread/MjUxNjg/lying-down/",
  },
  {
    id: 25155,
    slug: "be-a-leader",
    title: "Be a Leader",
    url: "https://www.betheshyft.com/community/thread/MjUxNTU/be-a-leader/",
  },
  {
    id: 25146,
    slug: "basic-yoga-poses",
    title: "Basic yoga poses",
    url: "https://www.betheshyft.com/community/thread/MjUxNDY/basic-yoga-poses/",
  },
  {
    id: 25123,
    slug: "being-gentle",
    title: "Being gentle",
    url: "https://www.betheshyft.com/community/thread/MjUxMjM/being-gentle/",
  },
  {
    id: 25105,
    slug: "did-you-try-the-healthy-golden-milk-know",
    title: "Did you try the healthy Golden milk … know it’s benefits!!!!",
    url: "https://www.betheshyft.com/community/thread/MjUxMDU/did-you-try-the-healthy-golden-milk-know/",
  },
  {
    id: 25075,
    slug: "liver-health",
    title: "Liver Health",
    url: "https://www.betheshyft.com/community/thread/MjUwNzU/liver-health/",
  },
  {
    id: 25069,
    slug: "foods-that-help-with-fatty-liver",
    title: "Foods that help with Fatty Liver 💪😌",
    url: "https://www.betheshyft.com/community/thread/MjUwNjk/foods-that-help-with-fatty-liver/",
  },
  {
    id: 25062,
    slug: "paneer-cucumber-and-tomatoe-sandwich-today-with-green",
    title: "Paneer, cucumber, and tomatoe sandwich today with green chutney 😋",
    url: "https://www.betheshyft.com/community/thread/MjUwNjI/paneer-cucumber-and-tomatoe-sandwich-today-with-green/",
  },
  {
    id: 25060,
    slug: "setting-goal",
    title: "Setting goal",
    url: "https://www.betheshyft.com/community/thread/MjUwNjA/setting-goal/",
  },
  {
    id: 25003,
    slug: "if-youre-being-mindful-eating-out-can-be",
    title:
      "If you’re being mindful, Eating out can be fun, healthy (& guilt free)!",
    url: "https://www.betheshyft.com/community/thread/MjUwMDM/if-youre-being-mindful-eating-out-can-be/",
  },
  {
    id: 24995,
    slug: "six-bad-habits-which-you-should-stop-right",
    title: "Six bad habits which you should stop right NOW",
    url: "https://www.betheshyft.com/community/thread/MjQ5OTU/six-bad-habits-which-you-should-stop-right/",
  },
  {
    id: 24991,
    slug: "delicious-home-made-white-butter-and-its-benefits",
    title: "Delicious Home made white butter and it’s benefits ( Loni )",
    url: "https://www.betheshyft.com/community/thread/MjQ5OTE/delicious-home-made-white-butter-and-its-benefits/",
  },
  {
    id: 24979,
    slug: "leg-raises-correct-posture",
    title: "Leg raises correct posture",
    url: "https://www.betheshyft.com/community/thread/MjQ5Nzk/leg-raises-correct-posture/",
  },
  {
    id: 24929,
    slug: "low-lunge-with-twist",
    title: "Low lunge with twist",
    url: "https://www.betheshyft.com/community/thread/MjQ5Mjk/low-lunge-with-twist/",
  },
  {
    id: 24921,
    slug: "ways-to-support-your-child-s-mental-health",
    title: "Ways to support your Child's mental health",
    url: "https://www.betheshyft.com/community/thread/MjQ5MjE/ways-to-support-your-child-s-mental-health/",
  },
  {
    id: 24878,
    slug: "the-three-legged-dog",
    title: "The three legged dog",
    url: "https://www.betheshyft.com/community/thread/MjQ4Nzg/the-three-legged-dog/",
  },
  {
    id: 24874,
    slug: "importance-of-exercise-and-physical-activity",
    title: "Importance of Exercise and physical activity 🏃🏻‍♀️⛹🏻‍♀️🧘🏻‍♀️🏄🏻🏊🏻🤽🏻‍♂️🧗🏻‍♀️🚵🏻🏋🏻",
    url: "https://www.betheshyft.com/community/thread/MjQ4NzQ/importance-of-exercise-and-physical-activity/",
  },
  {
    id: 24859,
    slug: "downwards-facing-dog",
    title: "Downwards facing dog",
    url: "https://www.betheshyft.com/community/thread/MjQ4NTk/downwards-facing-dog/",
  },
  {
    id: 24841,
    slug: "is-fat-the-only-culprit-for-fatty-liver",
    title:
      "Is fat the only culprit for FATTY LIVER DISEASE ? \nThe answer is NO....an over consumption of fructose & carbohydrates too can lead to this condition.  Read on to know how !!!",
    url: "https://www.betheshyft.com/community/thread/MjQ4NDE/is-fat-the-only-culprit-for-fatty-liver/",
  },
  {
    id: 24831,
    slug: "parivritta-trikonasana-revolved-triangle-pose",
    title: "Parivritta Trikonasana/ Revolved Triangle Pose",
    url: "https://www.betheshyft.com/community/thread/MjQ4MzE/parivritta-trikonasana-revolved-triangle-pose/",
  },
  {
    id: 24808,
    slug: "depth-of-your-posture",
    title: "Depth of your posture",
    url: "https://www.betheshyft.com/community/thread/MjQ4MDg/depth-of-your-posture/",
  },
  {
    id: 24768,
    slug: "what-does-water-do-for-you-are-you",
    title: "What does water do for you ? Are you getting enough of it ?",
    url: "https://www.betheshyft.com/community/thread/MjQ3Njg/what-does-water-do-for-you-are-you/",
  },
  {
    id: 24733,
    slug: "understand-and-act-accordingly",
    title: "Understand and act accordingly",
    url: "https://www.betheshyft.com/community/thread/MjQ3MzM/understand-and-act-accordingly/",
  },
  {
    id: 24701,
    slug: "isometric-and-isotonic",
    title: "🔼Isometric and isotonic🔽",
    url: "https://www.betheshyft.com/community/thread/MjQ3MDE/isometric-and-isotonic/",
  },
  {
    id: 24604,
    slug: "rejuvenate-today",
    title: "Rejuvenate today!",
    url: "https://www.betheshyft.com/community/thread/MjQ2MDQ/rejuvenate-today/",
  },
  {
    id: 24591,
    slug: "did-you-pay-a-recent-visit-to-your",
    title:
      "Did you pay a recent visit to your dentist?! Has chewing become a nightmare post that and all you can have is liquids? Then this post is for you😎",
    url: "https://www.betheshyft.com/community/thread/MjQ1OTE/did-you-pay-a-recent-visit-to-your/",
  },
  {
    id: 24516,
    slug: "being-healthy-should-now-become-a-habit",
    title: "Being healthy should now become a habit👍",
    url: "https://www.betheshyft.com/community/thread/MjQ1MTY/being-healthy-should-now-become-a-habit/",
  },
  {
    id: 24490,
    slug: "deeper-benefits-of-sun-other-than-vitamin-d",
    title: "Deeper benefits of Sun other than Vitamin D🌞☀️",
    url: "https://www.betheshyft.com/community/thread/MjQ0OTA/deeper-benefits-of-sun-other-than-vitamin-d/",
  },
  {
    id: 24443,
    slug: "forgive-and-get-your-emotional-health-back",
    title: "Forgive and get your emotional health back:)",
    url: "https://www.betheshyft.com/community/thread/MjQ0NDM/forgive-and-get-your-emotional-health-back/",
  },
  {
    id: 24442,
    slug: "struggling-is-natural",
    title: "Struggling is natural",
    url: "https://www.betheshyft.com/community/thread/MjQ0NDI/struggling-is-natural/",
  },
  {
    id: 24433,
    slug: "myth-and-fact",
    title: "Myth and fact",
    url: "https://www.betheshyft.com/community/thread/MjQ0MzM/myth-and-fact/",
  },
  {
    id: 24424,
    slug: "how-to-maintain-your-waistline-while-you-travel",
    title: "How to maintain your waistline while you travel 😍",
    url: "https://www.betheshyft.com/community/thread/MjQ0MjQ/how-to-maintain-your-waistline-while-you-travel/",
  },
  {
    id: 24416,
    slug: "simple-movements-to-help-knee-pain",
    title: "Simple movements to help knee pain",
    url: "https://www.betheshyft.com/community/thread/MjQ0MTY/simple-movements-to-help-knee-pain/",
  },
  {
    id: 24391,
    slug: "read-the-labels",
    title: "Read the labels!",
    url: "https://www.betheshyft.com/community/thread/MjQzOTE/read-the-labels/",
  },
  {
    id: 24387,
    slug: "is-it-okay-to-take-supplements-whenever-we",
    title: "Is it okay to take supplements whenever we want to ?!",
    url: "https://www.betheshyft.com/community/thread/MjQzODc/is-it-okay-to-take-supplements-whenever-we/",
  },
  {
    id: 24299,
    slug: "supta-baddha-konasana-reclining-butterfly-pose",
    title: "Supta Baddha Konasana/Reclining Butterfly Pose",
    url: "https://www.betheshyft.com/community/thread/MjQyOTk/supta-baddha-konasana-reclining-butterfly-pose/",
  },
  {
    id: 24256,
    slug: "build-a-bridge",
    title: "Build a bridge",
    url: "https://www.betheshyft.com/community/thread/MjQyNTY/build-a-bridge/",
  },
  {
    id: 24252,
    slug: "understanding-mental-health-means-dismantling-myths",
    title: "Understanding mental health means dismantling myths",
    url: "https://www.betheshyft.com/community/thread/MjQyNTI/understanding-mental-health-means-dismantling-myths/",
  },
  {
    id: 24233,
    slug: "are-you-cutting-down-on-healthy-fats-in",
    title: "Are you cutting down on healthy fats in your weightloss journey ?",
    url: "https://www.betheshyft.com/community/thread/MjQyMzM/are-you-cutting-down-on-healthy-fats-in/",
  },
  {
    id: 24226,
    slug: "cultivate-breath-awareness",
    title: "Cultivate breath awareness",
    url: "https://www.betheshyft.com/community/thread/MjQyMjY/cultivate-breath-awareness/",
  },
  {
    id: 24136,
    slug: "picture-says-it-all",
    title: "Picture says it all",
    url: "https://www.betheshyft.com/community/thread/MjQxMzY/picture-says-it-all/",
  },
  {
    id: 24064,
    slug: "rejuvenate-over-the-weekend",
    title: "Rejuvenate over the weekend!",
    url: "https://www.betheshyft.com/community/thread/MjQwNjQ/rejuvenate-over-the-weekend/",
  },
  {
    id: 23931,
    slug: "why-should-you-choose-iodised-salt",
    title: "Why should you choose iodised salt?",
    url: "https://www.betheshyft.com/community/thread/MjM5MzE/why-should-you-choose-iodised-salt/",
  },
  {
    id: 23907,
    slug: "affirmations",
    title: "Affirmations",
    url: "https://www.betheshyft.com/community/thread/MjM5MDc/affirmations/",
  },
  {
    id: 23884,
    slug: "how-to-protect-your-mental-health",
    title: "How to protect your Mental health !!!",
    url: "https://www.betheshyft.com/community/thread/MjM4ODQ/how-to-protect-your-mental-health/",
  },
  {
    id: 23877,
    slug: "eat-your-veggies",
    title: "Eat Your Veggies ❤️💚",
    url: "https://www.betheshyft.com/community/thread/MjM4Nzc/eat-your-veggies/",
  },
  {
    id: 23799,
    slug: "hope-recharging-yourself-for-the-week-ahead",
    title: "Hope recharging yourself for the week ahead👍",
    url: "https://www.betheshyft.com/community/thread/MjM3OTk/hope-recharging-yourself-for-the-week-ahead/",
  },
  {
    id: 23763,
    slug: "picture-speak-louder-than-words-picture-8",
    title: "Picture speak louder than words : Picture 8",
    url: "https://www.betheshyft.com/community/thread/MjM3NjM/picture-speak-louder-than-words-picture-8/",
  },
  {
    id: 23762,
    slug: "picture-speak-louder-than-words-picture-7",
    title: "Picture speak louder than words : Picture 7",
    url: "https://www.betheshyft.com/community/thread/MjM3NjI/picture-speak-louder-than-words-picture-7/",
  },
  {
    id: 23761,
    slug: "picture-speak-louder-than-words-picture-6",
    title: "Picture speak louder than words : Picture 6",
    url: "https://www.betheshyft.com/community/thread/MjM3NjE/picture-speak-louder-than-words-picture-6/",
  },
  {
    id: 23760,
    slug: "picture-speak-louder-than-words-picture-5",
    title: "Picture speak louder than words : Picture 5",
    url: "https://www.betheshyft.com/community/thread/MjM3NjA/picture-speak-louder-than-words-picture-5/",
  },
  {
    id: 23759,
    slug: "picture-speak-louder-than-words-picture-4",
    title: "Picture speak louder than words: Picture 4",
    url: "https://www.betheshyft.com/community/thread/MjM3NTk/picture-speak-louder-than-words-picture-4/",
  },
  {
    id: 23758,
    slug: "picture-speak-louder-than-words-picture-3",
    title: "Picture speak louder than words : Picture 3",
    url: "https://www.betheshyft.com/community/thread/MjM3NTg/picture-speak-louder-than-words-picture-3/",
  },
  {
    id: 23757,
    slug: "picture-speak-louder-than-words-picture-2",
    title: "Picture speak louder than words : Picture 2",
    url: "https://www.betheshyft.com/community/thread/MjM3NTc/picture-speak-louder-than-words-picture-2/",
  },
  {
    id: 23756,
    slug: "picture-speak-louder-than-words-picture-1",
    title: "Picture speak louder than words : Picture 1",
    url: "https://www.betheshyft.com/community/thread/MjM3NTY/picture-speak-louder-than-words-picture-1/",
  },
  {
    id: 23710,
    slug: "foods-to-boost-your-immunity-this-rainy-season",
    title: "Foods to boost your immunity this rainy season",
    url: "https://www.betheshyft.com/community/thread/MjM3MTA/foods-to-boost-your-immunity-this-rainy-season/",
  },
  {
    id: 23628,
    slug: "the-first-crop-of-juicy-guavas-from-my",
    title:
      "The first crop of juicy GUAVAS from my garden !! 😋  The guava FRUIT is a source of vitamin C, fiber, and phytonutrients such as carotenoids, polyphenols, which function as natural antioxidants in the body.",
    url: "https://www.betheshyft.com/community/thread/MjM2Mjg/the-first-crop-of-juicy-guavas-from-my/",
  },
  {
    id: 23618,
    slug: "postpartum-recovery",
    title: "Postpartum Recovery",
    url: "https://www.betheshyft.com/community/thread/MjM2MTg/postpartum-recovery/",
  },
  {
    id: 23607,
    slug: "how-stress-affects-different-system-of-the-body",
    title: "How stress affects different system of the body",
    url: "https://www.betheshyft.com/community/thread/MjM2MDc/how-stress-affects-different-system-of-the-body/",
  },
  {
    id: 23599,
    slug: "gut-health",
    title: "Gut health",
    url: "https://www.betheshyft.com/community/thread/MjM1OTk/gut-health/",
  },
  {
    id: 23565,
    slug: "your-blood-sugar-clock",
    title: "Your Blood Sugar Clock",
    url: "https://www.betheshyft.com/community/thread/MjM1NjU/your-blood-sugar-clock/",
  },
  {
    id: 23551,
    slug: "the-bamboo-that-bends-is-stronger-than-the",
    title:
      '"The bamboo that bends is stronger than the oak that resists." Japanese proverb',
    url: "https://www.betheshyft.com/community/thread/MjM1NTE/the-bamboo-that-bends-is-stronger-than-the/",
  },
  {
    id: 23480,
    slug: "so-true",
    title: "So true",
    url: "https://www.betheshyft.com/community/thread/MjM0ODA/so-true/",
  },
  {
    id: 23402,
    slug: "toddler-parents-would-agree",
    title: "Toddler parents would agree😅",
    url: "https://www.betheshyft.com/community/thread/MjM0MDI/toddler-parents-would-agree/",
  },
  {
    id: 23383,
    slug: "breakfast-time",
    title: "Breakfast time",
    url: "https://www.betheshyft.com/community/thread/MjMzODM/breakfast-time/",
  },
  {
    id: 23340,
    slug: "happy-weekend",
    title: "Happy weekend!",
    url: "https://www.betheshyft.com/community/thread/MjMzNDA/happy-weekend/",
  },
  {
    id: 23249,
    slug: "anterior-pelvic-tilt",
    title: "Anterior Pelvic Tilt",
    url: "https://www.betheshyft.com/community/thread/MjMyNDk/anterior-pelvic-tilt/",
  },
  {
    id: 23208,
    slug: "you-can-do-more-than-you-think-you",
    title: "You can do more than you think you can :)",
    url: "https://www.betheshyft.com/community/thread/MjMyMDg/you-can-do-more-than-you-think-you/",
  },
  {
    id: 23036,
    slug: "share-happiness",
    title: "Share happiness",
    url: "https://www.betheshyft.com/community/thread/MjMwMzY/share-happiness/",
  },
  {
    id: 23019,
    slug: "differet-types-of-workouts-for-pcos",
    title: "Differet types of workouts for PCOS",
    url: "https://www.betheshyft.com/community/thread/MjMwMTk/differet-types-of-workouts-for-pcos/",
  },
  {
    id: 23017,
    slug: "immunity-boosters",
    title: "Immunity Boosters",
    url: "https://www.betheshyft.com/community/thread/MjMwMTc/immunity-boosters/",
  },
  {
    id: 22979,
    slug: "hope-having-a-balanced-lunch-today",
    title: "Hope having a balanced lunch today?",
    url: "https://www.betheshyft.com/community/thread/MjI5Nzk/hope-having-a-balanced-lunch-today/",
  },
  {
    id: 22962,
    slug: "ustrasana-or-camel-pose",
    title: "Ustrasana or Camel Pose",
    url: "https://www.betheshyft.com/community/thread/MjI5NjI/ustrasana-or-camel-pose/",
  },
  {
    id: 22951,
    slug: "hey-mama",
    title: "Hey mama 🤰🏻",
    url: "https://www.betheshyft.com/community/thread/MjI5NTE/hey-mama/",
  },
  {
    id: 22918,
    slug: "worried-about-sugar-finding-non-sugar-sweeteners",
    title: "Worried about Sugar & finding non sugar sweeteners ?",
    url: "https://www.betheshyft.com/community/thread/MjI5MTg/worried-about-sugar-finding-non-sugar-sweeteners/",
  },
  {
    id: 22892,
    slug: "improve-mindfulness",
    title: "Improve Mindfulness",
    url: "https://www.betheshyft.com/community/thread/MjI4OTI/improve-mindfulness/",
  },
  {
    id: 22881,
    slug: "importance-of-deep-sleep",
    title: "Importance of deep sleep",
    url: "https://www.betheshyft.com/community/thread/MjI4ODE/importance-of-deep-sleep/",
  },
  {
    id: 22844,
    slug: "practice-gratitude-daily-for-better-mental-health-peace",
    title:
      "Practice gratitude daily for better mental health, peace, and joy within .",
    url: "https://www.betheshyft.com/community/thread/MjI4NDQ/practice-gratitude-daily-for-better-mental-health-peace/",
  },
  {
    id: 22781,
    slug: "health-problems-related-to-stress-that-you-can",
    title: "Health Problems Related to Stress That You Can Fix",
    url: "https://www.betheshyft.com/community/thread/MjI3ODE/health-problems-related-to-stress-that-you-can/",
  },
  {
    id: 22731,
    slug: "you-can-probably-guess-what-happens-if-you",
    title: "You can probably guess what happens if you eat too much.",
    url: "https://www.betheshyft.com/community/thread/MjI3MzE/you-can-probably-guess-what-happens-if-you/",
  },
  {
    id: 22729,
    slug: "asanas-for-improving-digestion",
    title: "Asanas for improving digestion",
    url: "https://www.betheshyft.com/community/thread/MjI3Mjk/asanas-for-improving-digestion/",
  },
  {
    id: 22716,
    slug: "importance-of-bedtime-routine",
    title: "Importance of bedtime routine",
    url: "https://www.betheshyft.com/community/thread/MjI3MTY/importance-of-bedtime-routine/",
  },
  {
    id: 22688,
    slug: "physiological-tool-to-manage-emotion",
    title: "Physiological tool to manage Emotion",
    url: "https://www.betheshyft.com/community/thread/MjI2ODg/physiological-tool-to-manage-emotion/",
  },
  {
    id: 22685,
    slug: "deficiency-of-vit-b12",
    title: "Deficiency of vit B12",
    url: "https://www.betheshyft.com/community/thread/MjI2ODU/deficiency-of-vit-b12/",
  },
  {
    id: 22669,
    slug: "meditating-on-this-thought-today",
    title: "Meditating on this thought today 😊",
    url: "https://www.betheshyft.com/community/thread/MjI2Njk/meditating-on-this-thought-today/",
  },
  {
    id: 22640,
    slug: "sunday-habits",
    title: "Sunday Habits",
    url: "https://www.betheshyft.com/community/thread/MjI2NDA/sunday-habits/",
  },
  {
    id: 22629,
    slug: "are-you-craving-fried-food-in-monsoon",
    title: "Are you craving Fried Food in Monsoon?",
    url: "https://www.betheshyft.com/community/thread/MjI2Mjk/are-you-craving-fried-food-in-monsoon/",
  },
  {
    id: 22594,
    slug: "cultivating-habits",
    title: "Cultivating habits",
    url: "https://www.betheshyft.com/community/thread/MjI1OTQ/cultivating-habits/",
  },
  {
    id: 22589,
    slug: "pelvic-floor-dysfunction",
    title: "Pelvic floor dysfunction",
    url: "https://www.betheshyft.com/community/thread/MjI1ODk/pelvic-floor-dysfunction/",
  },
  {
    id: 22524,
    slug: "circardian-rhythm-what-is-it-how-does-it",
    title: "CIRCARDIAN RHYTHM -- 🌗🌠🌞 what is it ? How does it help us ??",
    url: "https://www.betheshyft.com/community/thread/MjI1MjQ/circardian-rhythm-what-is-it-how-does-it/",
  },
  {
    id: 22513,
    slug: "try-these-tomorrow-morning",
    title: "Try these tomorrow morning!",
    url: "https://www.betheshyft.com/community/thread/MjI1MTM/try-these-tomorrow-morning/",
  },
  {
    id: 22502,
    slug: "stress",
    title: "Stress",
    url: "https://www.betheshyft.com/community/thread/MjI1MDI/stress/",
  },
  {
    id: 22457,
    slug: "stay-active",
    title: "Stay Active",
    url: "https://www.betheshyft.com/community/thread/MjI0NTc/stay-active/",
  },
  {
    id: 22449,
    slug: "yoga-for-healthy-feet-and-ankles",
    title: "Yoga for healthy feet and ankles",
    url: "https://www.betheshyft.com/community/thread/MjI0NDk/yoga-for-healthy-feet-and-ankles/",
  },
  {
    id: 22416,
    slug: "benifits-of-backbends",
    title: "Benifits of backbends",
    url: "https://www.betheshyft.com/community/thread/MjI0MTY/benifits-of-backbends/",
  },
  {
    id: 22412,
    slug: "stretches-for-tight-shoulders",
    title: "Stretches for tight shoulders",
    url: "https://www.betheshyft.com/community/thread/MjI0MTI/stretches-for-tight-shoulders/",
  },
  {
    id: 22344,
    slug: "start-strong",
    title: "Start Strong!",
    url: "https://www.betheshyft.com/community/thread/MjIzNDQ/start-strong/",
  },
  {
    id: 22332,
    slug: "triangle-pose",
    title: "Triangle Pose",
    url: "https://www.betheshyft.com/community/thread/MjIzMzI/triangle-pose/",
  },
  {
    id: 22316,
    slug: "physiological-tool-to-manage-emotion",
    title: "Physiological tool to manage Emotion",
    url: "https://www.betheshyft.com/community/thread/MjIzMTY/physiological-tool-to-manage-emotion/",
  },
  {
    id: 22289,
    slug: "monsoons-should-i-make-changes-in-the-food",
    title: "MONSOONS ⛈️🌈☔️ should I make changes in the food I eat ??",
    url: "https://www.betheshyft.com/community/thread/MjIyODk/monsoons-should-i-make-changes-in-the-food/",
  },
  {
    id: 22231,
    slug: "trust-and-faith",
    title: "Trust and Faith",
    url: "https://www.betheshyft.com/community/thread/MjIyMzE/trust-and-faith/",
  },
  {
    id: 22224,
    slug: "mindful-practice",
    title: "Mindful Practice",
    url: "https://www.betheshyft.com/community/thread/MjIyMjQ/mindful-practice/",
  },
  {
    id: 22201,
    slug: "benefits-of-seated-forward-bend",
    title: "Benefits of Seated Forward Bend",
    url: "https://www.betheshyft.com/community/thread/MjIyMDE/benefits-of-seated-forward-bend/",
  },
  {
    id: 22183,
    slug: "spine-health-essentials",
    title: "Spine Health Essentials",
    url: "https://www.betheshyft.com/community/thread/MjIxODM/spine-health-essentials/",
  },
  {
    id: 22178,
    slug: "for-better-sleep",
    title: "For better sleep 😴",
    url: "https://www.betheshyft.com/community/thread/MjIxNzg/for-better-sleep/",
  },
  {
    id: 22166,
    slug: "marichyasana",
    title: "🪭Marichyasana🪭",
    url: "https://www.betheshyft.com/community/thread/MjIxNjY/marichyasana/",
  },
  {
    id: 22162,
    slug: "physiological-tool-to-manage-emotion",
    title: "Physiological tool to manage emotion",
    url: "https://www.betheshyft.com/community/thread/MjIxNjI/physiological-tool-to-manage-emotion/",
  },
  {
    id: 22144,
    slug: "how-to-boost-your-immune-system",
    title: "How to Boost your Immune System",
    url: "https://www.betheshyft.com/community/thread/MjIxNDQ/how-to-boost-your-immune-system/",
  },
  {
    id: 22134,
    slug: "vitamin-d",
    title: "Vitamin D",
    url: "https://www.betheshyft.com/community/thread/MjIxMzQ/vitamin-d/",
  },
  {
    id: 22126,
    slug: "gentle-reminder",
    title: "Gentle reminder ✨",
    url: "https://www.betheshyft.com/community/thread/MjIxMjY/gentle-reminder/",
  },
  {
    id: 22109,
    slug: "benefits-of-low-lunge-pose",
    title: "Benefits of Low Lunge Pose:",
    url: "https://www.betheshyft.com/community/thread/MjIxMDk/benefits-of-low-lunge-pose/",
  },
  {
    id: 22106,
    slug: "effect-of-sleep-deprivation",
    title: "Effect of sleep deprivation",
    url: "https://www.betheshyft.com/community/thread/MjIxMDY/effect-of-sleep-deprivation/",
  },
  {
    id: 22092,
    slug: "practicing-the-crescent-lunge-pose",
    title: "Practicing the Crescent Lunge Pose",
    url: "https://www.betheshyft.com/community/thread/MjIwOTI/practicing-the-crescent-lunge-pose/",
  },
  {
    id: 22054,
    slug: "rules-for-visiting-mama-and-baby-after-birth",
    title: "Rules for visiting Mama and baby after birth",
    url: "https://www.betheshyft.com/community/thread/MjIwNTQ/rules-for-visiting-mama-and-baby-after-birth/",
  },
  {
    id: 22051,
    slug: "sarvang-asana-also-know-as-shoulder-stand",
    title: "Sarvang asana also know as shoulder stand.",
    url: "https://www.betheshyft.com/community/thread/MjIwNTE/sarvang-asana-also-know-as-shoulder-stand/",
  },
  {
    id: 22046,
    slug: "poses-for-better-sleep",
    title: "Poses for better sleep",
    url: "https://www.betheshyft.com/community/thread/MjIwNDY/poses-for-better-sleep/",
  },
  {
    id: 22039,
    slug: "walking-barefoot",
    title: "Walking barefoot",
    url: "https://www.betheshyft.com/community/thread/MjIwMzk/walking-barefoot/",
  },
  {
    id: 22033,
    slug: "postures-to-ease-you-when-anxious",
    title: "Postures to ease you when anxious !",
    url: "https://www.betheshyft.com/community/thread/MjIwMzM/postures-to-ease-you-when-anxious/",
  },
  {
    id: 22025,
    slug: "a-relaxing-posture-for-your-back-and-neck",
    title:
      "A Relaxing posture for your back and neck after a long hectic day- Sphinx Pose",
    url: "https://www.betheshyft.com/community/thread/MjIwMjU/a-relaxing-posture-for-your-back-and-neck/",
  },
  {
    id: 21999,
    slug: "happy-sunday",
    title: "Happy Sunday ❤️🤗",
    url: "https://www.betheshyft.com/community/thread/MjE5OTk/happy-sunday/",
  },
  {
    id: 21998,
    slug: "benefits-of-salt",
    title: "Benefits of Salt",
    url: "https://www.betheshyft.com/community/thread/MjE5OTg/benefits-of-salt/",
  },
  {
    id: 21992,
    slug: "5-mins-of-relaxation",
    title: "5 mins of relaxation",
    url: "https://www.betheshyft.com/community/thread/MjE5OTI/5-mins-of-relaxation/",
  },
  {
    id: 21968,
    slug: "discovering-peace-and-joy-within",
    title: "Discovering peace and joy within :)",
    url: "https://www.betheshyft.com/community/thread/MjE5Njg/discovering-peace-and-joy-within/",
  },
  {
    id: 21952,
    slug: "manage-cortisol-level",
    title: "Manage cortisol level",
    url: "https://www.betheshyft.com/community/thread/MjE5NTI/manage-cortisol-level/",
  },
  {
    id: 21951,
    slug: "how-cortisol-level-affects-your-gut",
    title: "How cortisol level affects your gut",
    url: "https://www.betheshyft.com/community/thread/MjE5NTE/how-cortisol-level-affects-your-gut/",
  },
  {
    id: 21942,
    slug: "extended-side-angle-pose",
    title: "Extended Side Angle Pose",
    url: "https://www.betheshyft.com/community/thread/MjE5NDI/extended-side-angle-pose/",
  },
  {
    id: 21931,
    slug: "did-you-check-your-mental-weight-on-the",
    title: "Did you check your mental weight on the scale ?! 🤯🤯",
    url: "https://www.betheshyft.com/community/thread/MjE5MzE/did-you-check-your-mental-weight-on-the/",
  },
  {
    id: 21920,
    slug: "understanding-boat-pose",
    title: "Understanding Boat Pose",
    url: "https://www.betheshyft.com/community/thread/MjE5MjA/understanding-boat-pose/",
  },
  {
    id: 21876,
    slug: "overthinking-is-the-biggest-cause-of-unhappiness",
    title: "Overthinking is the biggest cause of unhappiness",
    url: "https://www.betheshyft.com/community/thread/MjE4NzY/overthinking-is-the-biggest-cause-of-unhappiness/",
  },
  {
    id: 21825,
    slug: "here-s-why-you-shouldn-t-use-plastic",
    title:
      "Here's why you shouldn't use plastic containers  to store or heat your food ☠️",
    url: "https://www.betheshyft.com/community/thread/MjE4MjU/here-s-why-you-shouldn-t-use-plastic/",
  },
  {
    id: 21715,
    slug: "day-21-easy-sitting-pose-the-ultimate-yoga",
    title: "Day 21: Easy Sitting Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjE3MTU/day-21-easy-sitting-pose-the-ultimate-yoga/",
  },
  {
    id: 21694,
    slug: "happy-international-yoga-day",
    title: "Happy International Yoga Day!",
    url: "https://www.betheshyft.com/community/thread/MjE2OTQ/happy-international-yoga-day/",
  },
  {
    id: 21610,
    slug: "day-20-goddess-pose-the-ultimate-yoga-day",
    title: "Day 20: Goddess Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjE2MTA/day-20-goddess-pose-the-ultimate-yoga-day/",
  },
  {
    id: 21587,
    slug: "what-all-can-your-2-months-old-baby",
    title: "What all can your 2 months old baby do?",
    url: "https://www.betheshyft.com/community/thread/MjE1ODc/what-all-can-your-2-months-old-baby/",
  },
  {
    id: 21574,
    slug: "prop-usage-to-keep-your-hands-and-wrist",
    title: "Prop usage to keep your hands and wrist safe.",
    url: "https://www.betheshyft.com/community/thread/MjE1NzQ/prop-usage-to-keep-your-hands-and-wrist/",
  },
  {
    id: 21519,
    slug: "mindful-eating-improve-your-relationship-with-food-make",
    title:
      "Mindful eating !!! ❤️Improve your relationship with Food …. Make a conscious choice for your health !!!🤗",
    url: "https://www.betheshyft.com/community/thread/MjE1MTk/mindful-eating-improve-your-relationship-with-food-make/",
  },
  {
    id: 21502,
    slug: "how-yoga-for-pregnant-women-helps",
    title: "How yoga for pregnant women helps😊",
    url: "https://www.betheshyft.com/community/thread/MjE1MDI/how-yoga-for-pregnant-women-helps/",
  },
  {
    id: 21489,
    slug: "ubhaya-padangusthasana-is-a-seated-posture-where-both",
    title:
      "Ubhaya Padangusthasana- is  a seated posture, where both big toes are held with both hands while balancing on your sitting bones.",
    url: "https://www.betheshyft.com/community/thread/MjE0ODk/ubhaya-padangusthasana-is-a-seated-posture-where-both/",
  },
  {
    id: 21484,
    slug: "healthy-habits",
    title: "Healthy habits",
    url: "https://www.betheshyft.com/community/thread/MjE0ODQ/healthy-habits/",
  },
  {
    id: 21455,
    slug: "day-18-head-to-knee-pose-the-ultimate",
    title: "Day 18: Head to Knee pose ( The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjE0NTU/day-18-head-to-knee-pose-the-ultimate/",
  },
  {
    id: 21430,
    slug: "tree-pose-ultimate-yoga-day-challenge",
    title: "Tree pose #Ultimate Yoga Day Challenge",
    url: "https://www.betheshyft.com/community/thread/MjE0MzA/tree-pose-ultimate-yoga-day-challenge/",
  },
  {
    id: 21406,
    slug: "day-17-big-toe-pose-the-ultimate-yoga",
    title: "Day 17:  Big Toe Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjE0MDY/day-17-big-toe-pose-the-ultimate-yoga/",
  },
  {
    id: 21367,
    slug: "strategies-that-can-help-manage-postpartum-rage",
    title: "Strategies that can help manage postpartum rage",
    url: "https://www.betheshyft.com/community/thread/MjEzNjc/strategies-that-can-help-manage-postpartum-rage/",
  },
  {
    id: 21363,
    slug: "butterfly-pose",
    title: "🦋Butterfly pose 🦋",
    url: "https://www.betheshyft.com/community/thread/MjEzNjM/butterfly-pose/",
  },
  {
    id: 21356,
    slug: "differences-in-flexibility-of-right-and-left-side",
    title: "Differences in flexibility of Right and Left side",
    url: "https://www.betheshyft.com/community/thread/MjEzNTY/differences-in-flexibility-of-right-and-left-side/",
  },
  {
    id: 21294,
    slug: "inverted-split-ultimate-yoga-day-challenge",
    title: "Inverted split #Ultimate Yoga Day Challenge",
    url: "https://www.betheshyft.com/community/thread/MjEyOTQ/inverted-split-ultimate-yoga-day-challenge/",
  },
  {
    id: 21288,
    slug: "types-of-headaches",
    title: "Types of Headaches",
    url: "https://www.betheshyft.com/community/thread/MjEyODg/types-of-headaches/",
  },
  {
    id: 21224,
    slug: "day-16-cobra-pose-the-ultimate-yoga-day",
    title: "Day 16: Cobra Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjEyMjQ/day-16-cobra-pose-the-ultimate-yoga-day/",
  },
  {
    id: 21196,
    slug: "reminder-to-be-consistent-take-this-as-a",
    title: "Reminder to be consistent- Take this as a sign 🙂",
    url: "https://www.betheshyft.com/community/thread/MjExOTY/reminder-to-be-consistent-take-this-as-a/",
  },
  {
    id: 21161,
    slug: "10k-steps-everyday",
    title: "10K steps everyday!",
    url: "https://www.betheshyft.com/community/thread/MjExNjE/10k-steps-everyday/",
  },
  {
    id: 21159,
    slug: "why-eat-more-turmeric",
    title: "Why eat more Turmeric",
    url: "https://www.betheshyft.com/community/thread/MjExNTk/why-eat-more-turmeric/",
  },
  {
    id: 21157,
    slug: "camel-pose",
    title: "Camel pose🧘‍♀️",
    url: "https://www.betheshyft.com/community/thread/MjExNTc/camel-pose/",
  },
  {
    id: 21103,
    slug: "day-15-pawanmuktasana-the-ultimate-yoga-day-challenge",
    title: "Day 15: Pawanmuktasana (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjExMDM/day-15-pawanmuktasana-the-ultimate-yoga-day-challenge/",
  },
  {
    id: 21081,
    slug: "start-your-meditation-journey-today-with-shyft",
    title: "Start your meditation journey today, with Shyft!",
    url: "https://www.betheshyft.com/community/thread/MjEwODE/start-your-meditation-journey-today-with-shyft/",
  },
  {
    id: 20963,
    slug: "day-14-pigeon-pose-the-ultimate-yoga-day",
    title: "Day 14: Pigeon Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjA5NjM/day-14-pigeon-pose-the-ultimate-yoga-day/",
  },
  {
    id: 20952,
    slug: "training-the-mind",
    title: "Training the mind",
    url: "https://www.betheshyft.com/community/thread/MjA5NTI/training-the-mind/",
  },
  {
    id: 20915,
    slug: "how-to-create-a-life-that-you-want",
    title: "How to create a life that you want in one year",
    url: "https://www.betheshyft.com/community/thread/MjA5MTU/how-to-create-a-life-that-you-want/",
  },
  {
    id: 20892,
    slug: "benefits-of-prenatal-yoga",
    title: "Benefits of prenatal yoga 🧘‍♀️",
    url: "https://www.betheshyft.com/community/thread/MjA4OTI/benefits-of-prenatal-yoga/",
  },
  {
    id: 20841,
    slug: "day-13-half-split-pose-the-ultimate-yoga",
    title: "Day 13: Half Split Pose ( The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjA4NDE/day-13-half-split-pose-the-ultimate-yoga/",
  },
  {
    id: 20838,
    slug: "benefits-of-wind-relieving-pose",
    title: "Benefits of wind relieving pose ✨️",
    url: "https://www.betheshyft.com/community/thread/MjA4Mzg/benefits-of-wind-relieving-pose/",
  },
  {
    id: 20788,
    slug: "habit-7",
    title: "Habit 7",
    url: "https://www.betheshyft.com/community/thread/MjA3ODg/habit-7/",
  },
  {
    id: 20787,
    slug: "habit-6",
    title: "Habit 6",
    url: "https://www.betheshyft.com/community/thread/MjA3ODc/habit-6/",
  },
  {
    id: 20786,
    slug: "habit-5",
    title: "Habit 5",
    url: "https://www.betheshyft.com/community/thread/MjA3ODY/habit-5/",
  },
  {
    id: 20785,
    slug: "habit-4",
    title: "Habit 4",
    url: "https://www.betheshyft.com/community/thread/MjA3ODU/habit-4/",
  },
  {
    id: 20784,
    slug: "habit-3",
    title: "Habit 3",
    url: "https://www.betheshyft.com/community/thread/MjA3ODQ/habit-3/",
  },
  {
    id: 20782,
    slug: "habit-2",
    title: "Habit 2",
    url: "https://www.betheshyft.com/community/thread/MjA3ODI/habit-2/",
  },
  {
    id: 20781,
    slug: "habit-1",
    title: "Habit 1",
    url: "https://www.betheshyft.com/community/thread/MjA3ODE/habit-1/",
  },
  {
    id: 20768,
    slug: "warrior-iii-vs-half-moon",
    title: "WARRIOR III VS HALF MOON",
    url: "https://www.betheshyft.com/community/thread/MjA3Njg/warrior-iii-vs-half-moon/",
  },
  {
    id: 20765,
    slug: "hugging-trees",
    title: "🌲🌳Hugging trees 🌲🌳",
    url: "https://www.betheshyft.com/community/thread/MjA3NjU/hugging-trees/",
  },
  {
    id: 20749,
    slug: "chair-pose-with-a-twist-ultimate-yoga-day",
    title: "Chair pose with a twist #Ultimate Yoga Day Challenge",
    url: "https://www.betheshyft.com/community/thread/MjA3NDk/chair-pose-with-a-twist-ultimate-yoga-day/",
  },
  {
    id: 20735,
    slug: "day-9-the-ultimate-yoga-day-challenge",
    title: "Day-9 'The ultimate yoga day challenge'",
    url: "https://www.betheshyft.com/community/thread/MjA3MzU/day-9-the-ultimate-yoga-day-challenge/",
  },
  {
    id: 20697,
    slug: "how-does-exercise-help",
    title: "How does exercise help❓",
    url: "https://www.betheshyft.com/community/thread/MjA2OTc/how-does-exercise-help/",
  },
  {
    id: 20583,
    slug: "day-11-double-big-toe-pose-the-ultimate",
    title: "Day 11: Double Big Toe Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjA1ODM/day-11-double-big-toe-pose-the-ultimate/",
  },
  {
    id: 20480,
    slug: "day-10-lizard-pose-the-ultimate-yoga-day",
    title: "Day 10: Lizard Pose (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjA0ODA/day-10-lizard-pose-the-ultimate-yoga-day/",
  },
  {
    id: 20413,
    slug: "soilder-pose",
    title: "Soilder pose. 🎖️",
    url: "https://www.betheshyft.com/community/thread/MjA0MTM/soilder-pose/",
  },
  {
    id: 20387,
    slug: "tips-for-a-healthy-weekend",
    title: "Tips for a Healthy Weekend",
    url: "https://www.betheshyft.com/community/thread/MjAzODc/tips-for-a-healthy-weekend/",
  },
  {
    id: 20341,
    slug: "why-walk-during-pregnancy",
    title: "Why walk during pregnancy?",
    url: "https://www.betheshyft.com/community/thread/MjAzNDE/why-walk-during-pregnancy/",
  },
  {
    id: 20295,
    slug: "day-9-pyramid-pose-the-ultimate-yoga-day",
    title: "Day 9: Pyramid Pose ( The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MjAyOTU/day-9-pyramid-pose-the-ultimate-yoga-day/",
  },
  {
    id: 20235,
    slug: "picture-says-it-all",
    title: "Picture says it all",
    url: "https://www.betheshyft.com/community/thread/MjAyMzU/picture-says-it-all/",
  },
  {
    id: 20224,
    slug: "try-this-blinking-exercise-for-dry-eyes",
    title: "Try this Blinking Exercise for Dry Eyes",
    url: "https://www.betheshyft.com/community/thread/MjAyMjQ/try-this-blinking-exercise-for-dry-eyes/",
  },
  {
    id: 20211,
    slug: "less-time-to-cook-make-this",
    title: "Less time to cook? Make this! 🤤",
    url: "https://www.betheshyft.com/community/thread/MjAyMTE/less-time-to-cook-make-this/",
  },
  {
    id: 20196,
    slug: "day-8-ultimate-yoga-day-challenge",
    title: "Day 8- Ultimate Yoga Day Challenge",
    url: "https://www.betheshyft.com/community/thread/MjAxOTY/day-8-ultimate-yoga-day-challenge/",
  },
  {
    id: 20192,
    slug: "day-6-the-ultimate-yoga-day-challenge",
    title: "Day-6 : The ultimate yoga day challenge",
    url: "https://www.betheshyft.com/community/thread/MjAxOTI/day-6-the-ultimate-yoga-day-challenge/",
  },
  {
    id: 20184,
    slug: "poll-results-2",
    title: "Poll results 2",
    url: "https://www.betheshyft.com/community/thread/MjAxODQ/poll-results-2/",
  },
  {
    id: 20108,
    slug: "hyperthyroidism-overactive-thyroid-gland-excess-thyroid-hormone-speeds",
    title:
      "HYPERTHYROIDISM ( overactive thyroid gland - excess thyroid hormone)  speeds up  body metabolism.  Symptoms include weight loss, hand tremors and rapid or irregular heartbeat. What to eat & what not to ? Read on....",
    url: "https://www.betheshyft.com/community/thread/MjAxMDg/hyperthyroidism-overactive-thyroid-gland-excess-thyroid-hormone-speeds/",
  },
  {
    id: 20035,
    slug: "yoga-poses-to-get-rid-of-fatigue",
    title: "Yoga poses to get rid of fatigue",
    url: "https://www.betheshyft.com/community/thread/MjAwMzU/yoga-poses-to-get-rid-of-fatigue/",
  },
  {
    id: 20034,
    slug: "soluble-fibre-rich-foods-my-top-9-selections",
    title: "Soluble Fibre rich foods - My top 9 selections",
    url: "https://www.betheshyft.com/community/thread/MjAwMzQ/soluble-fibre-rich-foods-my-top-9-selections/",
  },
  {
    id: 19963,
    slug: "day-7-downward-facing-dog-the-ultimate-yoga",
    title: "Day 7: Downward Facing Dog (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MTk5NjM/day-7-downward-facing-dog-the-ultimate-yoga/",
  },
  {
    id: 19952,
    slug: "poor-posture",
    title: "Poor Posture",
    url: "https://www.betheshyft.com/community/thread/MTk5NTI/poor-posture/",
  },
  {
    id: 19929,
    slug: "start-your-day-with-lot-of-positivity-in",
    title: "Start your day with lot of positivity in you👍",
    url: "https://www.betheshyft.com/community/thread/MTk5Mjk/start-your-day-with-lot-of-positivity-in/",
  },
  {
    id: 19797,
    slug: "side-bend",
    title: "Side Bend !",
    url: "https://www.betheshyft.com/community/thread/MTk3OTc/side-bend/",
  },
  {
    id: 19791,
    slug: "health-benefits-of-daily-breathwork",
    title: "Health Benefits of Daily Breathwork",
    url: "https://www.betheshyft.com/community/thread/MTk3OTE/health-benefits-of-daily-breathwork/",
  },
  {
    id: 19772,
    slug: "the-placebo-effect",
    title: "The placebo effect",
    url: "https://www.betheshyft.com/community/thread/MTk3NzI/the-placebo-effect/",
  },
  {
    id: 19744,
    slug: "hypothyroidism-what-should-be-taken-what-shouldn-t",
    title: "HYPOTHYROIDISM....what should be taken & what shouldn't be ???",
    url: "https://www.betheshyft.com/community/thread/MTk3NDQ/hypothyroidism-what-should-be-taken-what-shouldn-t/",
  },
  {
    id: 19674,
    slug: "uterine-prolapse",
    title: "Uterine Prolapse",
    url: "https://www.betheshyft.com/community/thread/MTk2NzQ/uterine-prolapse/",
  },
  {
    id: 19634,
    slug: "how-do-i-know-if-i-m-drinking",
    title:
      "How do I know if I'm drinking enough? And Should I worry about drinking too much water ?",
    url: "https://www.betheshyft.com/community/thread/MTk2MzQ/how-do-i-know-if-i-m-drinking/",
  },
  {
    id: 19633,
    slug: "is-water-the-only-option-for-staying-hydrated",
    title: "Is water the only option for staying hydrated?",
    url: "https://www.betheshyft.com/community/thread/MTk2MzM/is-water-the-only-option-for-staying-hydrated/",
  },
  {
    id: 19603,
    slug: "what-about-the-advice-to-drink-8-glasses",
    title: "What about the advice to drink 8 glasses a day?",
    url: "https://www.betheshyft.com/community/thread/MTk2MDM/what-about-the-advice-to-drink-8-glasses/",
  },
  {
    id: 19589,
    slug: "how-much-water-do-you-need",
    title: "How much water do you need?",
    url: "https://www.betheshyft.com/community/thread/MTk1ODk/how-much-water-do-you-need/",
  },
  {
    id: 19587,
    slug: "what-are-the-health-benefits-of-water",
    title: "What are the health benefits of water?",
    url: "https://www.betheshyft.com/community/thread/MTk1ODc/what-are-the-health-benefits-of-water/",
  },
  {
    id: 19581,
    slug: "day-5-ultimate-yoga-challenge",
    title: "Day 5 #ultimate yoga challenge",
    url: "https://www.betheshyft.com/community/thread/MTk1ODE/day-5-ultimate-yoga-challenge/",
  },
  {
    id: 19573,
    slug: "alternate-nostril-breathing",
    title: "Alternate nostril breathing",
    url: "https://www.betheshyft.com/community/thread/MTk1NzM/alternate-nostril-breathing/",
  },
  {
    id: 19567,
    slug: "day-5-ultimate-yoga-day-challenge",
    title: "Day 5- Ultimate Yoga Day Challenge",
    url: "https://www.betheshyft.com/community/thread/MTk1Njc/day-5-ultimate-yoga-day-challenge/",
  },
  {
    id: 19548,
    slug: "extended-hand-to-big-toe-pose",
    title: "Extended Hand to Big Toe Pose",
    url: "https://www.betheshyft.com/community/thread/MTk1NDg/extended-hand-to-big-toe-pose/",
  },
  {
    id: 19490,
    slug: "day-4-reverse-warrior-pose-the-ultimate-yoga",
    title: "Day 4: Reverse Warrior Pose ( The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MTk0OTA/day-4-reverse-warrior-pose-the-ultimate-yoga/",
  },
  {
    id: 19462,
    slug: "what-causes-low-energy",
    title: "What Causes Low Energy?",
    url: "https://www.betheshyft.com/community/thread/MTk0NjI/what-causes-low-energy/",
  },
  {
    id: 19461,
    slug: "understanding-hypothyroidism-better-hypothyroidism-less-functioning-of-thyroid",
    title:
      "Understanding HYPOTHYROIDISM better !! Hypothyroidism = less functioning of thyroid gland",
    url: "https://www.betheshyft.com/community/thread/MTk0NjE/understanding-hypothyroidism-better-hypothyroidism-less-functioning-of-thyroid/",
  },
  {
    id: 19404,
    slug: "new-mama-guilt",
    title: "New Mama Guilt...",
    url: "https://www.betheshyft.com/community/thread/MTk0MDQ/new-mama-guilt/",
  },
  {
    id: 19329,
    slug: "day-3-extended-puppy-pose-uttana-shishosana-the",
    title:
      "Day 3: Extended Puppy Pose (Uttana Shishosana) The Ultimate Yoga Day Challenge",
    url: "https://www.betheshyft.com/community/thread/MTkzMjk/day-3-extended-puppy-pose-uttana-shishosana-the/",
  },
  {
    id: 19287,
    slug: "prasarita-padottanasana-stretch",
    title: "Prasarita Padottanasana stretch",
    url: "https://www.betheshyft.com/community/thread/MTkyODc/prasarita-padottanasana-stretch/",
  },
  {
    id: 19277,
    slug: "scale-downs-of-the-postures",
    title: "Scale downs of the postures",
    url: "https://www.betheshyft.com/community/thread/MTkyNzc/scale-downs-of-the-postures/",
  },
  {
    id: 19201,
    slug: "what-to-expect-with-a-newborn",
    title: "What to expect with a newborn",
    url: "https://www.betheshyft.com/community/thread/MTkyMDE/what-to-expect-with-a-newborn/",
  },
  {
    id: 19194,
    slug: "snack-up-well-on-your-litchis-this-summer",
    title:
      "Snack up well on your Litchis this summer season ☀️As they will not lychee go of your health 😎😎",
    url: "https://www.betheshyft.com/community/thread/MTkxOTQ/snack-up-well-on-your-litchis-this-summer/",
  },
  {
    id: 19187,
    slug: "day-2-ultimate-yoga-day-challenge",
    title: "DAY 2 #ultimate yoga day challenge",
    url: "https://www.betheshyft.com/community/thread/MTkxODc/day-2-ultimate-yoga-day-challenge/",
  },
  {
    id: 19163,
    slug: "day-2-bharadwaja-s-twist-the-ultimate-yoga",
    title: "Day 2: Bharadwaja's Twist (The Ultimate Yoga Day Challenge)",
    url: "https://www.betheshyft.com/community/thread/MTkxNjM/day-2-bharadwaja-s-twist-the-ultimate-yoga/",
  },
  {
    id: 19084,
    slug: "supine-butterfly-pose",
    title: "Supine butterfly pose",
    url: "https://www.betheshyft.com/community/thread/MTkwODQ/supine-butterfly-pose/",
  },
  {
    id: 18987,
    slug: "day-1-urdhva-mukha-svanasana-upward-facing-dog",
    title: "Day 1: Urdhva mukha svanasana/Upward facing dog 🧘‍♀️",
    url: "https://www.betheshyft.com/community/thread/MTg5ODc/day-1-urdhva-mukha-svanasana-upward-facing-dog/",
  },
  {
    id: 18980,
    slug: "uterine-fibroids",
    title: "Uterine Fibroids",
    url: "https://www.betheshyft.com/community/thread/MTg5ODA/uterine-fibroids/",
  },
  {
    id: 18955,
    slug: "june-health-goals",
    title: "June Health Goals",
    url: "https://www.betheshyft.com/community/thread/MTg5NTU/june-health-goals/",
  },
  {
    id: 18946,
    slug: "serotonin-our-happy-hormone",
    title: "Serotonin - our happy hormone",
    url: "https://www.betheshyft.com/community/thread/MTg5NDY/serotonin-our-happy-hormone/",
  },
  {
    id: 18928,
    slug: "constantly-changing-weather",
    title: "Constantly changing weather",
    url: "https://www.betheshyft.com/community/thread/MTg5Mjg/constantly-changing-weather/",
  },
  {
    id: 18920,
    slug: "dietary-strategies-that-will-help-you-fight-your",
    title: "Dietary strategies that will help you fight your headache 💆",
    url: "https://www.betheshyft.com/community/thread/MTg5MjA/dietary-strategies-that-will-help-you-fight-your/",
  },
  {
    id: 18834,
    slug: "why-bmi",
    title: "Why BMI",
    url: "https://www.betheshyft.com/community/thread/MTg4MzQ/why-bmi/",
  },
  {
    id: 18828,
    slug: "raw-coconut-piece-as-a-snack",
    title: "Raw coconut piece as a Snack",
    url: "https://www.betheshyft.com/community/thread/MTg4Mjg/raw-coconut-piece-as-a-snack/",
  },
  {
    id: 18812,
    slug: "tips-of-getting-a-good-sleep",
    title: "Tips of getting a good sleep ❤️",
    url: "https://www.betheshyft.com/community/thread/MTg4MTI/tips-of-getting-a-good-sleep/",
  },
  {
    id: 18809,
    slug: "importance-of-sleep",
    title: "Importance of sleep  😴",
    url: "https://www.betheshyft.com/community/thread/MTg4MDk/importance-of-sleep/",
  },
  {
    id: 18805,
    slug: "this-meal-is-homemade-in-other-words-i",
    title: "This meal is homemade, in other words I licked the spoon😋😋",
    url: "https://www.betheshyft.com/community/thread/MTg4MDU/this-meal-is-homemade-in-other-words-i/",
  },
  {
    id: 18797,
    slug: "unlock-your-shoulders-for-optimal-well-being",
    title: "Unlock your shoulders for optimal well being",
    url: "https://www.betheshyft.com/community/thread/MTg3OTc/unlock-your-shoulders-for-optimal-well-being/",
  },
  {
    id: 18787,
    slug: "prunes-dried-plums",
    title: "Prunes- Dried plums",
    url: "https://www.betheshyft.com/community/thread/MTg3ODc/prunes-dried-plums/",
  },
  {
    id: 18776,
    slug: "stay-hydrated",
    title: "Stay hydrated",
    url: "https://www.betheshyft.com/community/thread/MTg3NzY/stay-hydrated/",
  },
  {
    id: 18775,
    slug: "knee-strengthening-or-prevent-knee-injury",
    title: "Knee strengthening or prevent knee injury.",
    url: "https://www.betheshyft.com/community/thread/MTg3NzU/knee-strengthening-or-prevent-knee-injury/",
  },
  {
    id: 18756,
    slug: "the-relevance-of-breathwork",
    title: "The relevance of Breathwork",
    url: "https://www.betheshyft.com/community/thread/MTg3NTY/the-relevance-of-breathwork/",
  },
  {
    id: 18740,
    slug: "allaboutpear",
    title: "#Allaboutpear",
    url: "https://www.betheshyft.com/community/thread/MTg3NDA/allaboutpear/",
  },
  {
    id: 18734,
    slug: "making-healthy-tasty-too",
    title: "Making HEALTHY ...tasty too 🤗🤗💜",
    url: "https://www.betheshyft.com/community/thread/MTg3MzQ/making-healthy-tasty-too/",
  },
  {
    id: 18729,
    slug: "did-you-know-about-chakotra-or-grapefruit",
    title: "Did you know about chakotra Or grapefruit",
    url: "https://www.betheshyft.com/community/thread/MTg3Mjk/did-you-know-about-chakotra-or-grapefruit/",
  },
  {
    id: 18718,
    slug: "ways-to-be-active",
    title: "Ways to be active",
    url: "https://www.betheshyft.com/community/thread/MTg3MTg/ways-to-be-active/",
  },
  {
    id: 18694,
    slug: "what-women-need-to-be-checked-for-every",
    title: "What Women Need to be Checked for Every Year",
    url: "https://www.betheshyft.com/community/thread/MTg2OTQ/what-women-need-to-be-checked-for-every/",
  },
  {
    id: 18683,
    slug: "3-reasons-to-practice-nadi-shodhan-pranayama",
    title: "3 Reasons to Practice Nadi Shodhan Pranayama",
    url: "https://www.betheshyft.com/community/thread/MTg2ODM/3-reasons-to-practice-nadi-shodhan-pranayama/",
  },
  {
    id: 18682,
    slug: "are-you-doing-it-right",
    title: "Are you doing it right ?",
    url: "https://www.betheshyft.com/community/thread/MTg2ODI/are-you-doing-it-right/",
  },
  {
    id: 18665,
    slug: "superfood-chia-seeds",
    title: "Superfood - Chia seeds",
    url: "https://www.betheshyft.com/community/thread/MTg2NjU/superfood-chia-seeds/",
  },
  {
    id: 18457,
    slug: "cobra-pose-vs-upward-facing-dog",
    title: "Cobra pose vs Upward facing dog",
    url: "https://www.betheshyft.com/community/thread/MTg0NTc/cobra-pose-vs-upward-facing-dog/",
  },
  {
    id: 18446,
    slug: "exercise-for-your-pelvic-floor",
    title: "Exercise for your Pelvic Floor",
    url: "https://www.betheshyft.com/community/thread/MTg0NDY/exercise-for-your-pelvic-floor/",
  },
  {
    id: 18399,
    slug: "breathwork-is-the-key-to-bring-awareness-to",
    title: "Breathwork is the key to bring awareness to your breath 😊",
    url: "https://www.betheshyft.com/community/thread/MTgzOTk/breathwork-is-the-key-to-bring-awareness-to/",
  },
  {
    id: 18390,
    slug: "snacks-that-can-help-you-in-keeping-your",
    title: "Snacks that can help you in keeping your gut healthy 🌿",
    url: "https://www.betheshyft.com/community/thread/MTgzOTA/snacks-that-can-help-you-in-keeping-your/",
  },
  {
    id: 18387,
    slug: "benefitsofpomegranate",
    title: "#benefitsofpomegranate",
    url: "https://www.betheshyft.com/community/thread/MTgzODc/benefitsofpomegranate/",
  },
  {
    id: 18332,
    slug: "beautiful-morning",
    title: "Beautiful morning 🌄",
    url: "https://www.betheshyft.com/community/thread/MTgzMzI/beautiful-morning/",
  },
  {
    id: 18328,
    slug: "core-strengthening",
    title: "Core strengthening",
    url: "https://www.betheshyft.com/community/thread/MTgzMjg/core-strengthening/",
  },
  {
    id: 18321,
    slug: "storing-breast-milk",
    title: "Storing breast milk",
    url: "https://www.betheshyft.com/community/thread/MTgzMjE/storing-breast-milk/",
  },
  {
    id: 18320,
    slug: "home-grown-and-organic",
    title: "Home grown and organic",
    url: "https://www.betheshyft.com/community/thread/MTgzMjA/home-grown-and-organic/",
  },
  {
    id: 18309,
    slug: "avocado",
    title: "#Avocado❤",
    url: "https://www.betheshyft.com/community/thread/MTgzMDk/avocado/",
  },
  {
    id: 18285,
    slug: "let-s-fight-with-inflammation-in-our-body",
    title:
      "Let's fight with inflammation 🔥 in our body with these nutrients 🕺",
    url: "https://www.betheshyft.com/community/thread/MTgyODU/let-s-fight-with-inflammation-in-our-body/",
  },
  {
    id: 18259,
    slug: "yoga-poses-to-release-tight-shoulders",
    title: "Yoga Poses to Release Tight Shoulders",
    url: "https://www.betheshyft.com/community/thread/MTgyNTk/yoga-poses-to-release-tight-shoulders/",
  },
  {
    id: 18231,
    slug: "emotional-benefits-of-flowers",
    title: "Emotional benefits of flowers🌻",
    url: "https://www.betheshyft.com/community/thread/MTgyMzE/emotional-benefits-of-flowers/",
  },
  {
    id: 18165,
    slug: "so-true",
    title: "So true👍",
    url: "https://www.betheshyft.com/community/thread/MTgxNjU/so-true/",
  },
  {
    id: 18146,
    slug: "some-basic-yoga-poses-for-weight-loss",
    title: "Some basic yoga poses for weight loss",
    url: "https://www.betheshyft.com/community/thread/MTgxNDY/some-basic-yoga-poses-for-weight-loss/",
  },
  {
    id: 18107,
    slug: "colourful-plate-is-always-balanced",
    title: "Colourful plate is always balanced😋",
    url: "https://www.betheshyft.com/community/thread/MTgxMDc/colourful-plate-is-always-balanced/",
  },
  {
    id: 18096,
    slug: "yoga-poses-to-cool-down-the-body",
    title: "Yoga poses to cool down the body",
    url: "https://www.betheshyft.com/community/thread/MTgwOTY/yoga-poses-to-cool-down-the-body/",
  },
  {
    id: 18092,
    slug: "morning-breakfast",
    title: "Morning breakfast",
    url: "https://www.betheshyft.com/community/thread/MTgwOTI/morning-breakfast/",
  },
  {
    id: 18068,
    slug: "the-right-way-to-eat-walnuts-for-maximum",
    title: "The right way to eat walnuts for maximum health benefits",
    url: "https://www.betheshyft.com/community/thread/MTgwNjg/the-right-way-to-eat-walnuts-for-maximum/",
  },
  {
    id: 18050,
    slug: "essential-hair-nutrients",
    title: "Essential hair nutrients",
    url: "https://www.betheshyft.com/community/thread/MTgwNTA/essential-hair-nutrients/",
  },
  {
    id: 18014,
    slug: "what-causes-low-back-pain",
    title: "What causes low back pain?",
    url: "https://www.betheshyft.com/community/thread/MTgwMTQ/what-causes-low-back-pain/",
  },
  {
    id: 17953,
    slug: "pyramid-pose-parsvottonasana",
    title: "Pyramid Pose (Parsvottonasana)",
    url: "https://www.betheshyft.com/community/thread/MTc5NTM/pyramid-pose-parsvottonasana/",
  },
  {
    id: 17907,
    slug: "asana-with-names",
    title: "Asana with names👇",
    url: "https://www.betheshyft.com/community/thread/MTc5MDc/asana-with-names/",
  },
  {
    id: 17888,
    slug: "padangushthasana",
    title: "Padangushthasana",
    url: "https://www.betheshyft.com/community/thread/MTc4ODg/padangushthasana/",
  },
  {
    id: 17868,
    slug: "happy-monday-shoo-the-blues-away",
    title: "Happy Monday, shoo the blues away 💜",
    url: "https://www.betheshyft.com/community/thread/MTc4Njg/happy-monday-shoo-the-blues-away/",
  },
  {
    id: 17867,
    slug: "barley-rice-dal-diabetic-friendly",
    title: "Barley rice & dal - Diabetic friendly",
    url: "https://www.betheshyft.com/community/thread/MTc4Njc/barley-rice-dal-diabetic-friendly/",
  },
  {
    id: 17858,
    slug: "the-calf-muscle-considered-the-second-heart",
    title: "THE CALF MUSCLE- CONSIDERED THE SECOND HEART",
    url: "https://www.betheshyft.com/community/thread/MTc4NTg/the-calf-muscle-considered-the-second-heart/",
  },
  {
    id: 17854,
    slug: "did-you-know",
    title: "Did you know?",
    url: "https://www.betheshyft.com/community/thread/MTc4NTQ/did-you-know/",
  },
  {
    id: 17843,
    slug: "menopause",
    title: "Menopause",
    url: "https://www.betheshyft.com/community/thread/MTc4NDM/menopause/",
  },
  {
    id: 17792,
    slug: "did-you-know",
    title: "Did you know?",
    url: "https://www.betheshyft.com/community/thread/MTc3OTI/did-you-know/",
  },
  {
    id: 17776,
    slug: "if-u-lack-discipline-read-this",
    title: "If u Lack discipline read this ….",
    url: "https://www.betheshyft.com/community/thread/MTc3NzY/if-u-lack-discipline-read-this/",
  },
  {
    id: 17764,
    slug: "try-this-meditative-pose",
    title: "Try this meditative pose",
    url: "https://www.betheshyft.com/community/thread/MTc3NjQ/try-this-meditative-pose/",
  },
  {
    id: 17760,
    slug: "benefits-of-malasana",
    title: "Benefits of Malasana",
    url: "https://www.betheshyft.com/community/thread/MTc3NjA/benefits-of-malasana/",
  },
  {
    id: 17728,
    slug: "walking-daily",
    title: "Walking daily",
    url: "https://www.betheshyft.com/community/thread/MTc3Mjg/walking-daily/",
  },
  {
    id: 17727,
    slug: "vrikshasana",
    title: "# Vrikshasana",
    url: "https://www.betheshyft.com/community/thread/MTc3Mjc/vrikshasana/",
  },
  {
    id: 17701,
    slug: "effects-of-sitting-posture",
    title: "Effects of Sitting Posture",
    url: "https://www.betheshyft.com/community/thread/MTc3MDE/effects-of-sitting-posture/",
  },
  {
    id: 17691,
    slug: "spending-time-with-nature-shyftyourhealth",
    title: "Spending time with nature🍃 #shyftyourhealth",
    url: "https://www.betheshyft.com/community/thread/MTc2OTE/spending-time-with-nature-shyftyourhealth/",
  },
  {
    id: 17686,
    slug: "do-you-know",
    title: "Do you know ?",
    url: "https://www.betheshyft.com/community/thread/MTc2ODY/do-you-know/",
  },
  {
    id: 17675,
    slug: "what-happens-when-you-squat-while-using-the",
    title: "What happens when you squat while using the Toilet.",
    url: "https://www.betheshyft.com/community/thread/MTc2NzU/what-happens-when-you-squat-while-using-the/",
  },
  {
    id: 17638,
    slug: "self-care-weekend",
    title: "Self-Care Weekend",
    url: "https://www.betheshyft.com/community/thread/MTc2Mzg/self-care-weekend/",
  },
  {
    id: 17619,
    slug: "good-way-to-start-your-day",
    title: "Good way to start your day..",
    url: "https://www.betheshyft.com/community/thread/MTc2MTk/good-way-to-start-your-day/",
  },
  {
    id: 17564,
    slug: "acro-yoga",
    title: "Acro Yoga",
    url: "https://www.betheshyft.com/community/thread/MTc1NjQ/acro-yoga/",
  },
  {
    id: 17549,
    slug: "10-ways-to-stimulate-your-vagus-nerve",
    title: "10 ways to stimulate your Vagus Nerve",
    url: "https://www.betheshyft.com/community/thread/MTc1NDk/10-ways-to-stimulate-your-vagus-nerve/",
  },
  {
    id: 17540,
    slug: "daily-planner-shyftyourhealth",
    title: "Daily Planner #shyftyourhealth",
    url: "https://www.betheshyft.com/community/thread/MTc1NDA/daily-planner-shyftyourhealth/",
  },
  {
    id: 17501,
    slug: "repetitive-practice-boredom",
    title: "Repetitive Practice & Boredom",
    url: "https://www.betheshyft.com/community/thread/MTc1MDE/repetitive-practice-boredom/",
  },
  {
    id: 17500,
    slug: "just-keep-going",
    title: "Just keep going ❤️",
    url: "https://www.betheshyft.com/community/thread/MTc1MDA/just-keep-going/",
  },
  {
    id: 17488,
    slug: "day-4-shyfttohealthyhabit",
    title: "Day 4 #shyftToHealthyHabit 🥗",
    url: "https://www.betheshyft.com/community/thread/MTc0ODg/day-4-shyfttohealthyhabit/",
  },
  {
    id: 17474,
    slug: "food-for-gut-health",
    title: "Food for gut health",
    url: "https://www.betheshyft.com/community/thread/MTc0NzQ/food-for-gut-health/",
  },
  {
    id: 17473,
    slug: "why-savasana-is-important",
    title: "Why Savasana is important ?",
    url: "https://www.betheshyft.com/community/thread/MTc0NzM/why-savasana-is-important/",
  },
  {
    id: 17454,
    slug: "what-is-basal-metabolic-rate-and-how-can",
    title:
      "What is Basal Metabolic Rate and how can you boost your metabolism ?! 🧐",
    url: "https://www.betheshyft.com/community/thread/MTc0NTQ/what-is-basal-metabolic-rate-and-how-can/",
  },
  {
    id: 17445,
    slug: "burning-calories-shyftyourhealth",
    title: "Burning calories #shyftyourhealth",
    url: "https://www.betheshyft.com/community/thread/MTc0NDU/burning-calories-shyftyourhealth/",
  },
  {
    id: 17426,
    slug: "matsyasana-fish-pose",
    title: "Matsyasana (Fish Pose)",
    url: "https://www.betheshyft.com/community/thread/MTc0MjY/matsyasana-fish-pose/",
  },
  {
    id: 17424,
    slug: "gate-pose-twist-by-highbp-warriors",
    title: "Gate Pose Twist by  HighBp warriors  🪖",
    url: "https://www.betheshyft.com/community/thread/MTc0MjQ/gate-pose-twist-by-highbp-warriors/",
  },
  {
    id: 17407,
    slug: "re-using-fried-oil-is-this-a-good",
    title: 'RE USING  " FRIED OIL" ?? Is this a good choice  🤔🤔',
    url: "https://www.betheshyft.com/community/thread/MTc0MDc/re-using-fried-oil-is-this-a-good/",
  },
  {
    id: 17345,
    slug: "hot-water-with-a-pinch-of-coffee-instant",
    title:
      "Hot water with a pinch of coffee (Instant energizer) #shyftyourhealth",
    url: "https://www.betheshyft.com/community/thread/MTczNDU/hot-water-with-a-pinch-of-coffee-instant/",
  },
  {
    id: 17334,
    slug: "day-2-my-healthy-habit-to-have-balanced",
    title:
      "Day 2: My healthy habit ( to have balanced meals for the next 7 days)",
    url: "https://www.betheshyft.com/community/thread/MTczMzQ/day-2-my-healthy-habit-to-have-balanced/",
  },
  {
    id: 17322,
    slug: "be-consistent-in-your-efforts-to-achieve-your",
    title: "Be consistent in your efforts to achieve your Health goal!",
    url: "https://www.betheshyft.com/community/thread/MTczMjI/be-consistent-in-your-efforts-to-achieve-your/",
  },
  {
    id: 17321,
    slug: "healthy-habits-challenge",
    title: "Healthy habits challenge",
    url: "https://www.betheshyft.com/community/thread/MTczMjE/healthy-habits-challenge/",
  },
  {
    id: 17302,
    slug: "make-your-8-limb-posture-better",
    title: "Make your 8 limb posture better!",
    url: "https://www.betheshyft.com/community/thread/MTczMDI/make-your-8-limb-posture-better/",
  },
  {
    id: 17292,
    slug: "benefits-of-balancing-poses",
    title: "Benefits of Balancing Poses",
    url: "https://www.betheshyft.com/community/thread/MTcyOTI/benefits-of-balancing-poses/",
  },
  {
    id: 17198,
    slug: "shyft-to-daily-healthy-habit-challenge",
    title: "Shyft to Daily Healthy Habit Challenge ❤️",
    url: "https://www.betheshyft.com/community/thread/MTcxOTg/shyft-to-daily-healthy-habit-challenge/",
  },
  {
    id: 17171,
    slug: "shyft-to-daily-healthy-habit-challenge",
    title: "Shyft to Daily Healthy Habit Challenge",
    url: "https://www.betheshyft.com/community/thread/MTcxNzE/shyft-to-daily-healthy-habit-challenge/",
  },
  {
    id: 17166,
    slug: "green-tea-a-step-to-build-up-healthy",
    title: "Green tea - a step to build up healthy habbit",
    url: "https://www.betheshyft.com/community/thread/MTcxNjY/green-tea-a-step-to-build-up-healthy/",
  },
  {
    id: 17163,
    slug: "healthy-ragi-cookies-snacks-ideas",
    title: "Healthy Ragi cookies - snacks ideas.",
    url: "https://www.betheshyft.com/community/thread/MTcxNjM/healthy-ragi-cookies-snacks-ideas/",
  },
  {
    id: 17136,
    slug: "hip-hip-hooray",
    title: "Hip Hip Hooray!!",
    url: "https://www.betheshyft.com/community/thread/MTcxMzY/hip-hip-hooray/",
  },
  {
    id: 17094,
    slug: "have-a-productive-sunday",
    title: "Have a productive Sunday!",
    url: "https://www.betheshyft.com/community/thread/MTcwOTQ/have-a-productive-sunday/",
  },
  {
    id: 17093,
    slug: "detox-water-make-it-a-basic-ingredient-of",
    title: "Detox water- Make it a basic ingredient of your lifestyle!",
    url: "https://www.betheshyft.com/community/thread/MTcwOTM/detox-water-make-it-a-basic-ingredient-of/",
  },
  {
    id: 17089,
    slug: "evening-snack-roasted-makhana",
    title: "Evening snack - Roasted Makhana",
    url: "https://www.betheshyft.com/community/thread/MTcwODk/evening-snack-roasted-makhana/",
  },
  {
    id: 17076,
    slug: "ananda-balasana-orhappy-baby-pose",
    title: "Ananda balasana or Happy baby pose",
    url: "https://www.betheshyft.com/community/thread/MTcwNzY/ananda-balasana-orhappy-baby-pose/",
  },
  {
    id: 17063,
    slug: "my-breakfast-today",
    title: "My breakfast today 😋",
    url: "https://www.betheshyft.com/community/thread/MTcwNjM/my-breakfast-today/",
  },
  {
    id: 17035,
    slug: "empowering-your-practice-the-power-of-positive-affirmations",
    title: "Empowering Your Practice: The power of positive affirmations",
    url: "https://www.betheshyft.com/community/thread/MTcwMzU/empowering-your-practice-the-power-of-positive-affirmations/",
  },
  {
    id: 17030,
    slug: "watermelon-special-post-workout-smoothie",
    title: "Watermelon special - Post workout smoothie",
    url: "https://www.betheshyft.com/community/thread/MTcwMzA/watermelon-special-post-workout-smoothie/",
  },
  {
    id: 17028,
    slug: "take-a-break",
    title: "Take a BREAK😊✨",
    url: "https://www.betheshyft.com/community/thread/MTcwMjg/take-a-break/",
  },
  {
    id: 17026,
    slug: "sarvangasana",
    title: "Sarvangasana",
    url: "https://www.betheshyft.com/community/thread/MTcwMjY/sarvangasana/",
  },
  {
    id: 17015,
    slug: "breathing-trivia",
    title: "Breathing Trivia",
    url: "https://www.betheshyft.com/community/thread/MTcwMTU/breathing-trivia/",
  },
  {
    id: 17014,
    slug: "sunny-yoga",
    title: "Sunny ☀️ yoga",
    url: "https://www.betheshyft.com/community/thread/MTcwMTQ/sunny-yoga/",
  },
  {
    id: 17007,
    slug: "basic-posture-to-reduce-back-stiffness",
    title: "Basic posture to reduce back stiffness",
    url: "https://www.betheshyft.com/community/thread/MTcwMDc/basic-posture-to-reduce-back-stiffness/",
  },
  {
    id: 17001,
    slug: "stay-healthy-in-the-heat",
    title: "Stay healthy in the heat!",
    url: "https://www.betheshyft.com/community/thread/MTcwMDE/stay-healthy-in-the-heat/",
  },
  {
    id: 16990,
    slug: "half-lord-of-the-fish-pose-a-super",
    title: "HALF LORD OF THE FISH POSE. A super pose for Diabetes",
    url: "https://www.betheshyft.com/community/thread/MTY5OTA/half-lord-of-the-fish-pose-a-super/",
  },
  {
    id: 16984,
    slug: "hanumanasana",
    title: "HANUMANASANA",
    url: "https://www.betheshyft.com/community/thread/MTY5ODQ/hanumanasana/",
  },
  {
    id: 16976,
    slug: "do-not-skip-savasana-after-practice",
    title: "Do not skip savasana after practice ✨️",
    url: "https://www.betheshyft.com/community/thread/MTY5NzY/do-not-skip-savasana-after-practice/",
  },
  {
    id: 16972,
    slug: "humming-bee-breathwork-wellnessenergy",
    title: "Humming Bee Breathwork #WellnessEnergy✨",
    url: "https://www.betheshyft.com/community/thread/MTY5NzI/humming-bee-breathwork-wellnessenergy/",
  },
  {
    id: 16951,
    slug: "healthy-habits",
    title: "Healthy habits 😊",
    url: "https://www.betheshyft.com/community/thread/MTY5NTE/healthy-habits/",
  },
  {
    id: 16950,
    slug: "smile",
    title: "Smile 😃",
    url: "https://www.betheshyft.com/community/thread/MTY5NTA/smile/",
  },
  {
    id: 16947,
    slug: "check-this",
    title: "Check this✅",
    url: "https://www.betheshyft.com/community/thread/MTY5NDc/check-this/",
  },
  {
    id: 16934,
    slug: "how-to-mentally-and-emotionally-prepare-for-both",
    title: "How to mentally and emotionally prepare for both",
    url: "https://www.betheshyft.com/community/thread/MTY5MzQ/how-to-mentally-and-emotionally-prepare-for-both/",
  },
  {
    id: 16930,
    slug: "the-healthier-twist-to-notorious-potatoes-secret-is",
    title:
      "The HEALTHIER twist to notorious POTATOES !! [ secret is to step up fiber in the potato  dish & thus bring down its glycemic index] !!",
    url: "https://www.betheshyft.com/community/thread/MTY5MzA/the-healthier-twist-to-notorious-potatoes-secret-is/",
  },
  {
    id: 16929,
    slug: "yoga-for-life-with-greater-joy-and-productivity",
    title: "Yoga for life with greater joy and productivity",
    url: "https://www.betheshyft.com/community/thread/MTY5Mjk/yoga-for-life-with-greater-joy-and-productivity/",
  },
  {
    id: 16928,
    slug: "a-proud-moment",
    title: "A Proud moment",
    url: "https://www.betheshyft.com/community/thread/MTY5Mjg/a-proud-moment/",
  },
  {
    id: 16925,
    slug: "right-posture-matters",
    title: "Right posture matters!",
    url: "https://www.betheshyft.com/community/thread/MTY5MjU/right-posture-matters/",
  },
  {
    id: 16893,
    slug: "downward-facing-dog",
    title: "Downward Facing Dog",
    url: "https://www.betheshyft.com/community/thread/MTY4OTM/downward-facing-dog/",
  },
  {
    id: 16881,
    slug: "will-baby-steps-really-help-me-get-to",
    title: "Will BABY STEPS really help me get to my goals ??",
    url: "https://www.betheshyft.com/community/thread/MTY4ODE/will-baby-steps-really-help-me-get-to/",
  },
  {
    id: 16868,
    slug: "loosening-practices",
    title: "Loosening practices.",
    url: "https://www.betheshyft.com/community/thread/MTY4Njg/loosening-practices/",
  },
  {
    id: 16866,
    slug: "jamuns-commonly-known-as-indian-blackberry-java-plum",
    title:
      "Jamuns commonly known as Indian blackberry, java plum or black plum are receiving attention as a health- protective functional food 🫐",
    url: "https://www.betheshyft.com/community/thread/MTY4NjY/jamuns-commonly-known-as-indian-blackberry-java-plum/",
  },
  {
    id: 16863,
    slug: "locust-pose-variation-working-those-back-muscles",
    title: "Locust pose variation- working those back muscles",
    url: "https://www.betheshyft.com/community/thread/MTY4NjM/locust-pose-variation-working-those-back-muscles/",
  },
  {
    id: 16859,
    slug: "half-moon-pose",
    title: "Half Moon Pose",
    url: "https://www.betheshyft.com/community/thread/MTY4NTk/half-moon-pose/",
  },
  {
    id: 16812,
    slug: "wrist-and-forearm-stretches",
    title: "Wrist and forearm stretches",
    url: "https://www.betheshyft.com/community/thread/MTY4MTI/wrist-and-forearm-stretches/",
  },
  {
    id: 16811,
    slug: "energizing-feeling-confident-with-back-bends",
    title: "Energizing & feeling confident with back bends",
    url: "https://www.betheshyft.com/community/thread/MTY4MTE/energizing-feeling-confident-with-back-bends/",
  },
  {
    id: 16800,
    slug: "dessert-se-taste-bhi-aur-health-bhi-mango",
    title: "Dessert se taste bhi aur health bhi- Mango Tapioca pudding",
    url: "https://www.betheshyft.com/community/thread/MTY4MDA/dessert-se-taste-bhi-aur-health-bhi-mango/",
  },
  {
    id: 16787,
    slug: "balancing-poses",
    title: "Balancing poses",
    url: "https://www.betheshyft.com/community/thread/MTY3ODc/balancing-poses/",
  },
  {
    id: 16784,
    slug: "drinking-lukewarm-water-empty-stomach",
    title: "Drinking lukewarm water empty stomach",
    url: "https://www.betheshyft.com/community/thread/MTY3ODQ/drinking-lukewarm-water-empty-stomach/",
  },
  {
    id: 16769,
    slug: "holding-the-inversions",
    title: "Holding the Inversions",
    url: "https://www.betheshyft.com/community/thread/MTY3Njk/holding-the-inversions/",
  },
  {
    id: 16753,
    slug: "online-yoga-class-yay-or-nah",
    title: "ONLINE YOGA CLASS.... YAY OR NAH?",
    url: "https://www.betheshyft.com/community/thread/MTY3NTM/online-yoga-class-yay-or-nah/",
  },
  {
    id: 16747,
    slug: "natural-healers",
    title: "Natural Healers",
    url: "https://www.betheshyft.com/community/thread/MTY3NDc/natural-healers/",
  },
  {
    id: 16733,
    slug: "visualization-practice",
    title: "Visualization practice",
    url: "https://www.betheshyft.com/community/thread/MTY3MzM/visualization-practice/",
  },
  {
    id: 16730,
    slug: "breath-is-the-bridge",
    title: "Breath is the bridge",
    url: "https://www.betheshyft.com/community/thread/MTY3MzA/breath-is-the-bridge/",
  },
  {
    id: 16729,
    slug: "cortisol-is-a-stress-harmony-and-it-is",
    title:
      "Cortisol is a stress harmony and it is bad right or does it have any other functions that help us to leave better?",
    url: "https://www.betheshyft.com/community/thread/MTY3Mjk/cortisol-is-a-stress-harmony-and-it-is/",
  },
  {
    id: 16720,
    slug: "3-easy-kitchen-hacks-to-get-rid-of",
    title: "3 easy kitchen hacks to get rid of bloating",
    url: "https://www.betheshyft.com/community/thread/MTY3MjA/3-easy-kitchen-hacks-to-get-rid-of/",
  },
  {
    id: 16712,
    slug: "standing-forward-fold",
    title: "Standing Forward Fold",
    url: "https://www.betheshyft.com/community/thread/MTY3MTI/standing-forward-fold/",
  },
  {
    id: 16686,
    slug: "toddler-approved-nutty-chocolate-bars",
    title: "✔️Toddler approved - Nutty chocolate bars !! 🍫😊👍",
    url: "https://www.betheshyft.com/community/thread/MTY2ODY/toddler-approved-nutty-chocolate-bars/",
  },
  {
    id: 16680,
    slug: "back-bends",
    title: "Back bends",
    url: "https://www.betheshyft.com/community/thread/MTY2ODA/back-bends/",
  },
  {
    id: 16661,
    slug: "the-best-asana-to-practice-right-after-a",
    title: "The best asana to practice right after a Full meal",
    url: "https://www.betheshyft.com/community/thread/MTY2NjE/the-best-asana-to-practice-right-after-a/",
  },
  {
    id: 16648,
    slug: "how-breathing-and-posture-are-co-related",
    title: "How breathing and posture are co-related??",
    url: "https://www.betheshyft.com/community/thread/MTY2NDg/how-breathing-and-posture-are-co-related/",
  },
  {
    id: 16605,
    slug: "top-4-micronutrients-needed-for-a-healthy-thyroid",
    title: "Top 4 micronutrients needed for a healthy thyroid function",
    url: "https://www.betheshyft.com/community/thread/MTY2MDU/top-4-micronutrients-needed-for-a-healthy-thyroid/",
  },
  {
    id: 16555,
    slug: "is-fruit-juice-healthy",
    title: "Is fruit juice healthy ?",
    url: "https://www.betheshyft.com/community/thread/MTY1NTU/is-fruit-juice-healthy/",
  },
  {
    id: 16551,
    slug: "today-s-breakfast-mango-oatmeal",
    title: "Today's breakfast- Mango Oatmeal",
    url: "https://www.betheshyft.com/community/thread/MTY1NTE/today-s-breakfast-mango-oatmeal/",
  },
  {
    id: 16549,
    slug: "buddha-purnima",
    title: "Buddha Purnima 🌕",
    url: "https://www.betheshyft.com/community/thread/MTY1NDk/buddha-purnima/",
  },
  {
    id: 16545,
    slug: "to-our-summer-favourite-the-nariyal-pani-and",
    title: "To our summer favourite : The Nariyal Pani and Malai🥥",
    url: "https://www.betheshyft.com/community/thread/MTY1NDU/to-our-summer-favourite-the-nariyal-pani-and/",
  },
  {
    id: 16531,
    slug: "why-should-all-the-compliments-be-around-physical",
    title: "Why should all the compliments be around physical attributes?",
    url: "https://www.betheshyft.com/community/thread/MTY1MzE/why-should-all-the-compliments-be-around-physical/",
  },
  {
    id: 16525,
    slug: "let-s-work-on-hip-flexibility-today",
    title: "Let's work on hip flexibility today ✅",
    url: "https://www.betheshyft.com/community/thread/MTY1MjU/let-s-work-on-hip-flexibility-today/",
  },
  {
    id: 16478,
    slug: "whenever-you-feel-stressed-just-calm-the-mind",
    title: "Whenever you feel stressed- just calm the mind😊",
    url: "https://www.betheshyft.com/community/thread/MTY0Nzg/whenever-you-feel-stressed-just-calm-the-mind/",
  },
  {
    id: 16463,
    slug: "sleep",
    title: "Sleep😴😴",
    url: "https://www.betheshyft.com/community/thread/MTY0NjM/sleep/",
  },
  {
    id: 16456,
    slug: "rainfall",
    title: "Rainfall 🌧️🌧️",
    url: "https://www.betheshyft.com/community/thread/MTY0NTY/rainfall/",
  },
  {
    id: 16444,
    slug: "learn-meditation-and-empower-yourself-with-a-better",
    title:
      "Learn meditation and empower yourself with a better decision-making ability.",
    url: "https://www.betheshyft.com/community/thread/MTY0NDQ/learn-meditation-and-empower-yourself-with-a-better/",
  },
  {
    id: 16343,
    slug: "sitz-bath-for-postpartum",
    title: "Sitz bath for postpartum",
    url: "https://www.betheshyft.com/community/thread/MTYzNDM/sitz-bath-for-postpartum/",
  },
  {
    id: 16331,
    slug: "butterfly-pose",
    title: "Butterfly pose 🦋",
    url: "https://www.betheshyft.com/community/thread/MTYzMzE/butterfly-pose/",
  },
  {
    id: 16323,
    slug: "progressive-muscle-relaxation-pmr",
    title: "Progressive muscle relaxation (PMR)",
    url: "https://www.betheshyft.com/community/thread/MTYzMjM/progressive-muscle-relaxation-pmr/",
  },
  {
    id: 16309,
    slug: "together-getting-stronger-every-day",
    title: "Together getting stronger every day!",
    url: "https://www.betheshyft.com/community/thread/MTYzMDk/together-getting-stronger-every-day/",
  },
  {
    id: 16302,
    slug: "positive-affirmation-practice",
    title: "Positive Affirmation Practice",
    url: "https://www.betheshyft.com/community/thread/MTYzMDI/positive-affirmation-practice/",
  },
  {
    id: 16296,
    slug: "vitamin-c-fresh-food-vitamin",
    title: "Vitamin C - fresh food vitamin",
    url: "https://www.betheshyft.com/community/thread/MTYyOTY/vitamin-c-fresh-food-vitamin/",
  },
  {
    id: 16229,
    slug: "anjaneyasana-relieves-sciatica-other-spinal-conditions",
    title: "Anjaneyasana - Relieves Sciatica & other spinal conditions.",
    url: "https://www.betheshyft.com/community/thread/MTYyMjk/anjaneyasana-relieves-sciatica-other-spinal-conditions/",
  },
  {
    id: 16218,
    slug: "endorphins-the-happy-hormones",
    title: "Endorphins- The Happy Hormones😃",
    url: "https://www.betheshyft.com/community/thread/MTYyMTg/endorphins-the-happy-hormones/",
  },
  {
    id: 16158,
    slug: "sleepy-time",
    title: "Sleepy time 💤😴",
    url: "https://www.betheshyft.com/community/thread/MTYxNTg/sleepy-time/",
  },
  {
    id: 16155,
    slug: "dhanurasana-bow-pose",
    title: "Dhanurasana/ Bow Pose",
    url: "https://www.betheshyft.com/community/thread/MTYxNTU/dhanurasana-bow-pose/",
  },
  {
    id: 16153,
    slug: "shalbhasana-advance-pose",
    title: "Shalbhasana (Advance pose)",
    url: "https://www.betheshyft.com/community/thread/MTYxNTM/shalbhasana-advance-pose/",
  },
  {
    id: 16148,
    slug: "cheat-meal-with-colours-on-my-plate",
    title: "Cheat meal with colours on my plate 😊👍",
    url: "https://www.betheshyft.com/community/thread/MTYxNDg/cheat-meal-with-colours-on-my-plate/",
  },
  {
    id: 16132,
    slug: "upward-facing-dog-pose-allignment-check",
    title: "Upward facing dog pose allignment check",
    url: "https://www.betheshyft.com/community/thread/MTYxMzI/upward-facing-dog-pose-allignment-check/",
  },
  {
    id: 16119,
    slug: "spine-twist",
    title: "SPINE TWIST",
    url: "https://www.betheshyft.com/community/thread/MTYxMTk/spine-twist/",
  },
  {
    id: 16111,
    slug: "connect-to-the-rhythms-of-nature",
    title: "Connect to the rhythms of Nature 🍀",
    url: "https://www.betheshyft.com/community/thread/MTYxMTE/connect-to-the-rhythms-of-nature/",
  },
  {
    id: 16102,
    slug: "today-s-breakfast-oats-pancake-tea",
    title: "Today's breakfast- Oats pancake & tea",
    url: "https://www.betheshyft.com/community/thread/MTYxMDI/today-s-breakfast-oats-pancake-tea/",
  },
  {
    id: 16096,
    slug: "pranayama-practice-in-pregnancy",
    title: "Pranayama practice in pregnancy 👶",
    url: "https://www.betheshyft.com/community/thread/MTYwOTY/pranayama-practice-in-pregnancy/",
  },
  {
    id: 16085,
    slug: "phosphorous",
    title: "Phosphorous",
    url: "https://www.betheshyft.com/community/thread/MTYwODU/phosphorous/",
  },
  {
    id: 15979,
    slug: "strenth-training-myth-or-reality-for-joint-pain",
    title: "Strenth training myth or reality( for joint pain) ?",
    url: "https://www.betheshyft.com/community/thread/MTU5Nzk/strenth-training-myth-or-reality-for-joint-pain/",
  },
  {
    id: 15844,
    slug: "yoga-nidra",
    title: "Yoga nidra",
    url: "https://www.betheshyft.com/community/thread/MTU4NDQ/yoga-nidra/",
  },
  {
    id: 15776,
    slug: "hidden-secrets-of-hips",
    title: "Hidden secrets of Hips. 🧐",
    url: "https://www.betheshyft.com/community/thread/MTU3NzY/hidden-secrets-of-hips/",
  },
  {
    id: 15774,
    slug: "lions-breathing",
    title: "Lion’s Breathing",
    url: "https://www.betheshyft.com/community/thread/MTU3NzQ/lions-breathing/",
  },
  {
    id: 15719,
    slug: "a-perfect-recipe-for-disaster",
    title: "A perfect recipe for disaster?🤕",
    url: "https://www.betheshyft.com/community/thread/MTU3MTk/a-perfect-recipe-for-disaster/",
  },
  {
    id: 15697,
    slug: "colic-and-what-it-really-means",
    title: "Colic and what it really means",
    url: "https://www.betheshyft.com/community/thread/MTU2OTc/colic-and-what-it-really-means/",
  },
  {
    id: 15617,
    slug: "baby-pressure-points-on-feet-to-stop-crying",
    title: "Baby pressure points on feet to stop crying",
    url: "https://www.betheshyft.com/community/thread/MTU2MTc/baby-pressure-points-on-feet-to-stop-crying/",
  },
  {
    id: 15569,
    slug: "trace-mineral-copper-concluding-part-3-choose-traditional",
    title:
      "Trace mineral - COPPER [ concluding part -3] Choose  traditional wisdom but do it right !!",
    url: "https://www.betheshyft.com/community/thread/MTU1Njk/trace-mineral-copper-concluding-part-3-choose-traditional/",
  },
  {
    id: 15543,
    slug: "happy-monday",
    title: "Happy Monday!",
    url: "https://www.betheshyft.com/community/thread/MTU1NDM/happy-monday/",
  },
  {
    id: 15519,
    slug: "9-tips-for-a-healthy-weekend",
    title: "9 tips for a Healthy Weekend!",
    url: "https://www.betheshyft.com/community/thread/MTU1MTk/9-tips-for-a-healthy-weekend/",
  },
  {
    id: 15517,
    slug: "sunshine-vitamins-for-overall-health",
    title: "Sunshine vitamins for overall  health 🌄🏖️",
    url: "https://www.betheshyft.com/community/thread/MTU1MTc/sunshine-vitamins-for-overall-health/",
  },
  {
    id: 15516,
    slug: "trace-mineral-copper-part-2",
    title: "Trace mineral - COPPER [ Part 2]",
    url: "https://www.betheshyft.com/community/thread/MTU1MTY/trace-mineral-copper-part-2/",
  },
  {
    id: 15505,
    slug: "trace-mineral-copper-part-1",
    title: "Trace mineral -- COPPER ![ Part 1]",
    url: "https://www.betheshyft.com/community/thread/MTU1MDU/trace-mineral-copper-part-1/",
  },
  {
    id: 15439,
    slug: "are-you-sitting-correctly",
    title: "Are you sitting correctly?",
    url: "https://www.betheshyft.com/community/thread/MTU0Mzk/are-you-sitting-correctly/",
  },
  {
    id: 15395,
    slug: "enhance-iron-absorption",
    title: "Enhance iron absorption!!",
    url: "https://www.betheshyft.com/community/thread/MTUzOTU/enhance-iron-absorption/",
  },
  {
    id: 15352,
    slug: "high-functional-anxiety",
    title: "High Functional Anxiety",
    url: "https://www.betheshyft.com/community/thread/MTUzNTI/high-functional-anxiety/",
  },
  {
    id: 15308,
    slug: "power-of-breathwork",
    title: "Power of breathwork",
    url: "https://www.betheshyft.com/community/thread/MTUzMDg/power-of-breathwork/",
  },
  {
    id: 14597,
    slug: "tips-to-help-you-bounce-back-after-being",
    title: "Tips to help you bounce back after being sick",
    url: "https://www.betheshyft.com/community/thread/MTQ1OTc/tips-to-help-you-bounce-back-after-being/",
  },
  {
    id: 13792,
    slug: "do-you-skip-shavasana-in-your-class",
    title: "Do you skip shavasana in your class ?",
    url: "https://www.betheshyft.com/community/thread/MTM3OTI/do-you-skip-shavasana-in-your-class/",
  },
  {
    id: 13204,
    slug: "eat-healthy-showyourplate-challenge-accepted-12th-18th-april",
    title: "Eat healthy #showyourplate Challenge accepted! 12th-18th April",
    url: "https://www.betheshyft.com/community/thread/MTMyMDQ/eat-healthy-showyourplate-challenge-accepted-12th-18th-april/",
  },
  {
    id: 13091,
    slug: "lot-to-learn-and-discuss-on-communities",
    title: "Lot to learn and discuss on Communities!",
    url: "https://www.betheshyft.com/community/thread/MTMwOTE/lot-to-learn-and-discuss-on-communities/",
  },
  {
    id: 13086,
    slug: "lymphatic-health",
    title: "Lymphatic health",
    url: "https://www.betheshyft.com/community/thread/MTMwODY/lymphatic-health/",
  },
  {
    id: 12973,
    slug: "the-emotional-values-of-postures",
    title: "The emotional values of postures",
    url: "https://www.betheshyft.com/community/thread/MTI5NzM/the-emotional-values-of-postures/",
  },
  {
    id: 12842,
    slug: "manage-swollen-feet-during-pregnancy",
    title: "Manage swollen feet during pregnancy",
    url: "https://www.betheshyft.com/community/thread/MTI4NDI/manage-swollen-feet-during-pregnancy/",
  },
  {
    id: 12816,
    slug: "raw-banana-a-nutrition-powerhouse-that-is-easily",
    title:
      "Raw Banana - A Nutrition powerhouse that is easily available but underrated",
    url: "https://www.betheshyft.com/community/thread/MTI4MTY/raw-banana-a-nutrition-powerhouse-that-is-easily/",
  },
  {
    id: 12740,
    slug: "start-your-week-fresh",
    title: "Start your week fresh.",
    url: "https://www.betheshyft.com/community/thread/MTI3NDA/start-your-week-fresh/",
  },
  {
    id: 12722,
    slug: "the-spirit-of-never-to-give-up",
    title: "THE SPIRIT OF NEVER TO GIVE UP !!",
    url: "https://www.betheshyft.com/community/thread/MTI3MjI/the-spirit-of-never-to-give-up/",
  },
  {
    id: 12673,
    slug: "destress-and-relax-in-nature",
    title: "Destress and relax in nature",
    url: "https://www.betheshyft.com/community/thread/MTI2NzM/destress-and-relax-in-nature/",
  },
  {
    id: 12514,
    slug: "get-movin-for-your-gut-health",
    title: "Get movin' for your gut health",
    url: "https://www.betheshyft.com/community/thread/MTI1MTQ/get-movin-for-your-gut-health/",
  },
  {
    id: 12431,
    slug: "be-healthy-always",
    title: "Be Healthy always!",
    url: "https://www.betheshyft.com/community/thread/MTI0MzE/be-healthy-always/",
  },
  {
    id: 12413,
    slug: "vitamin-k-for-blood-coagulation",
    title: "Vitamin K - for blood coagulation",
    url: "https://www.betheshyft.com/community/thread/MTI0MTM/vitamin-k-for-blood-coagulation/",
  },
  {
    id: 12402,
    slug: "happy-world-health-day",
    title: "HAPPY WORLD 🌏HEALTH DAY !",
    url: "https://www.betheshyft.com/community/thread/MTI0MDI/happy-world-health-day/",
  },
  {
    id: 12366,
    slug: "oil-pulling-does-this-help",
    title: "OIL PULLING - does this help ?",
    url: "https://www.betheshyft.com/community/thread/MTIzNjY/oil-pulling-does-this-help/",
  },
  {
    id: 12346,
    slug: "cat-cow-pose-great-way-to-warm-up",
    title: "Cat & Cow Pose- Great way to warm up the spine before workout",
    url: "https://www.betheshyft.com/community/thread/MTIzNDY/cat-cow-pose-great-way-to-warm-up/",
  },
  {
    id: 12319,
    slug: "what-happens-when-you-meditate",
    title: "What happens when you meditate?",
    url: "https://www.betheshyft.com/community/thread/MTIzMTk/what-happens-when-you-meditate/",
  },
  {
    id: 12292,
    slug: "an-uncommon-but-nutritious-fruit-bael-or-wood",
    title: "An uncommon but nutritious fruit- Bael or Wood apple",
    url: "https://www.betheshyft.com/community/thread/MTIyOTI/an-uncommon-but-nutritious-fruit-bael-or-wood/",
  },
  {
    id: 12266,
    slug: "stretch-hydrate-breathe-and-relax",
    title: "Stretch, hydrate, breathe and relax",
    url: "https://www.betheshyft.com/community/thread/MTIyNjY/stretch-hydrate-breathe-and-relax/",
  },
  {
    id: 12239,
    slug: "vitamin-e-available-freely",
    title: "Vitamin E - available freely",
    url: "https://www.betheshyft.com/community/thread/MTIyMzk/vitamin-e-available-freely/",
  },
  {
    id: 12037,
    slug: "importance-of-fasting",
    title: "Importance of fasting",
    url: "https://www.betheshyft.com/community/thread/MTIwMzc/importance-of-fasting/",
  },
  {
    id: 11916,
    slug: "don-t-let-the-desk-keep-you-stiff",
    title: "Don't let the desk keep you stiff",
    url: "https://www.betheshyft.com/community/thread/MTE5MTY/don-t-let-the-desk-keep-you-stiff/",
  },
  {
    id: 11779,
    slug: "vitamin-d-for-bones",
    title: "Vitamin D for bones",
    url: "https://www.betheshyft.com/community/thread/MTE3Nzk/vitamin-d-for-bones/",
  },
  {
    id: 11768,
    slug: "down-to-earth",
    title: "Down to EARTH !!",
    url: "https://www.betheshyft.com/community/thread/MTE3Njg/down-to-earth/",
  },
  {
    id: 11723,
    slug: "try-these-tonight",
    title: "Try these tonight!",
    url: "https://www.betheshyft.com/community/thread/MTE3MjM/try-these-tonight/",
  },
  {
    id: 11643,
    slug: "confused-about-what-to-eat",
    title: "Confused about what to eat?",
    url: "https://www.betheshyft.com/community/thread/MTE2NDM/confused-about-what-to-eat/",
  },
  {
    id: 11616,
    slug: "vitamin-a",
    title: "Vitamin A",
    url: "https://www.betheshyft.com/community/thread/MTE2MTY/vitamin-a/",
  },
  {
    id: 11608,
    slug: "counter-pose-after-a-deep-back-bend",
    title: "Counter pose after a deep back bend.",
    url: "https://www.betheshyft.com/community/thread/MTE2MDg/counter-pose-after-a-deep-back-bend/",
  },
  {
    id: 11515,
    slug: "coconut-flesh-an-inexpensive-substitute-for-avocado",
    title: "Coconut flesh, an inexpensive substitute for Avocado! 🥥",
    url: "https://www.betheshyft.com/community/thread/MTE1MTU/coconut-flesh-an-inexpensive-substitute-for-avocado/",
  },
  {
    id: 11086,
    slug: "natarajasana-dancer-s-pose",
    title: "Natarajasana (Dancer's pose)",
    url: "https://www.betheshyft.com/community/thread/MTEwODY/natarajasana-dancer-s-pose/",
  },
  {
    id: 10929,
    slug: "supine-postures-for-restoration-and-relaxing",
    title: "Supine postures for restoration and relaxing",
    url: "https://www.betheshyft.com/community/thread/MTA5Mjk/supine-postures-for-restoration-and-relaxing/",
  },
  {
    id: 10918,
    slug: "sliding-into-the-weekend",
    title: "Sliding into the weekend",
    url: "https://www.betheshyft.com/community/thread/MTA5MTg/sliding-into-the-weekend/",
  },
  {
    id: 10893,
    slug: "started-my-day-with-yummy-and-healthy-breakfast",
    title: "Started my day with yummy and healthy breakfast",
    url: "https://www.betheshyft.com/community/thread/MTA4OTM/started-my-day-with-yummy-and-healthy-breakfast/",
  },
  {
    id: 10729,
    slug: "mind-full-vs-mindful",
    title: "Mind Full vs Mindful!",
    url: "https://www.betheshyft.com/community/thread/MTA3Mjk/mind-full-vs-mindful/",
  },
  {
    id: 10636,
    slug: "yoga-for-back-strengthening",
    title: "Yoga for back strengthening",
    url: "https://www.betheshyft.com/community/thread/MTA2MzY/yoga-for-back-strengthening/",
  },
  {
    id: 10548,
    slug: "padahastasana",
    title: "Padahastasana",
    url: "https://www.betheshyft.com/community/thread/MTA1NDg/padahastasana/",
  },
  {
    id: 10480,
    slug: "festive-thali-but-never-not-balanced",
    title: "Festive thali, but never not balanced! ✨",
    url: "https://www.betheshyft.com/community/thread/MTA0ODA/festive-thali-but-never-not-balanced/",
  },
  {
    id: 10285,
    slug: "hey-nature-why-are-you-so-therapeutic",
    title: "Hey Nature - why are you so therapeutic !!!! 😍",
    url: "https://www.betheshyft.com/community/thread/MTAyODU/hey-nature-why-are-you-so-therapeutic/",
  },
  {
    id: 10097,
    slug: "step-target-achieved",
    title: "Step target achieved🎊",
    url: "https://www.betheshyft.com/community/thread/MTAwOTc/step-target-achieved/",
  },
  {
    id: 10066,
    slug: "full-camel-pose",
    title: "Full Camel pose",
    url: "https://www.betheshyft.com/community/thread/MTAwNjY/full-camel-pose/",
  },
  {
    id: 10043,
    slug: "what-is-the-importance-of-warm-ups-in",
    title: "What is the importance of warm-ups in yoga classes?",
    url: "https://www.betheshyft.com/community/thread/MTAwNDM/what-is-the-importance-of-warm-ups-in/",
  },
  {
    id: 9997,
    slug: "consuming-water-from-an-earthen-clay-pot",
    title: "Consuming water from an earthen/clay pot",
    url: "https://www.betheshyft.com/community/thread/OTk5Nw/consuming-water-from-an-earthen-clay-pot/",
  },
  {
    id: 9826,
    slug: "did-you-get-your-vitamin-d",
    title: "Did you get your vitamin D ?",
    url: "https://www.betheshyft.com/community/thread/OTgyNg/did-you-get-your-vitamin-d/",
  },
  {
    id: 9714,
    slug: "started-my-day-strong",
    title: "Started my day strong!",
    url: "https://www.betheshyft.com/community/thread/OTcxNA/started-my-day-strong/",
  },
  {
    id: 9704,
    slug: "childhood-beliefs-if-you-swallow-a-seed-it",
    title:
      "Childhood beliefs !!  🍉👧👦🧚‍♀️🧚 --- If you swallow a seed, it will grow into a plant ! How many of you grew up believing this ?",
    url: "https://www.betheshyft.com/community/thread/OTcwNA/childhood-beliefs-if-you-swallow-a-seed-it/",
  },
  {
    id: 9566,
    slug: "the-green-banana-magic",
    title: "THE GREEN BANANA MAGIC !!",
    url: "https://www.betheshyft.com/community/thread/OTU2Ng/the-green-banana-magic/",
  },
  {
    id: 9469,
    slug: "a-very-quick-delicious-and-healthy-dinner",
    title: "A very quick, delicious and healthy dinner!",
    url: "https://www.betheshyft.com/community/thread/OTQ2OQ/a-very-quick-delicious-and-healthy-dinner/",
  },
  {
    id: 9336,
    slug: "locust-a-prone-mini-back-bend-posture",
    title: "Locust- A prone mini back bend posture",
    url: "https://www.betheshyft.com/community/thread/OTMzNg/locust-a-prone-mini-back-bend-posture/",
  },
  {
    id: 9300,
    slug: "have-you-soaked-in-some-sun-today",
    title: "Have you soaked in some Sun today ?",
    url: "https://www.betheshyft.com/community/thread/OTMwMA/have-you-soaked-in-some-sun-today/",
  },
  {
    id: 9279,
    slug: "self-care",
    title: "Self Care",
    url: "https://www.betheshyft.com/community/thread/OTI3OQ/self-care/",
  },
  {
    id: 9218,
    slug: "pregnancy-mindset",
    title: "Pregnancy Mindset 💕",
    url: "https://www.betheshyft.com/community/thread/OTIxOA/pregnancy-mindset/",
  },
  {
    id: 9216,
    slug: "how-to-avoid-knee-injury-during-yoga",
    title: "How to avoid knee injury during yoga",
    url: "https://www.betheshyft.com/community/thread/OTIxNg/how-to-avoid-knee-injury-during-yoga/",
  },
  {
    id: 9213,
    slug: "what-is-vagus-nerve-and-what-does-it",
    title: "What is vagus nerve and what does it do?",
    url: "https://www.betheshyft.com/community/thread/OTIxMw/what-is-vagus-nerve-and-what-does-it/",
  },
  {
    id: 9177,
    slug: "creating-sleep-hygiene",
    title: "Creating sleep hygiene",
    url: "https://www.betheshyft.com/community/thread/OTE3Nw/creating-sleep-hygiene/",
  },
  {
    id: 9161,
    slug: "the-role-of-yoga-in-hashimotos-disease",
    title: "The role of yoga in Hashimoto’s disease",
    url: "https://www.betheshyft.com/community/thread/OTE2MQ/the-role-of-yoga-in-hashimotos-disease/",
  },
  {
    id: 9158,
    slug: "vitamins-simple-category",
    title: "Vitamins- Simple Category",
    url: "https://www.betheshyft.com/community/thread/OTE1OA/vitamins-simple-category/",
  },
  {
    id: 9141,
    slug: "dhanurasana-bow-pose",
    title: "Dhanurasana (Bow pose)",
    url: "https://www.betheshyft.com/community/thread/OTE0MQ/dhanurasana-bow-pose/",
  },
  {
    id: 9078,
    slug: "importance-of-guidance-in-your-health-journey",
    title: "Importance of guidance in your health journey",
    url: "https://www.betheshyft.com/community/thread/OTA3OA/importance-of-guidance-in-your-health-journey/",
  },
  {
    id: 9024,
    slug: "to-enhance-the-quality-of-sleep",
    title: "To enhance the quality of sleep!",
    url: "https://www.betheshyft.com/community/thread/OTAyNA/to-enhance-the-quality-of-sleep/",
  },
  {
    id: 9021,
    slug: "some-interesting-fact-about-human-body",
    title: "Some Interesting fact about Human Body!",
    url: "https://www.betheshyft.com/community/thread/OTAyMQ/some-interesting-fact-about-human-body/",
  },
  {
    id: 9001,
    slug: "cool-facts-about-baby",
    title: "Cool facts about baby!",
    url: "https://www.betheshyft.com/community/thread/OTAwMQ/cool-facts-about-baby/",
  },
  {
    id: 8939,
    slug: "box-breathing-to-release-stress-and-anxiety",
    title: "Box breathing to release stress and anxiety",
    url: "https://www.betheshyft.com/community/thread/ODkzOQ/box-breathing-to-release-stress-and-anxiety/",
  },
  {
    id: 8880,
    slug: "tree-pose",
    title: "Tree Pose",
    url: "https://www.betheshyft.com/community/thread/ODg4MA/tree-pose/",
  },
  {
    id: 8792,
    slug: "the-stress-response",
    title: "The stress response",
    url: "https://www.betheshyft.com/community/thread/ODc5Mg/the-stress-response/",
  },
  {
    id: 8771,
    slug: "sun-salutation-surya-namaskar",
    title: "Sun Salutation | Surya Namaskar",
    url: "https://www.betheshyft.com/community/thread/ODc3MQ/sun-salutation-surya-namaskar/",
  },
  {
    id: 8759,
    slug: "breathwork-benefits",
    title: "Breathwork Benefits",
    url: "https://www.betheshyft.com/community/thread/ODc1OQ/breathwork-benefits/",
  },
  {
    id: 8748,
    slug: "bhramari-pranayama-during-pregnancy",
    title: "Bhramari pranayama during pregnancy",
    url: "https://www.betheshyft.com/community/thread/ODc0OA/bhramari-pranayama-during-pregnancy/",
  },
  {
    id: 8685,
    slug: "getting-ready-for-the-weekend-with-the-breathing",
    title: "Getting ready for the weekend with the breathing exercises !",
    url: "https://www.betheshyft.com/community/thread/ODY4NQ/getting-ready-for-the-weekend-with-the-breathing/",
  },
  {
    id: 8663,
    slug: "benefits-of-gardening",
    title: "Benefits of gardening",
    url: "https://www.betheshyft.com/community/thread/ODY2Mw/benefits-of-gardening/",
  },
  {
    id: 8594,
    slug: "yoga-in-the-workplace",
    title: "Yoga in the workplace",
    url: "https://www.betheshyft.com/community/thread/ODU5NA/yoga-in-the-workplace/",
  },
  {
    id: 8374,
    slug: "fasting-and-short-of-yummy-and-healthy-ideas",
    title: "Fasting??? And short of yummy and healthy ideas ?? 🤔🙆‍♀️",
    url: "https://www.betheshyft.com/community/thread/ODM3NA/fasting-and-short-of-yummy-and-healthy-ideas/",
  },
  {
    id: 8159,
    slug: "came-across-this-infographic-which-could-come-in",
    title:
      "Came across this infographic which could come in handy as this flu seems to be getting the best of everyone these days! 🤧",
    url: "https://www.betheshyft.com/community/thread/ODE1OQ/came-across-this-infographic-which-could-come-in/",
  },
  {
    id: 8146,
    slug: "what-is-grounding",
    title: "What is grounding?",
    url: "https://www.betheshyft.com/community/thread/ODE0Ng/what-is-grounding/",
  },
  {
    id: 8121,
    slug: "the-buddha-bowl",
    title: "The Buddha Bowl 🥣",
    url: "https://www.betheshyft.com/community/thread/ODEyMQ/the-buddha-bowl/",
  },
  {
    id: 8110,
    slug: "happy-monday",
    title: "Happy Monday!",
    url: "https://www.betheshyft.com/community/thread/ODExMA/happy-monday/",
  },
  {
    id: 8103,
    slug: "benefits-of-water-2-0",
    title: "Benefits of water 2.0",
    url: "https://www.betheshyft.com/community/thread/ODEwMw/benefits-of-water-2-0/",
  },
  {
    id: 8050,
    slug: "what-are-circadian-rhythms",
    title: "What are circadian rhythms?",
    url: "https://www.betheshyft.com/community/thread/ODA1MA/what-are-circadian-rhythms/",
  },
  {
    id: 7992,
    slug: "how-are-you-planning-to-recharge-yourself-over",
    title: "How are you planning to recharge yourself over the weekend?",
    url: "https://www.betheshyft.com/community/thread/Nzk5Mg/how-are-you-planning-to-recharge-yourself-over/",
  },
  {
    id: 7920,
    slug: "importance-of-eating-meals-on-time",
    title: "Importance of eating meals on time",
    url: "https://www.betheshyft.com/community/thread/NzkyMA/importance-of-eating-meals-on-time/",
  },
  {
    id: 7859,
    slug: "5-healthy-habits-to-start-with-at-home",
    title: "5 healthy habits to start with at home:",
    url: "https://www.betheshyft.com/community/thread/Nzg1OQ/5-healthy-habits-to-start-with-at-home/",
  },
  {
    id: 7808,
    slug: "the-importance-of-a-morning-routine",
    title: "The Importance of a Morning Routine",
    url: "https://www.betheshyft.com/community/thread/NzgwOA/the-importance-of-a-morning-routine/",
  },
  {
    id: 7749,
    slug: "giving-into-cravings",
    title: "Giving into cravings",
    url: "https://www.betheshyft.com/community/thread/Nzc0OQ/giving-into-cravings/",
  },
  {
    id: 7590,
    slug: "good-morning-and-have-a-fantastic-day",
    title: "Good morning and have a fantastic day!",
    url: "https://www.betheshyft.com/community/thread/NzU5MA/good-morning-and-have-a-fantastic-day/",
  },
  {
    id: 7576,
    slug: "benefits-of-sleeping-well",
    title: "Benefits of sleeping well",
    url: "https://www.betheshyft.com/community/thread/NzU3Ng/benefits-of-sleeping-well/",
  },
  {
    id: 7537,
    slug: "muffin-top-aka-love-handles",
    title: "Muffin-top aka love handles 🙌🏼",
    url: "https://www.betheshyft.com/community/thread/NzUzNw/muffin-top-aka-love-handles/",
  },
  {
    id: 7465,
    slug: "currently-eating-food-that-helps-my-gut",
    title: "Currently eating food that helps my gut..😋",
    url: "https://www.betheshyft.com/community/thread/NzQ2NQ/currently-eating-food-that-helps-my-gut/",
  },
  {
    id: 7458,
    slug: "a-summertime-favorite-salad",
    title: "A summertime favorite SALAD !!",
    url: "https://www.betheshyft.com/community/thread/NzQ1OA/a-summertime-favorite-salad/",
  },
  {
    id: 7411,
    slug: "connect-with-the-breath-calm-and-steady-the",
    title: "Connect with the breath 🌬 calm and steady the mind🧘🏻‍♀️🧘‍♂️",
    url: "https://www.betheshyft.com/community/thread/NzQxMQ/connect-with-the-breath-calm-and-steady-the/",
  },
  {
    id: 7392,
    slug: "train-for-the-bigger-picture-the-real-reason",
    title:
      "Train for the BIGGER picture. The real reason to why to move your body.",
    url: "https://www.betheshyft.com/community/thread/NzM5Mg/train-for-the-bigger-picture-the-real-reason/",
  },
  {
    id: 7385,
    slug: "tomatoes-cause-kidney-stones-fact-or-myth",
    title: "TOMATOES 🍅 cause kidney stones - fact or myth ??",
    url: "https://www.betheshyft.com/community/thread/NzM4NQ/tomatoes-cause-kidney-stones-fact-or-myth/",
  },
  {
    id: 7356,
    slug: "improving-gut-health",
    title: "Improving gut health",
    url: "https://www.betheshyft.com/community/thread/NzM1Ng/improving-gut-health/",
  },
  {
    id: 7334,
    slug: "kids-nutrition",
    title: "Kids Nutrition ! !",
    url: "https://www.betheshyft.com/community/thread/NzMzNA/kids-nutrition/",
  },
  {
    id: 7333,
    slug: "kids-nutrition",
    title: "Kids Nutrition ! !",
    url: "https://www.betheshyft.com/community/thread/NzMzMw/kids-nutrition/",
  },
  {
    id: 7324,
    slug: "for-a-peaceful-night",
    title: "For a peaceful night",
    url: "https://www.betheshyft.com/community/thread/NzMyNA/for-a-peaceful-night/",
  },
  {
    id: 7315,
    slug: "inversion",
    title: "Inversion",
    url: "https://www.betheshyft.com/community/thread/NzMxNQ/inversion/",
  },
  {
    id: 7306,
    slug: "when-life-turns-you-upside-down-strike-a",
    title: "When life turns you upside down- Strike a pose!",
    url: "https://www.betheshyft.com/community/thread/NzMwNg/when-life-turns-you-upside-down-strike-a/",
  },
  {
    id: 7293,
    slug: "encourage-your-child-to-be-physically-active",
    title: "Encourage your child to be physically active",
    url: "https://www.betheshyft.com/community/thread/NzI5Mw/encourage-your-child-to-be-physically-active/",
  },
  {
    id: 7279,
    slug: "beat-the-heat",
    title: "Beat the heat🥵",
    url: "https://www.betheshyft.com/community/thread/NzI3OQ/beat-the-heat/",
  },
  {
    id: 7275,
    slug: "craving-for-sweets",
    title: "Craving for sweets",
    url: "https://www.betheshyft.com/community/thread/NzI3NQ/craving-for-sweets/",
  },
  {
    id: 7264,
    slug: "ear-pressure-pose-or-karnapidasana",
    title: "Ear Pressure Pose or Karnapidasana",
    url: "https://www.betheshyft.com/community/thread/NzI2NA/ear-pressure-pose-or-karnapidasana/",
  },
  {
    id: 7235,
    slug: "beat-the-heat",
    title: "Beat the heat 🥵",
    url: "https://www.betheshyft.com/community/thread/NzIzNQ/beat-the-heat/",
  },
  {
    id: 7147,
    slug: "lizard-pose",
    title: "Lizard pose",
    url: "https://www.betheshyft.com/community/thread/NzE0Nw/lizard-pose/",
  },
  {
    id: 7109,
    slug: "work-in-progress-all-time-favourite-posture",
    title: "Work in progress - All time favourite posture",
    url: "https://www.betheshyft.com/community/thread/NzEwOQ/work-in-progress-all-time-favourite-posture/",
  },
  {
    id: 7101,
    slug: "set-your-smart-goal",
    title: "Set your SMART goal",
    url: "https://www.betheshyft.com/community/thread/NzEwMQ/set-your-smart-goal/",
  },
  {
    id: 7099,
    slug: "i-like-to-call-it-the-bloody-mary",
    title: "I like to call it- “The Bloody Mary” 🥤",
    url: "https://www.betheshyft.com/community/thread/NzA5OQ/i-like-to-call-it-the-bloody-mary/",
  },
  {
    id: 7071,
    slug: "down-with-the-flu",
    title: "Down with the FLU !!! 👩‍⚕️🤒",
    url: "https://www.betheshyft.com/community/thread/NzA3MQ/down-with-the-flu/",
  },
  {
    id: 7069,
    slug: "ways-to-practice-meditation",
    title: "Ways to practice meditation",
    url: "https://www.betheshyft.com/community/thread/NzA2OQ/ways-to-practice-meditation/",
  },
  {
    id: 7065,
    slug: "detoxifying-posture-seated-forward-bend-paschimottanasana",
    title: "Detoxifying posture- Seated forward bend(Paschimottanasana)",
    url: "https://www.betheshyft.com/community/thread/NzA2NQ/detoxifying-posture-seated-forward-bend-paschimottanasana/",
  },
  {
    id: 7063,
    slug: "say-goodbye-to-toxins",
    title: "Say goodbye to toxins 👋",
    url: "https://www.betheshyft.com/community/thread/NzA2Mw/say-goodbye-to-toxins/",
  },
  {
    id: 7041,
    slug: "are-you-back-on-track-post-holi",
    title: "Are you back on track post Holi?",
    url: "https://www.betheshyft.com/community/thread/NzA0MQ/are-you-back-on-track-post-holi/",
  },
  {
    id: 7040,
    slug: "detox-with-yoga-revolved-triangle-pose",
    title: "Detox with Yoga - Revolved Triangle Pose",
    url: "https://www.betheshyft.com/community/thread/NzA0MA/detox-with-yoga-revolved-triangle-pose/",
  },
  {
    id: 7039,
    slug: "wide-legged-forward-bend-detoxification-pose",
    title: "Wide legged Forward bend(Detoxification pose)",
    url: "https://www.betheshyft.com/community/thread/NzAzOQ/wide-legged-forward-bend-detoxification-pose/",
  },
  {
    id: 6907,
    slug: "restorative-pose-reclined-butterfly-pose",
    title: "Restorative pose ( Reclined butterfly pose )",
    url: "https://www.betheshyft.com/community/thread/NjkwNw/restorative-pose-reclined-butterfly-pose/",
  },
  {
    id: 6882,
    slug: "is-milk-really-healthy",
    title: "Is milk really healthy?",
    url: "https://www.betheshyft.com/community/thread/Njg4Mg/is-milk-really-healthy/",
  },
  {
    id: 6862,
    slug: "standing-back-bend-pose",
    title: "Standing Back Bend Pose",
    url: "https://www.betheshyft.com/community/thread/Njg2Mg/standing-back-bend-pose/",
  },
  {
    id: 6848,
    slug: "prone-positions",
    title: "Prone positions",
    url: "https://www.betheshyft.com/community/thread/Njg0OA/prone-positions/",
  },
  {
    id: 6836,
    slug: "wild-thing-pose",
    title: "Wild Thing Pose",
    url: "https://www.betheshyft.com/community/thread/NjgzNg/wild-thing-pose/",
  },
  {
    id: 6814,
    slug: "mandukasana-helping-with-digestion",
    title: "Mandukasana helping with digestion",
    url: "https://www.betheshyft.com/community/thread/NjgxNA/mandukasana-helping-with-digestion/",
  },
  {
    id: 6775,
    slug: "goddess-pose",
    title: "Goddess pose 💪",
    url: "https://www.betheshyft.com/community/thread/Njc3NQ/goddess-pose/",
  },
  {
    id: 6767,
    slug: "my-fav-variation-of-savasana",
    title: "My fav variation of savasana",
    url: "https://www.betheshyft.com/community/thread/Njc2Nw/my-fav-variation-of-savasana/",
  },
  {
    id: 6753,
    slug: "variation-of-shavasana-prone-shavasana",
    title: "Variation of shavasana (Prone shavasana)",
    url: "https://www.betheshyft.com/community/thread/Njc1Mw/variation-of-shavasana-prone-shavasana/",
  },
  {
    id: 6750,
    slug: "my-way-of-relaxing-on-the-mat",
    title: "My way of relaxing on the mat",
    url: "https://www.betheshyft.com/community/thread/Njc1MA/my-way-of-relaxing-on-the-mat/",
  },
  {
    id: 6740,
    slug: "savasana-mostly-we-do-it-in-the-last",
    title:
      "Savasana - Mostly we do it in the last of the session and it's a most awaited pose for most of us😀",
    url: "https://www.betheshyft.com/community/thread/Njc0MA/savasana-mostly-we-do-it-in-the-last/",
  },
  {
    id: 6737,
    slug: "common-labor-birth-fears",
    title: "Common Labor/ Birth Fears",
    url: "https://www.betheshyft.com/community/thread/NjczNw/common-labor-birth-fears/",
  },
  {
    id: 6733,
    slug: "savasana-bolster-under-knees",
    title: "Savasana - Bolster Under Knees",
    url: "https://www.betheshyft.com/community/thread/NjczMw/savasana-bolster-under-knees/",
  },
  {
    id: 6731,
    slug: "how-where-should-i-begin-will-i-be",
    title:
      "How & where should I begin ? Will I be able to reach my goals ?? 🤔🤔",
    url: "https://www.betheshyft.com/community/thread/NjczMQ/how-where-should-i-begin-will-i-be/",
  },
  {
    id: 6730,
    slug: "who-doesnt-like-savasana",
    title: "Who doesn’t like SAVASANA!!!! 😛",
    url: "https://www.betheshyft.com/community/thread/NjczMA/who-doesnt-like-savasana/",
  },
  {
    id: 6726,
    slug: "variation-of-savasana",
    title: "Variation Of Savasana",
    url: "https://www.betheshyft.com/community/thread/NjcyNg/variation-of-savasana/",
  },
  {
    id: 6706,
    slug: "chakrasana-wheel-pose",
    title: "🛞 Chakrasana/wheel pose 🛞",
    url: "https://www.betheshyft.com/community/thread/NjcwNg/chakrasana-wheel-pose/",
  },
  {
    id: 6697,
    slug: "my-favourite-workout",
    title: "My favourite workout!",
    url: "https://www.betheshyft.com/community/thread/NjY5Nw/my-favourite-workout/",
  },
  {
    id: 6690,
    slug: "the-secret-about-collagen",
    title: "The secret about COLLAGEN 🤫🤫",
    url: "https://www.betheshyft.com/community/thread/NjY5MA/the-secret-about-collagen/",
  },
  {
    id: 6686,
    slug: "plan-your-week-ahead",
    title: "Plan your week ahead",
    url: "https://www.betheshyft.com/community/thread/NjY4Ng/plan-your-week-ahead/",
  },
  {
    id: 6675,
    slug: "ways-to-give-your-mind-a-deep-cleaning",
    title: "Ways to Give Your Mind a Deep Cleaning",
    url: "https://www.betheshyft.com/community/thread/NjY3NQ/ways-to-give-your-mind-a-deep-cleaning/",
  },
  {
    id: 6623,
    slug: "stay-with-your-moment",
    title: "Stay with your moment",
    url: "https://www.betheshyft.com/community/thread/NjYyMw/stay-with-your-moment/",
  },
  {
    id: 6543,
    slug: "what-is-mindfulness",
    title: "What is mindfulness?",
    url: "https://www.betheshyft.com/community/thread/NjU0Mw/what-is-mindfulness/",
  },
  {
    id: 6531,
    slug: "exam-time-fever-for-parent-or-child",
    title: "Exam time fever...for parent or child ?? 🤔🤔",
    url: "https://www.betheshyft.com/community/thread/NjUzMQ/exam-time-fever-for-parent-or-child/",
  },
  {
    id: 6488,
    slug: "do-s-for-a-better-sleep",
    title: "Do's for a better sleep",
    url: "https://www.betheshyft.com/community/thread/NjQ4OA/do-s-for-a-better-sleep/",
  },
  {
    id: 6411,
    slug: "does-selenium-help-the-thyroid-gland",
    title: "Does selenium help the thyroid gland ??",
    url: "https://www.betheshyft.com/community/thread/NjQxMQ/does-selenium-help-the-thyroid-gland/",
  },
  {
    id: 6371,
    slug: "core-strengthening-pose",
    title: "Core strengthening pose.",
    url: "https://www.betheshyft.com/community/thread/NjM3MQ/core-strengthening-pose/",
  },
  {
    id: 6332,
    slug: "kick-start-your-day-with-this-nutrient-rich",
    title:
      "Kick start your day with this nutrient rich juice - ABC. The Apple-Beetroot - Carrot Juice. Listing down some facts and benefits of the juice!",
    url: "https://www.betheshyft.com/community/thread/NjMzMg/kick-start-your-day-with-this-nutrient-rich/",
  },
  {
    id: 6293,
    slug: "hip-opener-pose-seated-wide-legged-forward-bend",
    title: "Hip opener pose - Seated wide legged forward bend",
    url: "https://www.betheshyft.com/community/thread/NjI5Mw/hip-opener-pose-seated-wide-legged-forward-bend/",
  },
  {
    id: 6268,
    slug: "i-m-not-an-onion-seed-i-m",
    title: "I'm not an onion seed ....I'm a Nigella seed 🙂  I am KALONJI !",
    url: "https://www.betheshyft.com/community/thread/NjI2OA/i-m-not-an-onion-seed-i-m/",
  },
  {
    id: 6265,
    slug: "pcos-and-exercise",
    title: "Pcos and exercise",
    url: "https://www.betheshyft.com/community/thread/NjI2NQ/pcos-and-exercise/",
  },
  {
    id: 6234,
    slug: "hip-opener-of-the-day-wide-angle-seated",
    title:
      "Hip opener of the day: Wide angle seated  forward bend/ Upavishta Konasana",
    url: "https://www.betheshyft.com/community/thread/NjIzNA/hip-opener-of-the-day-wide-angle-seated/",
  },
  {
    id: 6179,
    slug: "post-your-favourite-hip-opening-pose",
    title: "Post your favourite hip opening pose",
    url: "https://www.betheshyft.com/community/thread/NjE3OQ/post-your-favourite-hip-opening-pose/",
  },
  {
    id: 6149,
    slug: "crescent-lunge-pose",
    title: "Crescent lunge pose",
    url: "https://www.betheshyft.com/community/thread/NjE0OQ/crescent-lunge-pose/",
  },
  {
    id: 6115,
    slug: "start-your-day-off-right",
    title: "🧘🏻‍♀️START YOUR DAY OFF RIGHT 🧘🏻‍♀️",
    url: "https://www.betheshyft.com/community/thread/NjExNQ/start-your-day-off-right/",
  },
  {
    id: 6062,
    slug: "chest-opening-pose",
    title: "Chest opening pose.",
    url: "https://www.betheshyft.com/community/thread/NjA2Mg/chest-opening-pose/",
  },
  {
    id: 6049,
    slug: "chest-opener",
    title: "Chest Opener",
    url: "https://www.betheshyft.com/community/thread/NjA0OQ/chest-opener/",
  },
  {
    id: 6000,
    slug: "lunch-today-aloo-sabzi-quinoa-curd-with-chia",
    title:
      "Lunch today: Aloo sabzi + Quinoa + curd with chia seeds + salad. 🍽️",
    url: "https://www.betheshyft.com/community/thread/NjAwMA/lunch-today-aloo-sabzi-quinoa-curd-with-chia/",
  },
  {
    id: 5999,
    slug: "chest-openers",
    title: "Chest openers",
    url: "https://www.betheshyft.com/community/thread/NTk5OQ/chest-openers/",
  },
  {
    id: 5981,
    slug: "chest-opening-yoga-pose-king-pigeon-pose",
    title: "CHEST-OPENING YOGA POSE - King Pigeon Pose",
    url: "https://www.betheshyft.com/community/thread/NTk4MQ/chest-opening-yoga-pose-king-pigeon-pose/",
  },
  {
    id: 5945,
    slug: "chest-opener-puppy-pose-with-the-help-of",
    title: "Chest opener (Puppy Pose) with the help of blocks",
    url: "https://www.betheshyft.com/community/thread/NTk0NQ/chest-opener-puppy-pose-with-the-help-of/",
  },
  {
    id: 5711,
    slug: "do-you-frequently-have-sweet-cravings-or-know",
    title: "Do you frequently have sweet cravings or know someone who does ?",
    url: "https://www.betheshyft.com/community/thread/NTcxMQ/do-you-frequently-have-sweet-cravings-or-know/",
  },
  {
    id: 5631,
    slug: "yoga",
    title: "Yoga",
    url: "https://www.betheshyft.com/community/thread/NTYzMQ/yoga/",
  },
  {
    id: 5588,
    slug: "why-were-the-guests-first-served-with-curd",
    title:
      "Why were the guests, first served with curd and then the main course?!  Well, because curd was more 'cultured' 😜",
    url: "https://www.betheshyft.com/community/thread/NTU4OA/why-were-the-guests-first-served-with-curd/",
  },
  {
    id: 5380,
    slug: "the-benefits-of-yoga",
    title: "The Benefits of Yoga",
    url: "https://www.betheshyft.com/community/thread/NTM4MA/the-benefits-of-yoga/",
  },
  {
    id: 5173,
    slug: "warrior-pose",
    title: "Warrior pose",
    url: "https://www.betheshyft.com/community/thread/NTE3Mw/warrior-pose/",
  },
  {
    id: 4918,
    slug: "breathwork",
    title: "Breathwork",
    url: "https://www.betheshyft.com/community/thread/NDkxOA/breathwork/",
  },
  {
    id: 4898,
    slug: "the-food-you-don-t-chew-is-ewwww",
    title: "The food you don't CHEW is EWWWW - Part -2",
    url: "https://www.betheshyft.com/community/thread/NDg5OA/the-food-you-don-t-chew-is-ewwww/",
  },
  {
    id: 4881,
    slug: "rules-for-visiting-mama-and-baby-after-birth",
    title: "Rules for visiting Mama and baby after birth",
    url: "https://www.betheshyft.com/community/thread/NDg4MQ/rules-for-visiting-mama-and-baby-after-birth/",
  },
  {
    id: 4813,
    slug: "todays-lunch-bowl",
    title: "Today’s Lunch bowl.",
    url: "https://www.betheshyft.com/community/thread/NDgxMw/todays-lunch-bowl/",
  },
  {
    id: 4807,
    slug: "twin-twisting",
    title: "Twin twisting 😅",
    url: "https://www.betheshyft.com/community/thread/NDgwNw/twin-twisting/",
  },
  {
    id: 4692,
    slug: "3-benefits-of-tree-pose",
    title: "3 benefits of tree pose",
    url: "https://www.betheshyft.com/community/thread/NDY5Mg/3-benefits-of-tree-pose/",
  },
  {
    id: 4674,
    slug: "butterfly-posture",
    title: "Butterfly Posture🦋",
    url: "https://www.betheshyft.com/community/thread/NDY3NA/butterfly-posture/",
  },
  {
    id: 4670,
    slug: "butterfly-posture",
    title: "Butterfly posture",
    url: "https://www.betheshyft.com/community/thread/NDY3MA/butterfly-posture/",
  },
  {
    id: 4668,
    slug: "how-to-best-support-your-partner-during-birth",
    title: "How to best support your partner during birth",
    url: "https://www.betheshyft.com/community/thread/NDY2OA/how-to-best-support-your-partner-during-birth/",
  },
  {
    id: 4662,
    slug: "the-food-you-don-t-chew-is-ewwww",
    title: "The food you don't 'CHEW' is EWWWW",
    url: "https://www.betheshyft.com/community/thread/NDY2Mg/the-food-you-don-t-chew-is-ewwww/",
  },
  {
    id: 4656,
    slug: "talk-to-your-newborn",
    title: "Talk to your Newborn",
    url: "https://www.betheshyft.com/community/thread/NDY1Ng/talk-to-your-newborn/",
  },
  {
    id: 4651,
    slug: "hanumanasana",
    title: "Hanumanasana",
    url: "https://www.betheshyft.com/community/thread/NDY1MQ/hanumanasana/",
  },
  {
    id: 4648,
    slug: "rules-of-healthy-sleep",
    title: "Rules of healthy sleep",
    url: "https://www.betheshyft.com/community/thread/NDY0OA/rules-of-healthy-sleep/",
  },
  {
    id: 4642,
    slug: "7-steps-to-jumpstart-healthy-habits",
    title: "7 steps to Jumpstart Healthy Habits",
    url: "https://www.betheshyft.com/community/thread/NDY0Mg/7-steps-to-jumpstart-healthy-habits/",
  },
  {
    id: 4619,
    slug: "pregnant-and-peeing-a-lot-makes-sense",
    title: "Pregnant and peeing a lot? Makes sense!",
    url: "https://www.betheshyft.com/community/thread/NDYxOQ/pregnant-and-peeing-a-lot-makes-sense/",
  },
  {
    id: 4561,
    slug: "oatmeal-porridge-for-acidity-a-whole-grain-breakfast",
    title:
      "Oatmeal porridge for Acidity- A whole grain breakfast loaded with fiber & complex carbohydrates",
    url: "https://www.betheshyft.com/community/thread/NDU2MQ/oatmeal-porridge-for-acidity-a-whole-grain-breakfast/",
  },
  {
    id: 4534,
    slug: "this-is-so-true",
    title: "This is so true!",
    url: "https://www.betheshyft.com/community/thread/NDUzNA/this-is-so-true/",
  },
  {
    id: 4507,
    slug: "why-core-strength-is-important-than-just-building",
    title: "Why Core Strength is Important than just building your six packs",
    url: "https://www.betheshyft.com/community/thread/NDUwNw/why-core-strength-is-important-than-just-building/",
  },
  {
    id: 4434,
    slug: "10k-steps-every-day",
    title: "10K steps every day! 🏃‍♀️",
    url: "https://www.betheshyft.com/community/thread/NDQzNA/10k-steps-every-day/",
  },
  {
    id: 4429,
    slug: "stop-making-excuses",
    title: "Stop making excuses!",
    url: "https://www.betheshyft.com/community/thread/NDQyOQ/stop-making-excuses/",
  },
  {
    id: 4425,
    slug: "first-crop-of-cherry-tomatoes-from-my-garden",
    title: "First crop of cherry tomatoes 🍅 from my garden",
    url: "https://www.betheshyft.com/community/thread/NDQyNQ/first-crop-of-cherry-tomatoes-from-my-garden/",
  },
  {
    id: 4239,
    slug: "an-emotional-detox-journey",
    title: "An emotional detox journey",
    url: "https://www.betheshyft.com/community/thread/NDIzOQ/an-emotional-detox-journey/",
  },
  {
    id: 4097,
    slug: "the-secret-to-having-balanced-meals",
    title: "The secret to having balanced meals😋😉",
    url: "https://www.betheshyft.com/community/thread/NDA5Nw/the-secret-to-having-balanced-meals/",
  },
  {
    id: 3946,
    slug: "benefits-of-breastfeeding-for-the-baby",
    title: "Benefits of Breastfeeding for the baby",
    url: "https://www.betheshyft.com/community/thread/Mzk0Ng/benefits-of-breastfeeding-for-the-baby/",
  },
  {
    id: 3902,
    slug: "sleep-and-immune-system",
    title: "Sleep and Immune System",
    url: "https://www.betheshyft.com/community/thread/MzkwMg/sleep-and-immune-system/",
  },
  {
    id: 3901,
    slug: "role-of-good-night-s-sleep",
    title: "Role of Good night's sleep",
    url: "https://www.betheshyft.com/community/thread/MzkwMQ/role-of-good-night-s-sleep/",
  },
  {
    id: 3895,
    slug: "the-constant-struggle-of-falling-in-and-out",
    title: "The constant struggle of falling in and out of routine 🥲",
    url: "https://www.betheshyft.com/community/thread/Mzg5NQ/the-constant-struggle-of-falling-in-and-out/",
  },
  {
    id: 3891,
    slug: "soak-it-guys",
    title: "Soak it guys 😍",
    url: "https://www.betheshyft.com/community/thread/Mzg5MQ/soak-it-guys/",
  },
  {
    id: 3888,
    slug: "is-herbal-tea-an-actual-tea-here-are",
    title: "Is ' Herbal tea' an ' actual tea ' ??🫖🫖 Here are the facts",
    url: "https://www.betheshyft.com/community/thread/Mzg4OA/is-herbal-tea-an-actual-tea-here-are/",
  },
  {
    id: 3886,
    slug: "early-postpartum-exercises",
    title: "Early Postpartum exercises",
    url: "https://www.betheshyft.com/community/thread/Mzg4Ng/early-postpartum-exercises/",
  },
  {
    id: 3885,
    slug: "what-are-positive-affirmations",
    title: "What are positive affirmations?",
    url: "https://www.betheshyft.com/community/thread/Mzg4NQ/what-are-positive-affirmations/",
  },
  {
    id: 3876,
    slug: "5-different-breastfeeding-positions",
    title: "5 different breastfeeding positions.",
    url: "https://www.betheshyft.com/community/thread/Mzg3Ng/5-different-breastfeeding-positions/",
  },
  {
    id: 3875,
    slug: "some-benefits-of-breastfeeding",
    title: "Some benefits of breastfeeding!",
    url: "https://www.betheshyft.com/community/thread/Mzg3NQ/some-benefits-of-breastfeeding/",
  },
  {
    id: 3856,
    slug: "avocados-how-do-i-eat-that",
    title: "Avocados - how do I eat that ?🥵",
    url: "https://www.betheshyft.com/community/thread/Mzg1Ng/avocados-how-do-i-eat-that/",
  },
  {
    id: 3798,
    slug: "what-s-your-reason-to-lose-weight",
    title: "What's your reason to lose weight?! 🤔",
    url: "https://www.betheshyft.com/community/thread/Mzc5OA/what-s-your-reason-to-lose-weight/",
  },
  {
    id: 3794,
    slug: "salads-are-not-for-everyone",
    title: "Salads are not for everyone.",
    url: "https://www.betheshyft.com/community/thread/Mzc5NA/salads-are-not-for-everyone/",
  },
  {
    id: 3759,
    slug: "auto-immune-diseases-yoga-as-a-lifestyle",
    title: "Auto-immune diseases & Yoga as a Lifestyle",
    url: "https://www.betheshyft.com/community/thread/Mzc1OQ/auto-immune-diseases-yoga-as-a-lifestyle/",
  },
  {
    id: 3717,
    slug: "water-for-the-winters",
    title: "Water for the winters !!!🥛",
    url: "https://www.betheshyft.com/community/thread/MzcxNw/water-for-the-winters/",
  },
  {
    id: 3702,
    slug: "reminder",
    title: "Reminder:",
    url: "https://www.betheshyft.com/community/thread/MzcwMg/reminder/",
  },
  {
    id: 3682,
    slug: "know-your-poop-kyunki-harr-poop-kuch-kehta",
    title: "Know your poop, kyunki harr poop kuch kehta hain 😜",
    url: "https://www.betheshyft.com/community/thread/MzY4Mg/know-your-poop-kyunki-harr-poop-kuch-kehta/",
  },
  {
    id: 3674,
    slug: "why-is-nrem-non-rapid-eye-movement-sleep",
    title: "Why is NREM(Non Rapid Eye Movement) sleep important?",
    url: "https://www.betheshyft.com/community/thread/MzY3NA/why-is-nrem-non-rapid-eye-movement-sleep/",
  },
  {
    id: 3652,
    slug: "improve-posture-for-a-healthy-back",
    title: "Improve Posture for a Healthy Back",
    url: "https://www.betheshyft.com/community/thread/MzY1Mg/improve-posture-for-a-healthy-back/",
  },
  {
    id: 3603,
    slug: "doing-nothing-is-actually-good-at-times",
    title: "Doing nothing is actually good at times!",
    url: "https://www.betheshyft.com/community/thread/MzYwMw/doing-nothing-is-actually-good-at-times/",
  },
  {
    id: 3571,
    slug: "ways-to-protect-your-cervical-spine",
    title: "Ways to Protect Your Cervical Spine",
    url: "https://www.betheshyft.com/community/thread/MzU3MQ/ways-to-protect-your-cervical-spine/",
  },
  {
    id: 3542,
    slug: "top-10-superfoods-for-management-of-pcos",
    title: "Top 10 superfoods for  management of PCOS!!",
    url: "https://www.betheshyft.com/community/thread/MzU0Mg/top-10-superfoods-for-management-of-pcos/",
  },
  {
    id: 3483,
    slug: "say-no-to-unsolicited-advice-from-influencers-and",
    title:
      "Say NO 😼 to unsolicited advice from influencers and self-proclaimed nutritionists !!",
    url: "https://www.betheshyft.com/community/thread/MzQ4Mw/say-no-to-unsolicited-advice-from-influencers-and/",
  },
  {
    id: 3473,
    slug: "monday-motivation",
    title: "#Monday motivation",
    url: "https://www.betheshyft.com/community/thread/MzQ3Mw/monday-motivation/",
  },
  {
    id: 3420,
    slug: "sweet-cravings-i-got-you-the-bombs",
    title: "Sweet cravings - I Got you the BOMBS 😜",
    url: "https://www.betheshyft.com/community/thread/MzQyMA/sweet-cravings-i-got-you-the-bombs/",
  },
  {
    id: 3326,
    slug: "the-importance-of-taking-time-to-recharge-yourself",
    title: "The importance of taking time to recharge yourself",
    url: "https://www.betheshyft.com/community/thread/MzMyNg/the-importance-of-taking-time-to-recharge-yourself/",
  },
  {
    id: 3317,
    slug: "yeh-kaun-hain-jisne-fruits-ko-itna-badnaam",
    title: "Yeh kaun hain jisne fruits ko itna badnaam kiya hain 🥲👀",
    url: "https://www.betheshyft.com/community/thread/MzMxNw/yeh-kaun-hain-jisne-fruits-ko-itna-badnaam/",
  },
  {
    id: 3290,
    slug: "take-care-of-yourself-first",
    title: "Take care of yourself first",
    url: "https://www.betheshyft.com/community/thread/MzI5MA/take-care-of-yourself-first/",
  },
  {
    id: 3286,
    slug: "morning-done-right",
    title: "Morning Done Right 🧘🏻‍♂️🧘🏻‍♀️",
    url: "https://www.betheshyft.com/community/thread/MzI4Ng/morning-done-right/",
  },
  {
    id: 3243,
    slug: "work-from-home-got-u-glued-to-your",
    title: "Work from home - Got u glued 😞to your chair !!!",
    url: "https://www.betheshyft.com/community/thread/MzI0Mw/work-from-home-got-u-glued-to-your/",
  },
  {
    id: 3212,
    slug: "easy-chair-twist",
    title: "Easy Chair Twist",
    url: "https://www.betheshyft.com/community/thread/MzIxMg/easy-chair-twist/",
  },
  {
    id: 3206,
    slug: "yoga-practice-and-birthing-positions",
    title: "Yoga Practice and Birthing Positions",
    url: "https://www.betheshyft.com/community/thread/MzIwNg/yoga-practice-and-birthing-positions/",
  },
  {
    id: 3201,
    slug: "winter-classic",
    title: "Winter classic.  🎃",
    url: "https://www.betheshyft.com/community/thread/MzIwMQ/winter-classic/",
  },
  {
    id: 3193,
    slug: "benefits-of-breathwork-pranayam",
    title: "Benefits of Breathwork/Pranayam",
    url: "https://www.betheshyft.com/community/thread/MzE5Mw/benefits-of-breathwork-pranayam/",
  },
  {
    id: 3183,
    slug: "meditation-nourishes-the-mind-in-the-same-way",
    title:
      "Meditation nourishes the mind in the same way that food nourishes the body.",
    url: "https://www.betheshyft.com/community/thread/MzE4Mw/meditation-nourishes-the-mind-in-the-same-way/",
  },
  {
    id: 3152,
    slug: "healthy-lifestyle",
    title: "Healthy Lifestyle",
    url: "https://www.betheshyft.com/community/thread/MzE1Mg/healthy-lifestyle/",
  },
  {
    id: 3139,
    slug: "10-tips-to-boost-your-mental-health",
    title: "10 tips to boost your mental health",
    url: "https://www.betheshyft.com/community/thread/MzEzOQ/10-tips-to-boost-your-mental-health/",
  },
  {
    id: 3121,
    slug: "jal-hee-jeewan-hainnn",
    title: "Jal hee jeewan hainnn 😋",
    url: "https://www.betheshyft.com/community/thread/MzEyMQ/jal-hee-jeewan-hainnn/",
  },
  {
    id: 3045,
    slug: "relatable",
    title: "Relatable?",
    url: "https://www.betheshyft.com/community/thread/MzA0NQ/relatable/",
  },
  {
    id: 3021,
    slug: "has-to-be-my-favourite-evening-snack",
    title: "Has to be my favourite evening snack!",
    url: "https://www.betheshyft.com/community/thread/MzAyMQ/has-to-be-my-favourite-evening-snack/",
  },
  {
    id: 3009,
    slug: "spinach-mushroom-curry-with-rice-added-a-little",
    title:
      "Spinach mushroom curry with rice ( added a little amla for tang 😋)",
    url: "https://www.betheshyft.com/community/thread/MzAwOQ/spinach-mushroom-curry-with-rice-added-a-little/",
  },
  {
    id: 2997,
    slug: "body-signals-are-you-listening",
    title: "Body Signals: Are You Listening?",
    url: "https://www.betheshyft.com/community/thread/Mjk5Nw/body-signals-are-you-listening/",
  },
  {
    id: 2969,
    slug: "yoga-for-mental-health",
    title: "Yoga for mental health",
    url: "https://www.betheshyft.com/community/thread/Mjk2OQ/yoga-for-mental-health/",
  },
  {
    id: 2886,
    slug: "wellness-holistically",
    title: "Wellness holistically",
    url: "https://www.betheshyft.com/community/thread/Mjg4Ng/wellness-holistically/",
  },
  {
    id: 2854,
    slug: "importance-of-regular-bowels",
    title: "Importance of regular bowels!",
    url: "https://www.betheshyft.com/community/thread/Mjg1NA/importance-of-regular-bowels/",
  },
  {
    id: 2850,
    slug: "importance-of-seasonal-fruits-and-vegetables",
    title: "Importance of seasonal fruits and vegetables",
    url: "https://www.betheshyft.com/community/thread/Mjg1MA/importance-of-seasonal-fruits-and-vegetables/",
  },
  {
    id: 2849,
    slug: "how-should-a-balanced-meal-look-like",
    title: "How should a balanced meal look like?",
    url: "https://www.betheshyft.com/community/thread/Mjg0OQ/how-should-a-balanced-meal-look-like/",
  },
  {
    id: 2848,
    slug: "take-yoga-off-the-mat",
    title: "🧘‍♀️Take Yoga off The Mat 🧘‍♀️",
    url: "https://www.betheshyft.com/community/thread/Mjg0OA/take-yoga-off-the-mat/",
  },
  {
    id: 2843,
    slug: "morning-practice",
    title: "Morning Practice  🌸",
    url: "https://www.betheshyft.com/community/thread/Mjg0Mw/morning-practice/",
  },
  {
    id: 2829,
    slug: "favourite-winter-breakfast-methi-parantha-and-curd-with",
    title:
      "Favourite winter breakfast - Methi parantha and curd with chia seeds.",
    url: "https://www.betheshyft.com/community/thread/MjgyOQ/favourite-winter-breakfast-methi-parantha-and-curd-with/",
  },
  {
    id: 2828,
    slug: "symptomsofhypertension",
    title: "#Symptomsofhypertension",
    url: "https://www.betheshyft.com/community/thread/MjgyOA/symptomsofhypertension/",
  },
  {
    id: 2825,
    slug: "gooseberry-or-amla",
    title: "Gooseberry or Amla",
    url: "https://www.betheshyft.com/community/thread/MjgyNQ/gooseberry-or-amla/",
  },
  {
    id: 2815,
    slug: "magic-magnesium",
    title: "Magic MAGNESIUM !!",
    url: "https://www.betheshyft.com/community/thread/MjgxNQ/magic-magnesium/",
  },
  {
    id: 2808,
    slug: "detox-your-body",
    title: "Detox Your Body",
    url: "https://www.betheshyft.com/community/thread/MjgwOA/detox-your-body/",
  },
  {
    id: 2804,
    slug: "tips-to-help-control-stress",
    title: "Tips to help control stress",
    url: "https://www.betheshyft.com/community/thread/MjgwNA/tips-to-help-control-stress/",
  },
  {
    id: 2792,
    slug: "ways-to-stay-hydrated",
    title: "Ways to stay hydrated",
    url: "https://www.betheshyft.com/community/thread/Mjc5Mg/ways-to-stay-hydrated/",
  },
  {
    id: 2791,
    slug: "conditions-affecting-water-needs",
    title: "Conditions affecting water needs",
    url: "https://www.betheshyft.com/community/thread/Mjc5MQ/conditions-affecting-water-needs/",
  },
  {
    id: 2789,
    slug: "importance-of-staying-hydrated-in-the-winter",
    title: "Importance of staying hydrated in the winter",
    url: "https://www.betheshyft.com/community/thread/Mjc4OQ/importance-of-staying-hydrated-in-the-winter/",
  },
  {
    id: 2784,
    slug: "couscous-with-veggies-and-herbs",
    title: "couscous with veggies and herbs 🌿",
    url: "https://www.betheshyft.com/community/thread/Mjc4NA/couscous-with-veggies-and-herbs/",
  },
  {
    id: 2777,
    slug: "chai-time",
    title: "Chai time ⚘️",
    url: "https://www.betheshyft.com/community/thread/Mjc3Nw/chai-time/",
  },
  {
    id: 2735,
    slug: "dairy-and-dairy-products-yay-or-nay",
    title: "Dairy and dairy products yay or nay !!!",
    url: "https://www.betheshyft.com/community/thread/MjczNQ/dairy-and-dairy-products-yay-or-nay/",
  },
  {
    id: 2731,
    slug: "from-my-kitchen-garden",
    title: "From my kitchen garden!",
    url: "https://www.betheshyft.com/community/thread/MjczMQ/from-my-kitchen-garden/",
  },
  {
    id: 2728,
    slug: "yoga-mat-your-own-space",
    title: "YOGA MAT - YOUR OWN SPACE:)",
    url: "https://www.betheshyft.com/community/thread/MjcyOA/yoga-mat-your-own-space/",
  },
  {
    id: 2726,
    slug: "how-do-you-know-if-you-have-pcos",
    title: "How do you know if you have PCOS?",
    url: "https://www.betheshyft.com/community/thread/MjcyNg/how-do-you-know-if-you-have-pcos/",
  },
  {
    id: 2720,
    slug: "that-feeling-of-getting-periods-on-time",
    title: "That feeling of getting periods on time!",
    url: "https://www.betheshyft.com/community/thread/MjcyMA/that-feeling-of-getting-periods-on-time/",
  },
  {
    id: 2719,
    slug: "watch-out-for-these-guys-when-diagnosed-with",
    title: "Watch out for these guys when diagnosed with High Blood Pressure.",
    url: "https://www.betheshyft.com/community/thread/MjcxOQ/watch-out-for-these-guys-when-diagnosed-with/",
  },
  {
    id: 2708,
    slug: "consistency-is-the-key",
    title: "Consistency is the key!",
    url: "https://www.betheshyft.com/community/thread/MjcwOA/consistency-is-the-key/",
  },
  {
    id: 2683,
    slug: "will-eating-fat-free-foods-make-you-lose",
    title: "Will eating fat free foods make you lose weight?",
    url: "https://www.betheshyft.com/community/thread/MjY4Mw/will-eating-fat-free-foods-make-you-lose/",
  },
  {
    id: 2677,
    slug: "shavasana-the-favourite",
    title: "Shavasana-- The Favourite ❤️",
    url: "https://www.betheshyft.com/community/thread/MjY3Nw/shavasana-the-favourite/",
  },
  {
    id: 2667,
    slug: "backbends-chest-openers",
    title: "Backbends - chest openers",
    url: "https://www.betheshyft.com/community/thread/MjY2Nw/backbends-chest-openers/",
  },
  {
    id: 2652,
    slug: "satisfied",
    title: "Satisfied..",
    url: "https://www.betheshyft.com/community/thread/MjY1Mg/satisfied/",
  },
  {
    id: 2613,
    slug: "right-sitting-posture-at-your-computer",
    title: "Right Sitting Posture at Your Computer",
    url: "https://www.betheshyft.com/community/thread/MjYxMw/right-sitting-posture-at-your-computer/",
  },
  {
    id: 2564,
    slug: "always-enjoy-the-journey",
    title: "Always enjoy the journey",
    url: "https://www.betheshyft.com/community/thread/MjU2NA/always-enjoy-the-journey/",
  },
  {
    id: 2543,
    slug: "benefits-of-exercise",
    title: "Benefits of Exercise",
    url: "https://www.betheshyft.com/community/thread/MjU0Mw/benefits-of-exercise/",
  },
  {
    id: 2511,
    slug: "go-easy-with-your-yoga-asanas",
    title: "🤸🏻‍♀️Go Easy With Your Yoga Asanas 🤸🏻‍♀️",
    url: "https://www.betheshyft.com/community/thread/MjUxMQ/go-easy-with-your-yoga-asanas/",
  },
  {
    id: 2488,
    slug: "healthy-eating-tips-for-sticking-to-your-diet",
    title:
      "Healthy eating tips for sticking to your diet on vacation ( contd.)",
    url: "https://www.betheshyft.com/community/thread/MjQ4OA/healthy-eating-tips-for-sticking-to-your-diet/",
  },
  {
    id: 2482,
    slug: "healthy-eating-tips-for-sticking-to-your-diet",
    title: "Healthy eating tips for sticking to your diet on vacation!",
    url: "https://www.betheshyft.com/community/thread/MjQ4Mg/healthy-eating-tips-for-sticking-to-your-diet/",
  },
  {
    id: 2478,
    slug: "bridge-pose",
    title: "Bridge Pose",
    url: "https://www.betheshyft.com/community/thread/MjQ3OA/bridge-pose/",
  },
  {
    id: 2467,
    slug: "roasted-chana",
    title: "Roasted chana",
    url: "https://www.betheshyft.com/community/thread/MjQ2Nw/roasted-chana/",
  },
  {
    id: 2465,
    slug: "morning-affirmations-to-start-your-day",
    title: "Morning Affirmations to Start Your Day",
    url: "https://www.betheshyft.com/community/thread/MjQ2NQ/morning-affirmations-to-start-your-day/",
  },
  {
    id: 2463,
    slug: "beat-the-winter-blues",
    title: "Beat the winter blues 🌻🍎🥕🌞",
    url: "https://www.betheshyft.com/community/thread/MjQ2Mw/beat-the-winter-blues/",
  },
  {
    id: 2431,
    slug: "winter-colours",
    title: "Winter colours!",
    url: "https://www.betheshyft.com/community/thread/MjQzMQ/winter-colours/",
  },
  {
    id: 2346,
    slug: "how-prenatal-yoga-class-helps",
    title: "How Prenatal Yoga Class Helps",
    url: "https://www.betheshyft.com/community/thread/MjM0Ng/how-prenatal-yoga-class-helps/",
  },
  {
    id: 2344,
    slug: "magnificent",
    title: "#magnificent",
    url: "https://www.betheshyft.com/community/thread/MjM0NA/magnificent/",
  },
  {
    id: 2329,
    slug: "a-happy-state-of-mind",
    title: "🧘‍♀️A Happy State Of Mind 🧘‍♀️",
    url: "https://www.betheshyft.com/community/thread/MjMyOQ/a-happy-state-of-mind/",
  },
  {
    id: 2297,
    slug: "eat-late-gain-weight",
    title: "Eat late gain weight?",
    url: "https://www.betheshyft.com/community/thread/MjI5Nw/eat-late-gain-weight/",
  },
  {
    id: 2278,
    slug: "5-health-benefits-of-soaking-in-the-winter",
    title: "5 Health Benefits Of Soaking in The Winter Sun",
    url: "https://www.betheshyft.com/community/thread/MjI3OA/5-health-benefits-of-soaking-in-the-winter/",
  },
  {
    id: 2255,
    slug: "have-you-wondered-what-you-should-eat-for",
    title: "Have you wondered what you should eat for breakfast?",
    url: "https://www.betheshyft.com/community/thread/MjI1NQ/have-you-wondered-what-you-should-eat-for/",
  },
  {
    id: 2254,
    slug: "yogic-gazing-trataka",
    title: "Yogic gazing(Trataka)",
    url: "https://www.betheshyft.com/community/thread/MjI1NA/yogic-gazing-trataka/",
  },
  {
    id: 2252,
    slug: "regular-physical-activity",
    title: "Regular Physical Activity",
    url: "https://www.betheshyft.com/community/thread/MjI1Mg/regular-physical-activity/",
  },
  {
    id: 2234,
    slug: "dry-skin-in-winters-a-concern",
    title: "Dry skin in winters ...a concern ??",
    url: "https://www.betheshyft.com/community/thread/MjIzNA/dry-skin-in-winters-a-concern/",
  },
  {
    id: 2183,
    slug: "winter-is-here",
    title: "Winter is here",
    url: "https://www.betheshyft.com/community/thread/MjE4Mw/winter-is-here/",
  },
  {
    id: 2168,
    slug: "the-weather-calls-for-some-hot-chocolate-innit",
    title: "The weather calls for some ‘Hot Chocolate’ innit?",
    url: "https://www.betheshyft.com/community/thread/MjE2OA/the-weather-calls-for-some-hot-chocolate-innit/",
  },
  {
    id: 2118,
    slug: "legs-strengthening",
    title: "Legs strengthening",
    url: "https://www.betheshyft.com/community/thread/MjExOA/legs-strengthening/",
  },
  {
    id: 2116,
    slug: "natural-ways-to-cleanse-the-air-at-home",
    title: "Natural ways to cleanse the air at home",
    url: "https://www.betheshyft.com/community/thread/MjExNg/natural-ways-to-cleanse-the-air-at-home/",
  },
  {
    id: 2114,
    slug: "some-thought-provoking-facts-about-something-we-all",
    title:
      "Some thought-provoking facts about something we all do thousands of times a day: Breathe 🫁",
    url: "https://www.betheshyft.com/community/thread/MjExNA/some-thought-provoking-facts-about-something-we-all/",
  },
  {
    id: 2113,
    slug: "new-to-meditation",
    title: "New to meditation?",
    url: "https://www.betheshyft.com/community/thread/MjExMw/new-to-meditation/",
  },
  {
    id: 2111,
    slug: "things-to-keep-in-mind-while-practicing-prenatal",
    title: "Things to keep in mind while practicing prenatal yoga",
    url: "https://www.betheshyft.com/community/thread/MjExMQ/things-to-keep-in-mind-while-practicing-prenatal/",
  },
  {
    id: 2102,
    slug: "work-life-balance",
    title: "Work life balance",
    url: "https://www.betheshyft.com/community/thread/MjEwMg/work-life-balance/",
  },
  {
    id: 2095,
    slug: "foods-which-can-boost-the-health-and-growth",
    title: "Foods which can boost the health and growth of hair!",
    url: "https://www.betheshyft.com/community/thread/MjA5NQ/foods-which-can-boost-the-health-and-growth/",
  },
  {
    id: 2080,
    slug: "eating-out-and-eating-right",
    title: "Eating out and eating right.",
    url: "https://www.betheshyft.com/community/thread/MjA4MA/eating-out-and-eating-right/",
  },
  {
    id: 2065,
    slug: "signs-you-ve-gotten-good-night-s-sleep",
    title: "Signs you've gotten good night's sleep",
    url: "https://www.betheshyft.com/community/thread/MjA2NQ/signs-you-ve-gotten-good-night-s-sleep/",
  },
  {
    id: 1998,
    slug: "sleep-recipe-for-mental-physical-and-emotional-strength",
    title: "Sleep recipe for mental, physical, and emotional strength",
    url: "https://www.betheshyft.com/community/thread/MTk5OA/sleep-recipe-for-mental-physical-and-emotional-strength/",
  },
  {
    id: 1995,
    slug: "feel-warm-thiswinter-practice-yoga",
    title: "Feel Warm This Winter - Practice Yoga ❄️🧘‍♀️",
    url: "https://www.betheshyft.com/community/thread/MTk5NQ/feel-warm-thiswinter-practice-yoga/",
  },
  {
    id: 1994,
    slug: "happy-hormones-for-better-mood",
    title: "Happy hormones for better mood",
    url: "https://www.betheshyft.com/community/thread/MTk5NA/happy-hormones-for-better-mood/",
  },
  {
    id: 1991,
    slug: "do-you-think-drinking-tea-coffee-will-hamper",
    title: "Do you think drinking tea/coffee will hamper weight loss ?",
    url: "https://www.betheshyft.com/community/thread/MTk5MQ/do-you-think-drinking-tea-coffee-will-hamper/",
  },
  {
    id: 1988,
    slug: "abc-rule",
    title: "ABC RULE",
    url: "https://www.betheshyft.com/community/thread/MTk4OA/abc-rule/",
  },
  {
    id: 1984,
    slug: "breathwork",
    title: "Breathwork",
    url: "https://www.betheshyft.com/community/thread/MTk4NA/breathwork/",
  },
  {
    id: 1981,
    slug: "critical-nutrients-for-postpartum-mothers",
    title: "Critical nutrients for postpartum mothers",
    url: "https://www.betheshyft.com/community/thread/MTk4MQ/critical-nutrients-for-postpartum-mothers/",
  },
  {
    id: 1980,
    slug: "half-moon-pose",
    title: "HALF- MOON POSE",
    url: "https://www.betheshyft.com/community/thread/MTk4MA/half-moon-pose/",
  },
  {
    id: 1972,
    slug: "improve-your-gut-healthboost-immunity",
    title: "Improve your Gut health…Boost immunity !!!",
    url: "https://www.betheshyft.com/community/thread/MTk3Mg/improve-your-gut-healthboost-immunity/",
  },
  {
    id: 1960,
    slug: "todays-lunch-bowl",
    title: "Today’s Lunch Bowl.",
    url: "https://www.betheshyft.com/community/thread/MTk2MA/todays-lunch-bowl/",
  },
  {
    id: 1897,
    slug: "balance",
    title: "Balance",
    url: "https://www.betheshyft.com/community/thread/MTg5Nw/balance/",
  },
  {
    id: 1891,
    slug: "easy-ways-to-manage-gut-health-during-winter",
    title: "Easy ways to manage gut health during winter",
    url: "https://www.betheshyft.com/community/thread/MTg5MQ/easy-ways-to-manage-gut-health-during-winter/",
  },
  {
    id: 1840,
    slug: "keeping-up-the-motivation",
    title: "Keeping up the motivation",
    url: "https://www.betheshyft.com/community/thread/MTg0MA/keeping-up-the-motivation/",
  },
  {
    id: 1805,
    slug: "digital-detox",
    title: "Digital Detox 📱👩🏻‍💻",
    url: "https://www.betheshyft.com/community/thread/MTgwNQ/digital-detox/",
  },
  {
    id: 1804,
    slug: "windshield-wiper-exercise",
    title: "Windshield Wiper exercise",
    url: "https://www.betheshyft.com/community/thread/MTgwNA/windshield-wiper-exercise/",
  },
  {
    id: 1774,
    slug: "be-mindful",
    title: "Be Mindful !",
    url: "https://www.betheshyft.com/community/thread/MTc3NA/be-mindful/",
  },
  {
    id: 1773,
    slug: "supine-twists",
    title: "Supine twists",
    url: "https://www.betheshyft.com/community/thread/MTc3Mw/supine-twists/",
  },
  {
    id: 1766,
    slug: "good-night",
    title: "Good night",
    url: "https://www.betheshyft.com/community/thread/MTc2Ng/good-night/",
  },
  {
    id: 1676,
    slug: "benefits-of-morning-sunlight",
    title: "Benefits of morning sunlight!",
    url: "https://www.betheshyft.com/community/thread/MTY3Ng/benefits-of-morning-sunlight/",
  },
  {
    id: 1611,
    slug: "listen-to-yourself",
    title: "Listen to yourself",
    url: "https://www.betheshyft.com/community/thread/MTYxMQ/listen-to-yourself/",
  },
  {
    id: 1582,
    slug: "boost-your-metabolism-naturally",
    title: "Boost your metabolism naturally !!!",
    url: "https://www.betheshyft.com/community/thread/MTU4Mg/boost-your-metabolism-naturally/",
  },
  {
    id: 1580,
    slug: "hi-sukanya-tell-me-an-asana-to-reduce",
    title: "Hi Sukanya, tell me an asana to reduce belly fat🥹",
    url: "https://www.betheshyft.com/community/thread/MTU4MA/hi-sukanya-tell-me-an-asana-to-reduce/",
  },
  {
    id: 1558,
    slug: "balanced-meals",
    title: "Balanced meals !!",
    url: "https://www.betheshyft.com/community/thread/MTU1OA/balanced-meals/",
  },
  {
    id: 1533,
    slug: "benefits-of-proper-alignment",
    title: "Benefits Of Proper Alignment",
    url: "https://www.betheshyft.com/community/thread/MTUzMw/benefits-of-proper-alignment/",
  },
  {
    id: 1506,
    slug: "seated-forward-bend-paschimottanasana",
    title: "Seated Forward Bend (Paschimottanasana)",
    url: "https://www.betheshyft.com/community/thread/MTUwNg/seated-forward-bend-paschimottanasana/",
  },
  {
    id: 1505,
    slug: "tips-for-practicing-morning-yoga",
    title: "TIPS FOR PRACTICING MORNING YOGA",
    url: "https://www.betheshyft.com/community/thread/MTUwNQ/tips-for-practicing-morning-yoga/",
  },
  {
    id: 1504,
    slug: "can-yoga-build-muscle",
    title: "Can yoga build muscle?",
    url: "https://www.betheshyft.com/community/thread/MTUwNA/can-yoga-build-muscle/",
  },
  {
    id: 1496,
    slug: "dinner-plate-taste-nutrition-comfort",
    title: "Dinner plate - Taste ✅ Nutrition ✅ Comfort ✅",
    url: "https://www.betheshyft.com/community/thread/MTQ5Ng/dinner-plate-taste-nutrition-comfort/",
  },
  {
    id: 1488,
    slug: "core-strengthening-during-pregnancy",
    title: "Core strengthening during pregnancy",
    url: "https://www.betheshyft.com/community/thread/MTQ4OA/core-strengthening-during-pregnancy/",
  },
  {
    id: 1445,
    slug: "trimester-three-what-to-eat-why",
    title: "Trimester three !! What to eat & why ?",
    url: "https://www.betheshyft.com/community/thread/MTQ0NQ/trimester-three-what-to-eat-why/",
  },
  {
    id: 1432,
    slug: "top-winter-foods-to-include-in-your-diet",
    title: "Top winter foods to include in your diet today!",
    url: "https://www.betheshyft.com/community/thread/MTQzMg/top-winter-foods-to-include-in-your-diet/",
  },
  {
    id: 1431,
    slug: "yoga-for-everyone",
    title: "YOGA FOR EVERYONE",
    url: "https://www.betheshyft.com/community/thread/MTQzMQ/yoga-for-everyone/",
  },
  {
    id: 1424,
    slug: "diabetes-and-hypertension",
    title: "Diabetes and Hypertension",
    url: "https://www.betheshyft.com/community/thread/MTQyNA/diabetes-and-hypertension/",
  },
  {
    id: 1423,
    slug: "what-are-the-benefits-of-twists",
    title: "What are the benefits of twists?",
    url: "https://www.betheshyft.com/community/thread/MTQyMw/what-are-the-benefits-of-twists/",
  },
  {
    id: 1407,
    slug: "trimester-two-what-to-eat-why",
    title: "Trimester two ....what to eat & why ?",
    url: "https://www.betheshyft.com/community/thread/MTQwNw/trimester-two-what-to-eat-why/",
  },
  {
    id: 1406,
    slug: "foods-for-morning-sickness",
    title: "Foods for Morning Sickness",
    url: "https://www.betheshyft.com/community/thread/MTQwNg/foods-for-morning-sickness/",
  },
  {
    id: 1404,
    slug: "potato-and-that-too-sweet-potato",
    title: "POTATO...🍠!!! And that too SWEET POTATO 😧",
    url: "https://www.betheshyft.com/community/thread/MTQwNA/potato-and-that-too-sweet-potato/",
  },
  {
    id: 1399,
    slug: "stress-stress-stress-i-don-t-like-it",
    title: "Stress.Stress.Stress. I don't like it.I avoid but",
    url: "https://www.betheshyft.com/community/thread/MTM5OQ/stress-stress-stress-i-don-t-like-it/",
  },
  {
    id: 1395,
    slug: "work-life-balance",
    title: "⚖️ Work-Life Balance ⚖️",
    url: "https://www.betheshyft.com/community/thread/MTM5NQ/work-life-balance/",
  },
  {
    id: 1338,
    slug: "mezze-platter",
    title: "Mezze Platter. 🍱",
    url: "https://www.betheshyft.com/community/thread/MTMzOA/mezze-platter/",
  },
  {
    id: 1297,
    slug: "believe",
    title: "Believe.",
    url: "https://www.betheshyft.com/community/thread/MTI5Nw/believe/",
  },
  {
    id: 1291,
    slug: "positive-birth-affirmations",
    title: "Positive Birth Affirmations",
    url: "https://www.betheshyft.com/community/thread/MTI5MQ/positive-birth-affirmations/",
  },
  {
    id: 1288,
    slug: "stop-breath-observe-proceed",
    title: "Stop. Breath. Observe. Proceed.",
    url: "https://www.betheshyft.com/community/thread/MTI4OA/stop-breath-observe-proceed/",
  },
  {
    id: 1286,
    slug: "symptomsofdiabetes",
    title: "#symptomsofdiabetes",
    url: "https://www.betheshyft.com/community/thread/MTI4Ng/symptomsofdiabetes/",
  },
  {
    id: 1278,
    slug: "here-s-the-secret-to-step-up-your",
    title: "Here's the secret to step up your metabolism....",
    url: "https://www.betheshyft.com/community/thread/MTI3OA/here-s-the-secret-to-step-up-your/",
  },
  {
    id: 1274,
    slug: "doodle",
    title: "#doodle",
    url: "https://www.betheshyft.com/community/thread/MTI3NA/doodle/",
  },
  {
    id: 1271,
    slug: "restorative-child-pose",
    title: "Restorative Child Pose",
    url: "https://www.betheshyft.com/community/thread/MTI3MQ/restorative-child-pose/",
  },
  {
    id: 1268,
    slug: "are-you-eating-for-2-people",
    title: "Are you eating for 2 people?",
    url: "https://www.betheshyft.com/community/thread/MTI2OA/are-you-eating-for-2-people/",
  },
  {
    id: 1266,
    slug: "never-neglect",
    title: "Never neglect",
    url: "https://www.betheshyft.com/community/thread/MTI2Ng/never-neglect/",
  },
  {
    id: 1258,
    slug: "symptoms-to-know-if-you-have-an-anxiety",
    title: "Symptoms to know if you have an Anxiety Disorder",
    url: "https://www.betheshyft.com/community/thread/MTI1OA/symptoms-to-know-if-you-have-an-anxiety/",
  },
  {
    id: 1249,
    slug: "trimester-1-what-to-eat-why",
    title: "Trimester 1 - what to eat & why ??",
    url: "https://www.betheshyft.com/community/thread/MTI0OQ/trimester-1-what-to-eat-why/",
  },
  {
    id: 1245,
    slug: "i-have-lost-weight-how-fast-am-i",
    title: "I have lost weight,how fast am I going to regain?",
    url: "https://www.betheshyft.com/community/thread/MTI0NQ/i-have-lost-weight-how-fast-am-i/",
  },
  {
    id: 1222,
    slug: "letting-go",
    title: "Letting go!",
    url: "https://www.betheshyft.com/community/thread/MTIyMg/letting-go/",
  },
  {
    id: 1210,
    slug: "happy-new-year-everyone",
    title: "Happy new year everyone ✨️ 💛",
    url: "https://www.betheshyft.com/community/thread/MTIxMA/happy-new-year-everyone/",
  },
  {
    id: 1206,
    slug: "warm-up-for-6-minutes-before-starting-work",
    title: "Warm Up for 6 ‘minutes before starting work out",
    url: "https://www.betheshyft.com/community/thread/MTIwNg/warm-up-for-6-minutes-before-starting-work/",
  },
  {
    id: 1156,
    slug: "halasana-plough-pose",
    title: "Halasana (Plough Pose)",
    url: "https://www.betheshyft.com/community/thread/MTE1Ng/halasana-plough-pose/",
  },
  {
    id: 1153,
    slug: "the-answer-is-always-calorie-deficit",
    title: "The answer is always Calorie Deficit",
    url: "https://www.betheshyft.com/community/thread/MTE1Mw/the-answer-is-always-calorie-deficit/",
  },
  {
    id: 1146,
    slug: "everything-you-need-is-within-you",
    title: "Everything you need is within you🦋",
    url: "https://www.betheshyft.com/community/thread/MTE0Ng/everything-you-need-is-within-you/",
  },
  {
    id: 1105,
    slug: "the-love-and-hate-relationship-with-sweets",
    title: "The love and hate relationship with sweets!",
    url: "https://www.betheshyft.com/community/thread/MTEwNQ/the-love-and-hate-relationship-with-sweets/",
  },
  {
    id: 1082,
    slug: "how-does-caffeine-affect-sleep",
    title: "How does caffeine affect sleep?",
    url: "https://www.betheshyft.com/community/thread/MTA4Mg/how-does-caffeine-affect-sleep/",
  },
  {
    id: 1075,
    slug: "asans-for-good-digestion",
    title: "Asans for good digestion",
    url: "https://www.betheshyft.com/community/thread/MTA3NQ/asans-for-good-digestion/",
  },
  {
    id: 1069,
    slug: "3-nutrients-for-a-healthy-gut",
    title: "3 nutrients for a healthy gut",
    url: "https://www.betheshyft.com/community/thread/MTA2OQ/3-nutrients-for-a-healthy-gut/",
  },
  {
    id: 1064,
    slug: "weight-management-during-pcos",
    title: "Weight Management during PCOS",
    url: "https://www.betheshyft.com/community/thread/MTA2NA/weight-management-during-pcos/",
  },
  {
    id: 1059,
    slug: "gentle-reminder",
    title: "Gentle reminder",
    url: "https://www.betheshyft.com/community/thread/MTA1OQ/gentle-reminder/",
  },
  {
    id: 1058,
    slug: "how-do-i-speed-up-my-weight-loss",
    title: "How Do I Speed Up My Weight Loss?",
    url: "https://www.betheshyft.com/community/thread/MTA1OA/how-do-i-speed-up-my-weight-loss/",
  },
  {
    id: 1003,
    slug: "health-implications-of-pcos",
    title: "Health Implications of PCOS",
    url: "https://www.betheshyft.com/community/thread/MTAwMw/health-implications-of-pcos/",
  },
  {
    id: 997,
    slug: "step-up-your-iron",
    title: "Step up your iron !!",
    url: "https://www.betheshyft.com/community/thread/OTk3/step-up-your-iron/",
  },
  {
    id: 995,
    slug: "not-feeling-thirsty-in-winters-try-these",
    title: "Not feeling thirsty in winters ? TRY THESE...",
    url: "https://www.betheshyft.com/community/thread/OTk1/not-feeling-thirsty-in-winters-try-these/",
  },
  {
    id: 980,
    slug: "strengthen-pelvic-floor-muscles",
    title: "Strengthen pelvic floor muscles",
    url: "https://www.betheshyft.com/community/thread/OTgw/strengthen-pelvic-floor-muscles/",
  },
  {
    id: 976,
    slug: "guidelines-for-exercise-during-pregnancy",
    title: "Guidelines for Exercise During Pregnancy",
    url: "https://www.betheshyft.com/community/thread/OTc2/guidelines-for-exercise-during-pregnancy/",
  },
  {
    id: 971,
    slug: "lifestyle-changes-to-manage-high-bp",
    title: "Lifestyle changes to manage high bp",
    url: "https://www.betheshyft.com/community/thread/OTcx/lifestyle-changes-to-manage-high-bp/",
  },
  {
    id: 970,
    slug: "risks-of-extended-sitting",
    title: "👩‍💻Risks of Extended Sitting 🧑‍💻",
    url: "https://www.betheshyft.com/community/thread/OTcw/risks-of-extended-sitting/",
  },
  {
    id: 954,
    slug: "cycle-of-sweet-cravings",
    title: "Cycle of sweet cravings",
    url: "https://www.betheshyft.com/community/thread/OTU0/cycle-of-sweet-cravings/",
  },
  {
    id: 935,
    slug: "my-go-to-breakfast",
    title: "My go to breakfast! 🍲",
    url: "https://www.betheshyft.com/community/thread/OTM1/my-go-to-breakfast/",
  },
  {
    id: 930,
    slug: "stress-management",
    title: "Stress Management",
    url: "https://www.betheshyft.com/community/thread/OTMw/stress-management/",
  },
  {
    id: 929,
    slug: "find-your-center",
    title: "Find your center",
    url: "https://www.betheshyft.com/community/thread/OTI5/find-your-center/",
  },
  {
    id: 916,
    slug: "winding-down",
    title: "Winding Down",
    url: "https://www.betheshyft.com/community/thread/OTE2/winding-down/",
  },
  {
    id: 896,
    slug: "water-essential-but-overlooked-nutrient",
    title: "Water : Essential but overlooked nutrient",
    url: "https://www.betheshyft.com/community/thread/ODk2/water-essential-but-overlooked-nutrient/",
  },
  {
    id: 884,
    slug: "symptoms-of-pcos",
    title: "Symptoms of PCOS",
    url: "https://www.betheshyft.com/community/thread/ODg0/symptoms-of-pcos/",
  },
  {
    id: 867,
    slug: "yoga-for-diabetes",
    title: "Yoga for diabetes",
    url: "https://www.betheshyft.com/community/thread/ODY3/yoga-for-diabetes/",
  },
  {
    id: 866,
    slug: "you-are-beautiful-momma",
    title: "You are beautiful Momma!",
    url: "https://www.betheshyft.com/community/thread/ODY2/you-are-beautiful-momma/",
  },
  {
    id: 862,
    slug: "management-of-health-post-delivery",
    title: "Management of health post delivery",
    url: "https://www.betheshyft.com/community/thread/ODYy/management-of-health-post-delivery/",
  },
  {
    id: 847,
    slug: "the-iconics",
    title: "The Iconics",
    url: "https://www.betheshyft.com/community/thread/ODQ3/the-iconics/",
  },
  {
    id: 832,
    slug: "why-is-radish-considered-a-winter-superfood",
    title: "Why is radish considered a winter superfood?",
    url: "https://www.betheshyft.com/community/thread/ODMy/why-is-radish-considered-a-winter-superfood/",
  },
  {
    id: 828,
    slug: "the-beauty-of-yoga",
    title: "The beauty of yoga",
    url: "https://www.betheshyft.com/community/thread/ODI4/the-beauty-of-yoga/",
  },
  {
    id: 827,
    slug: "pelvic-floor-health",
    title: "Pelvic Floor Health",
    url: "https://www.betheshyft.com/community/thread/ODI3/pelvic-floor-health/",
  },
  {
    id: 826,
    slug: "mindful-mornings",
    title: "Mindful mornings!",
    url: "https://www.betheshyft.com/community/thread/ODI2/mindful-mornings/",
  },
  {
    id: 825,
    slug: "how-often-should-you-do-yoga",
    title: "HOW OFTEN SHOULD YOU DO YOGA?",
    url: "https://www.betheshyft.com/community/thread/ODI1/how-often-should-you-do-yoga/",
  },
  {
    id: 809,
    slug: "red-flags-of-weight-loss",
    title: "Red flags of weight loss",
    url: "https://www.betheshyft.com/community/thread/ODA5/red-flags-of-weight-loss/",
  },
  {
    id: 801,
    slug: "safety-guidelines-for-prenatal-yoga",
    title: "Safety Guidelines for Prenatal Yoga",
    url: "https://www.betheshyft.com/community/thread/ODAx/safety-guidelines-for-prenatal-yoga/",
  },
  {
    id: 799,
    slug: "stress-lifestyle-factors-and-infertility",
    title: "Stress, Lifestyle Factors and Infertility",
    url: "https://www.betheshyft.com/community/thread/Nzk5/stress-lifestyle-factors-and-infertility/",
  },
  {
    id: 797,
    slug: "beat-those-cravings-damn",
    title: "Beat those cravings …. Damn !",
    url: "https://www.betheshyft.com/community/thread/Nzk3/beat-those-cravings-damn/",
  },
  {
    id: 795,
    slug: "best-time-for-practising-yoga",
    title: "Best Time For Practising Yoga",
    url: "https://www.betheshyft.com/community/thread/Nzk1/best-time-for-practising-yoga/",
  },
  {
    id: 785,
    slug: "3-myths-about-type-2-diabetes",
    title: "3 myths about Type 2 diabetes",
    url: "https://www.betheshyft.com/community/thread/Nzg1/3-myths-about-type-2-diabetes/",
  },
  {
    id: 784,
    slug: "3-types-of-diabetes",
    title: "3 Types of Diabetes",
    url: "https://www.betheshyft.com/community/thread/Nzg0/3-types-of-diabetes/",
  },
  {
    id: 767,
    slug: "fruits-and-diabetes",
    title: "Fruits and diabetes",
    url: "https://www.betheshyft.com/community/thread/NzY3/fruits-and-diabetes/",
  },
  {
    id: 765,
    slug: "rice-and-diabetes",
    title: "Rice and diabetes",
    url: "https://www.betheshyft.com/community/thread/NzY1/rice-and-diabetes/",
  },
  {
    id: 764,
    slug: "best-time-to-take-thyroid-medication",
    title: "Best time to take thyroid medication",
    url: "https://www.betheshyft.com/community/thread/NzY0/best-time-to-take-thyroid-medication/",
  },
  {
    id: 762,
    slug: "foods-to-be-consumed-in-moderation-in-hypothyroidi",
    title: "Foods to be consumed in moderation in hypothyroidi",
    url: "https://www.betheshyft.com/community/thread/NzYy/foods-to-be-consumed-in-moderation-in-hypothyroidi/",
  },
  {
    id: 739,
    slug: "no-crazy-diets",
    title: "NO CRAZY DIETS ⚠️",
    url: "https://www.betheshyft.com/community/thread/NzM5/no-crazy-diets/",
  },
  {
    id: 736,
    slug: "spinal-twist-for-diabetes",
    title: "Spinal Twist for Diabetes",
    url: "https://www.betheshyft.com/community/thread/NzM2/spinal-twist-for-diabetes/",
  },
  {
    id: 690,
    slug: "still-solitude",
    title: "STILL.. Solitude..",
    url: "https://www.betheshyft.com/community/thread/Njkw/still-solitude/",
  },
  {
    id: 590,
    slug: "polycystic-ovary-syndrome",
    title: "Polycystic Ovary Syndrome",
    url: "https://www.betheshyft.com/community/thread/NTkw/polycystic-ovary-syndrome/",
  },
  {
    id: 580,
    slug: "it-s-never-too-late",
    title: "It's never too late...",
    url: "https://www.betheshyft.com/community/thread/NTgw/it-s-never-too-late/",
  },
  {
    id: 579,
    slug: "hashimoto-thyroiditis",
    title: "Hashimoto thyroiditis",
    url: "https://www.betheshyft.com/community/thread/NTc5/hashimoto-thyroiditis/",
  },
  {
    id: 575,
    slug: "benefits-of-binaural-beats",
    title: "Benefits of binaural beats",
    url: "https://www.betheshyft.com/community/thread/NTc1/benefits-of-binaural-beats/",
  },
  {
    id: 562,
    slug: "periods-and-pcos",
    title: "Periods and PCOS",
    url: "https://www.betheshyft.com/community/thread/NTYy/periods-and-pcos/",
  },
  {
    id: 510,
    slug: "step-up-your-protein",
    title: "Step up your protein !!",
    url: "https://www.betheshyft.com/community/thread/NTEw/step-up-your-protein/",
  },
  {
    id: 505,
    slug: "top-foods-for-breastfeeding-moms",
    title: "Top Foods for Breastfeeding Moms",
    url: "https://www.betheshyft.com/community/thread/NTA1/top-foods-for-breastfeeding-moms/",
  },
  {
    id: 504,
    slug: "nutrients-for-post-natal-mothers",
    title: "Nutrients for Post Natal Mothers",
    url: "https://www.betheshyft.com/community/thread/NTA0/nutrients-for-post-natal-mothers/",
  },
  {
    id: 501,
    slug: "fatigue-during-pregnancy",
    title: "Fatigue during pregnancy",
    url: "https://www.betheshyft.com/community/thread/NTAx/fatigue-during-pregnancy/",
  },
  {
    id: 500,
    slug: "hydrate-hydrate-hydrate",
    title: "Hydrate! Hydrate! Hydrate!",
    url: "https://www.betheshyft.com/community/thread/NTAw/hydrate-hydrate-hydrate/",
  },
  {
    id: 499,
    slug: "symptoms-of-thyroid-disorder",
    title: "Symptoms of thyroid disorder",
    url: "https://www.betheshyft.com/community/thread/NDk5/symptoms-of-thyroid-disorder/",
  },
  {
    id: 498,
    slug: "general-tips-to-manage-hypertension",
    title: "General Tips to Manage Hypertension",
    url: "https://www.betheshyft.com/community/thread/NDk4/general-tips-to-manage-hypertension/",
  },
  {
    id: 497,
    slug: "superfood-alert",
    title: "Superfood Alert",
    url: "https://www.betheshyft.com/community/thread/NDk3/superfood-alert/",
  },
  {
    id: 496,
    slug: "diabetes-awareness",
    title: "Diabetes awareness",
    url: "https://www.betheshyft.com/community/thread/NDk2/diabetes-awareness/",
  },
  {
    id: 495,
    slug: "be-kind-to-yourself",
    title: "Be kind to yourself",
    url: "https://www.betheshyft.com/community/thread/NDk1/be-kind-to-yourself/",
  },
  {
    id: 493,
    slug: "diabetes-and-stress",
    title: "Diabetes and Stress",
    url: "https://www.betheshyft.com/community/thread/NDkz/diabetes-and-stress/",
  },
  {
    id: 490,
    slug: "drinks-to-boost-metabolism-in-hypothyroidism",
    title: "Drinks to Boost Metabolism in Hypothyroidism",
    url: "https://www.betheshyft.com/community/thread/NDkw/drinks-to-boost-metabolism-in-hypothyroidism/",
  },
  {
    id: 489,
    slug: "hunger-pangs-at-night",
    title: "Hunger Pangs at Night",
    url: "https://www.betheshyft.com/community/thread/NDg5/hunger-pangs-at-night/",
  },
  {
    id: 485,
    slug: "asanas-for-high-bp",
    title: "Asanas for high BP",
    url: "https://www.betheshyft.com/community/thread/NDg1/asanas-for-high-bp/",
  },
  {
    id: 484,
    slug: "yoga-and-high-bp",
    title: "Yoga and high BP",
    url: "https://www.betheshyft.com/community/thread/NDg0/yoga-and-high-bp/",
  },
  {
    id: 483,
    slug: "golden-rule-of-weight-management",
    title: "Golden Rule of Weight Management",
    url: "https://www.betheshyft.com/community/thread/NDgz/golden-rule-of-weight-management/",
  },
  {
    id: 482,
    slug: "top-6-reasons-for-hormonal-imbalance",
    title: "Top 6 Reasons for Hormonal Imbalance",
    url: "https://www.betheshyft.com/community/thread/NDgy/top-6-reasons-for-hormonal-imbalance/",
  },
  {
    id: 481,
    slug: "pregnancy-hormones-the-tragedy-maker",
    title: "Pregnancy Hormones - the tragedy maker",
    url: "https://www.betheshyft.com/community/thread/NDgx/pregnancy-hormones-the-tragedy-maker/",
  },
  {
    id: 480,
    slug: "pcod-guidelines",
    title: "PCOD Guidelines",
    url: "https://www.betheshyft.com/community/thread/NDgw/pcod-guidelines/",
  },
  {
    id: 478,
    slug: "foods-that-cause-bloating",
    title: "Foods that cause bloating",
    url: "https://www.betheshyft.com/community/thread/NDc4/foods-that-cause-bloating/",
  },
  {
    id: 477,
    slug: "suffering-from-gas",
    title: "Suffering from Gas?",
    url: "https://www.betheshyft.com/community/thread/NDc3/suffering-from-gas/",
  },
  {
    id: 475,
    slug: "what-is-hidden-sugar",
    title: "What is Hidden Sugar?",
    url: "https://www.betheshyft.com/community/thread/NDc1/what-is-hidden-sugar/",
  },
  {
    id: 474,
    slug: "labor-induction",
    title: "Labor Induction",
    url: "https://www.betheshyft.com/community/thread/NDc0/labor-induction/",
  },
  {
    id: 473,
    slug: "veggies-to-avoid-during-hypothyroidism",
    title: "Veggies to Avoid During Hypothyroidism",
    url: "https://www.betheshyft.com/community/thread/NDcz/veggies-to-avoid-during-hypothyroidism/",
  },
  {
    id: 472,
    slug: "importance-of-family-time",
    title: "Importance of family time",
    url: "https://www.betheshyft.com/community/thread/NDcy/importance-of-family-time/",
  },
  {
    id: 447,
    slug: "thinking-how-to-reduce-high-bp",
    title: "Thinking how to reduce High bp 🤔?",
    url: "https://www.betheshyft.com/community/thread/NDQ3/thinking-how-to-reduce-high-bp/",
  },
  {
    id: 445,
    slug: "why-inch-loss-is-better-than-weight-loss",
    title: "Why inch loss is better than weight loss?",
    url: "https://www.betheshyft.com/community/thread/NDQ1/why-inch-loss-is-better-than-weight-loss/",
  },
  {
    id: 436,
    slug: "how-can-i-tighten-my-pelvic-floor-after",
    title: "How can I tighten my pelvic floor after delivery?",
    url: "https://www.betheshyft.com/community/thread/NDM2/how-can-i-tighten-my-pelvic-floor-after/",
  },
  {
    id: 434,
    slug: "how-long-does-it-take-to-lose-postpartum",
    title: "How long does it take to lose  postpartum weight?",
    url: "https://www.betheshyft.com/community/thread/NDM0/how-long-does-it-take-to-lose-postpartum/",
  },
  {
    id: 433,
    slug: "lowers-down-your-bp-with-abdominal-breathing",
    title: "Lowers down your bp with #Abdominal Breathing 🫁",
    url: "https://www.betheshyft.com/community/thread/NDMz/lowers-down-your-bp-with-abdominal-breathing/",
  },
  {
    id: 430,
    slug: "are-squats-safe-to-be-practiced-before-36th",
    title: "Are squats safe to be practiced before 36th week?",
    url: "https://www.betheshyft.com/community/thread/NDMw/are-squats-safe-to-be-practiced-before-36th/",
  },
  {
    id: 429,
    slug: "puppy-pose-uttana-shishosana",
    title: "Puppy Pose / Uttana Shishosana",
    url: "https://www.betheshyft.com/community/thread/NDI5/puppy-pose-uttana-shishosana/",
  },
  {
    id: 428,
    slug: "loving-yourself",
    title: "Loving yourself",
    url: "https://www.betheshyft.com/community/thread/NDI4/loving-yourself/",
  },
  {
    id: 427,
    slug: "set-little-milestones",
    title: "Set little milestones",
    url: "https://www.betheshyft.com/community/thread/NDI3/set-little-milestones/",
  },
  {
    id: 426,
    slug: "regularising-periods",
    title: "Regularising periods",
    url: "https://www.betheshyft.com/community/thread/NDI2/regularising-periods/",
  },
  {
    id: 422,
    slug: "gut-and-emotions",
    title: "Gut and emotions",
    url: "https://www.betheshyft.com/community/thread/NDIy/gut-and-emotions/",
  },
  {
    id: 420,
    slug: "why-prenatal-yoga",
    title: "Why prenatal yoga?",
    url: "https://www.betheshyft.com/community/thread/NDIw/why-prenatal-yoga/",
  },
  {
    id: 411,
    slug: "hydration-in-pregnancy",
    title: "Hydration in pregnancy",
    url: "https://www.betheshyft.com/community/thread/NDEx/hydration-in-pregnancy/",
  },
  {
    id: 410,
    slug: "prenatal-self-care-affirmations",
    title: "Prenatal self care affirmations",
    url: "https://www.betheshyft.com/community/thread/NDEw/prenatal-self-care-affirmations/",
  },
  {
    id: 407,
    slug: "5-awesome-benefits-of-balancing-postures",
    title: "5 awesome benefits of balancing postures",
    url: "https://www.betheshyft.com/community/thread/NDA3/5-awesome-benefits-of-balancing-postures/",
  },
  {
    id: 390,
    slug: "yoga-and-nature",
    title: "Yoga and Nature",
    url: "https://www.betheshyft.com/community/thread/Mzkw/yoga-and-nature/",
  },
  {
    id: 382,
    slug: "sugar-free-date-laddoo-recipe",
    title: "Sugar Free Date Laddoo Recipe",
    url: "https://www.betheshyft.com/community/thread/Mzgy/sugar-free-date-laddoo-recipe/",
  },
  {
    id: 381,
    slug: "gut-health",
    title: "Gut health",
    url: "https://www.betheshyft.com/community/thread/Mzgx/gut-health/",
  },
  {
    id: 366,
    slug: "is-mango-the-forbidden-fruit-for-weight-loss",
    title: "Is mango the forbidden fruit for weight loss?",
    url: "https://www.betheshyft.com/community/thread/MzY2/is-mango-the-forbidden-fruit-for-weight-loss/",
  },
  {
    id: 364,
    slug: "yoga-is-lifestyle",
    title: "Yoga is lifestyle",
    url: "https://www.betheshyft.com/community/thread/MzY0/yoga-is-lifestyle/",
  },
  {
    id: 362,
    slug: "anjaneyasana",
    title: "Anjaneyasana",
    url: "https://www.betheshyft.com/community/thread/MzYy/anjaneyasana/",
  },
  {
    id: 355,
    slug: "develop-a-new-hobby",
    title: "Develop a new hobby",
    url: "https://www.betheshyft.com/community/thread/MzU1/develop-a-new-hobby/",
  },
  {
    id: 354,
    slug: "diet-in-pregnancy",
    title: "Diet in pregnancy....",
    url: "https://www.betheshyft.com/community/thread/MzU0/diet-in-pregnancy/",
  },
  {
    id: 349,
    slug: "back-health",
    title: "Back Health",
    url: "https://www.betheshyft.com/community/thread/MzQ5/back-health/",
  },
  {
    id: 348,
    slug: "starting-with-a-good-warmup",
    title: "Starting with a good warmup",
    url: "https://www.betheshyft.com/community/thread/MzQ4/starting-with-a-good-warmup/",
  },
  {
    id: 334,
    slug: "why-soaked-almonds-are-better-for-health",
    title: "Why Soaked almonds are better for health?",
    url: "https://www.betheshyft.com/community/thread/MzM0/why-soaked-almonds-are-better-for-health/",
  },
  {
    id: 330,
    slug: "health-is-wealth",
    title: "Health is Wealth",
    url: "https://www.betheshyft.com/community/thread/MzMw/health-is-wealth/",
  },
  {
    id: 328,
    slug: "the-secret-to-healthy-eating",
    title: "The Secret to healthy eating !!",
    url: "https://www.betheshyft.com/community/thread/MzI4/the-secret-to-healthy-eating/",
  },
  {
    id: 323,
    slug: "mindful-eating",
    title: "Mindful eating",
    url: "https://www.betheshyft.com/community/thread/MzIz/mindful-eating/",
  },
  {
    id: 315,
    slug: "what-meditation-does-to-your-brain",
    title: "What meditation does to your brain ?",
    url: "https://www.betheshyft.com/community/thread/MzE1/what-meditation-does-to-your-brain/",
  },
  {
    id: 304,
    slug: "palak-paneer-may-not-be-as-healthy-as",
    title: "Palak paneer may not be as healthy as you think",
    url: "https://www.betheshyft.com/community/thread/MzA0/palak-paneer-may-not-be-as-healthy-as/",
  },
  {
    id: 302,
    slug: "put-in-right-strategies-to-manage-high-bp",
    title: "Put in right strategies to manage High BP",
    url: "https://www.betheshyft.com/community/thread/MzAy/put-in-right-strategies-to-manage-high-bp/",
  },
  {
    id: 301,
    slug: "what-can-be-done-for-bloating",
    title: "What can be done for bloating??",
    url: "https://www.betheshyft.com/community/thread/MzAx/what-can-be-done-for-bloating/",
  },
  {
    id: 24,
    slug: "exercises-for-hypothyroidism",
    title: "Exercises for Hypothyroidism",
    url: "https://www.betheshyft.com/community/thread/MjQ/exercises-for-hypothyroidism/",
  },
  {
    id: 23,
    slug: "happy-healthy-pregnancy-tips",
    title: "Happy & Healthy Pregnancy Tips :)",
    url: "https://www.betheshyft.com/community/thread/MjM/happy-healthy-pregnancy-tips/",
  },
  {
    id: 22,
    slug: "10-breathing-techniques-to-help-during-pregnancy-and",
    title: "10 breathing techniques to help during pregnancy and labour",
    url: "https://www.betheshyft.com/community/thread/MjI/10-breathing-techniques-to-help-during-pregnancy-and/",
  },
  {
    id: 21,
    slug: "self-care-routine-post-delivery",
    title: "Self care routine post delivery",
    url: "https://www.betheshyft.com/community/thread/MjE/self-care-routine-post-delivery/",
  },
  {
    id: 20,
    slug: "common-symptoms-of-pcos",
    title: "Common symptoms of PCOS",
    url: "https://www.betheshyft.com/community/thread/MjA/common-symptoms-of-pcos/",
  },
  {
    id: 19,
    slug: "what-are-some-of-the-risk-factors-associated",
    title: "What are some of the risk factors associated with PCOS?",
    url: "https://www.betheshyft.com/community/thread/MTk/what-are-some-of-the-risk-factors-associated/",
  },
  {
    id: 18,
    slug: "if-you-have-pcos-what-medical-problems-are",
    title: "If you have PCOS what medical problems are you at risk for?",
    url: "https://www.betheshyft.com/community/thread/MTg/if-you-have-pcos-what-medical-problems-are/",
  },
  {
    id: 16,
    slug: "benefits-of-breathing-practices",
    title: "Benefits of breathing practices",
    url: "https://www.betheshyft.com/community/thread/MTY/benefits-of-breathing-practices/",
  },
  {
    id: 15,
    slug: "benefits-of-meditation",
    title: "Benefits of Meditation",
    url: "https://www.betheshyft.com/community/thread/MTU/benefits-of-meditation/",
  },
  {
    id: 14,
    slug: "sleep-position-and-posture-for-overall-wellness",
    title: "Sleep position and posture for overall wellness",
    url: "https://www.betheshyft.com/community/thread/MTQ/sleep-position-and-posture-for-overall-wellness/",
  },
  {
    id: 13,
    slug: "what-is-the-best-way-to-improve-my",
    title: "What is the best way to improve my mental wellbeing?",
    url: "https://www.betheshyft.com/community/thread/MTM/what-is-the-best-way-to-improve-my/",
  },
  {
    id: 12,
    slug: "unsure-if-exercising-is-safe-with-high-blood",
    title: "Unsure if exercising is safe with high blood pressure/",
    url: "https://www.betheshyft.com/community/thread/MTI/unsure-if-exercising-is-safe-with-high-blood/",
  },
  {
    id: 10,
    slug: "managing-high-bp",
    title: "Managing High BP",
    url: "https://www.betheshyft.com/community/thread/MTA/managing-high-bp/",
  },
  {
    id: 8,
    slug: "good-health-for-the-gut",
    title: "Good health for the Gut!",
    url: "https://www.betheshyft.com/community/thread/OA/good-health-for-the-gut/",
  },
  {
    id: 7,
    slug: "the-practices-that-help-with-motility-in-the",
    title: "The practices that help with Motility in the human body",
    url: "https://www.betheshyft.com/community/thread/Nw/the-practices-that-help-with-motility-in-the/",
  },
  {
    id: 5,
    slug: "are-potatoes-bad-for-weight-loss",
    title: "Are potatoes bad for weight loss?",
    url: "https://www.betheshyft.com/community/thread/NQ/are-potatoes-bad-for-weight-loss/",
  },
  {
    id: 4,
    slug: "do-you-need-to-count-calories-in-my",
    title: "Do you need to count calories in my meals?",
    url: "https://www.betheshyft.com/community/thread/NA/do-you-need-to-count-calories-in-my/",
  },
  {
    id: 2,
    slug: "don-t-skip-your-savasana",
    title: "Don't skip your Savasana!",
    url: "https://www.betheshyft.com/community/thread/Mg/don-t-skip-your-savasana/",
  },
  {
    id: 1,
    slug: "suggest-postures-to-improve-vision",
    title: "Suggest postures to improve vision",
    url: "https://www.betheshyft.com/community/thread/MQ/suggest-postures-to-improve-vision/",
  },
];

export default data;
